var _assertThisInitialized = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _slicedToArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _get = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _wrapNativeSuper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

var _taggedTemplateLiteral = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _toConsumableArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _defineProperty = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _objectSpread = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29, _templateObject30, _templateObject31, _templateObject32, _templateObject33, _templateObject34, _templateObject35, _templateObject36, _templateObject37, _templateObject38, _templateObject39, _templateObject40, _templateObject41, _templateObject42, _templateObject43, _templateObject44, _templateObject45, _templateObject46, _templateObject47, _templateObject48, _templateObject49, _templateObject50, _templateObject51, _templateObject52, _templateObject53, _templateObject54, _templateObject55, _templateObject56, _templateObject57, _templateObject58, _templateObject59, _templateObject60, _templateObject61, _templateObject62, _templateObject63, _templateObject64, _templateObject65, _templateObject66, _templateObject67, _templateObject68, _templateObject69, _templateObject70, _templateObject71, _templateObject72, _templateObject73, _templateObject74, _templateObject75, _templateObject76, _templateObject77, _templateObject78, _templateObject79, _templateObject80, _templateObject81, _templateObject82, _templateObject83, _templateObject84, _templateObject85, _templateObject86, _templateObject87, _templateObject88, _templateObject89, _templateObject90, _templateObject91, _templateObject92, _templateObject93, _templateObject94, _templateObject95, _templateObject96, _templateObject97, _templateObject98, _templateObject99, _templateObject100, _templateObject101, _templateObject102, _templateObject103, _templateObject104, _templateObject105, _templateObject106, _templateObject107, _templateObject108, _templateObject109, _templateObject110, _templateObject111, _templateObject112, _templateObject113, _templateObject114, _templateObject115, _templateObject116, _templateObject117, _templateObject118, _templateObject119, _templateObject120, _templateObject121, _templateObject122, _templateObject123, _templateObject124, _templateObject125, _templateObject126, _templateObject127, _templateObject128, _templateObject129, _templateObject130, _templateObject131, _templateObject132, _templateObject133, _templateObject134, _templateObject135, _templateObject136, _templateObject137, _templateObject138, _templateObject139, _templateObject140, _templateObject141, _templateObject142, _templateObject143, _templateObject144, _templateObject145, _templateObject146, _templateObject147, _templateObject148, _templateObject149, _templateObject150, _templateObject151, _templateObject152, _templateObject153, _templateObject154, _templateObject155, _templateObject156, _templateObject157, _templateObject158, _templateObject159, _templateObject160, _templateObject161, _templateObject162, _templateObject163, _templateObject164, _templateObject165, _templateObject166, _templateObject167, _templateObject168, _templateObject169, _templateObject170, _templateObject171, _templateObject172, _templateObject173, _templateObject174, _templateObject175, _templateObject176, _templateObject177, _templateObject178, _templateObject179, _templateObject180, _templateObject181, _templateObject182, _templateObject183, _templateObject184, _templateObject185, _templateObject186, _templateObject187, _templateObject188, _templateObject189, _templateObject190, _templateObject191, _templateObject192, _templateObject193, _templateObject194, _templateObject195, _templateObject196, _templateObject197, _templateObject198, _templateObject199, _templateObject200, _templateObject201, _templateObject202, _templateObject203, _templateObject204, _templateObject205, _templateObject206, _templateObject207, _templateObject208, _templateObject209, _templateObject210, _templateObject211, _templateObject212, _templateObject213, _templateObject214, _templateObject215, _templateObject216, _templateObject217, _templateObject218, _templateObject219, _templateObject220, _templateObject221, _templateObject222, _templateObject223, _templateObject224, _templateObject225, _templateObject226, _templateObject227, _templateObject228, _templateObject229, _templateObject230, _templateObject231, _templateObject232, _templateObject233, _templateObject234, _templateObject235, _templateObject236, _templateObject237, _templateObject238, _templateObject239, _templateObject240, _templateObject241, _templateObject242, _templateObject243, _templateObject244, _templateObject245, _templateObject246, _templateObject247, _templateObject248, _templateObject249, _templateObject250, _templateObject251, _templateObject252, _templateObject253, _templateObject254, _templateObject255, _templateObject256, _templateObject257, _templateObject258, _templateObject259, _templateObject260, _templateObject261, _templateObject262, _templateObject263, _templateObject264, _templateObject265, _templateObject266, _templateObject267, _templateObject268, _templateObject269, _templateObject270, _templateObject271, _templateObject272, _templateObject273, _templateObject274, _templateObject275, _templateObject276, _templateObject277, _templateObject278;

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e27) { throw _e27; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e28) { didErr = true; err = _e28; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(exports) : "function" == typeof define && define.amd ? define("decentraland-transactions", ["exports"], t) : t((e = "undefined" != typeof globalThis ? globalThis : e || self)["decentraland-transactions"] = {});
}(this, function (e) {
  "use strict";

  var _Oe, _ke, _je, _De, _Ue, _Ve, _Fe, _Be, _He, _Le, _Ke, _ze, _qe, _Ge;

  var t;
  e.ContractName = void 0, (t = e.ContractName || (e.ContractName = {})).Bid = "Bid", t.CollectionFactory = "CollectionFactory", t.CollectionManager = "CollectionManager", t.CollectionStore = "CollectionStore", t.Committee = "Committee", t.ERC20 = "ERC20", t.ERC721 = "ERC721", t.ERC721CollectionV2 = "ERC721CollectionV2", t.Forwarder = "Forwarder", t.MANAToken = "MANAToken", t.Marketplace = "Marketplace", t.Rarities = "Rarities";
  var n = [{
    name: "name",
    type: "string"
  }, {
    name: "version",
    type: "string"
  }, {
    name: "verifyingContract",
    type: "address"
  }, {
    name: "salt",
    type: "bytes32"
  }],
      a = [{
    name: "nonce",
    type: "uint256"
  }, {
    name: "from",
    type: "address"
  }, {
    name: "functionSignature",
    type: "bytes"
  }];

  function r(e) {
    return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
  }

  function s(e, t) {
    return e(t = {
      exports: {}
    }, t.exports), t.exports;
  }

  function i(e) {
    return e && e.default || e;
  }

  var o = s(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getRules = t.isJSONType = void 0;
    var n = new Set(["string", "number", "integer", "boolean", "null", "object", "array"]);
    t.isJSONType = function (e) {
      return "string" == typeof e && n.has(e);
    }, t.getRules = function () {
      var e = {
        number: {
          type: "number",
          rules: []
        },
        string: {
          type: "string",
          rules: []
        },
        array: {
          type: "array",
          rules: []
        },
        object: {
          type: "object",
          rules: []
        }
      };
      return {
        types: _objectSpread({}, e, {
          integer: !0,
          boolean: !0,
          null: !0
        }),
        rules: [{
          rules: []
        }, e.number, e.string, e.array, e.object],
        post: {
          rules: []
        },
        all: {},
        keywords: {}
      };
    };
  });
  r(o), o.getRules, o.isJSONType;
  var p = s(function (e, t) {
    function n(e, t) {
      return t.rules.some(function (t) {
        return a(e, t);
      });
    }

    function a(e, t) {
      var n;
      return void 0 !== e[t.keyword] || (null === (n = t.definition.implements) || void 0 === n ? void 0 : n.some(function (t) {
        return void 0 !== e[t];
      }));
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.shouldUseRule = t.shouldUseGroup = t.schemaHasRulesForType = void 0, t.schemaHasRulesForType = function (_ref, a) {
      var e = _ref.schema,
          t = _ref.self;
      var r = t.RULES.types[a];
      return r && !0 !== r && n(e, r);
    }, t.shouldUseGroup = n, t.shouldUseRule = a;
  });
  r(p), p.shouldUseRule, p.shouldUseGroup, p.schemaHasRulesForType;
  var u = s(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getProperty = t.safeStringify = t.stringify = t.strConcat = t.addCodeArg = t.str = t._ = t.nil = t._Code = t.Name = t.IDENTIFIER = t._CodeOrName = void 0;

    var n = function n() {
      _classCallCheck(this, n);
    };

    t._CodeOrName = n, t.IDENTIFIER = /^[a-z$_][a-z$_0-9]*$/i;

    var a = /*#__PURE__*/function (_n) {
      _inherits(a, _n);

      function a(e) {
        var _this;

        _classCallCheck(this, a);

        if (_this = _possibleConstructorReturn(this, _getPrototypeOf(a).call(this)), !t.IDENTIFIER.test(e)) throw new Error("CodeGen: name must be a valid identifier");
        _this.str = e;
        return _possibleConstructorReturn(_this);
      }

      _createClass(a, [{
        key: "toString",
        value: function toString() {
          return this.str;
        }
      }, {
        key: "emptyStr",
        value: function emptyStr() {
          return !1;
        }
      }, {
        key: "names",
        get: function get() {
          return _defineProperty({}, this.str, 1);
        }
      }]);

      return a;
    }(n);

    t.Name = a;

    var r = /*#__PURE__*/function (_n2) {
      _inherits(r, _n2);

      function r(e) {
        var _this2;

        _classCallCheck(this, r);

        _this2 = _possibleConstructorReturn(this, _getPrototypeOf(r).call(this)), _this2._items = "string" == typeof e ? [e] : e;
        return _this2;
      }

      _createClass(r, [{
        key: "toString",
        value: function toString() {
          return this.str;
        }
      }, {
        key: "emptyStr",
        value: function emptyStr() {
          if (this._items.length > 1) return !1;
          var e = this._items[0];
          return "" === e || '""' === e;
        }
      }, {
        key: "str",
        get: function get() {
          var e;
          return null !== (e = this._str) && void 0 !== e ? e : this._str = this._items.reduce(function (e, t) {
            return "".concat(e).concat(t);
          }, "");
        }
      }, {
        key: "names",
        get: function get() {
          var e;
          return null !== (e = this._names) && void 0 !== e ? e : this._names = this._items.reduce(function (e, t) {
            return t instanceof a && (e[t.str] = (e[t.str] || 0) + 1), e;
          }, {});
        }
      }]);

      return r;
    }(n);

    function s(e) {
      var n = [e[0]];
      var a = 0;

      for (var _len = arguments.length, t = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        t[_key - 1] = arguments[_key];
      }

      for (; a < t.length;) {
        p(n, t[a]), n.push(e[++a]);
      }

      return new r(n);
    }

    t._Code = r, t.nil = new r(""), t._ = s;
    var i = new r("+");

    function o(e) {
      var n = [d(e[0])];
      var a = 0;

      for (var _len2 = arguments.length, t = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        t[_key2 - 1] = arguments[_key2];
      }

      for (; a < t.length;) {
        n.push(i), p(n, t[a]), n.push(i, d(e[++a]));
      }

      return function (e) {
        var t = 1;

        for (; t < e.length - 1;) {
          if (e[t] === i) {
            var _n3 = u(e[t - 1], e[t + 1]);

            if (void 0 !== _n3) {
              e.splice(t - 1, 3, _n3);
              continue;
            }

            e[t++] = "+";
          }

          t++;
        }
      }(n), new r(n);
    }

    function p(e, t) {
      var n;
      t instanceof r ? e.push.apply(e, _toConsumableArray(t._items)) : t instanceof a ? e.push(t) : e.push("number" == typeof (n = t) || "boolean" == typeof n || null === n ? n : d(Array.isArray(n) ? n.join(",") : n));
    }

    function u(e, t) {
      if ('""' === t) return e;
      if ('""' === e) return t;

      if ("string" == typeof e) {
        if (t instanceof a || '"' !== e[e.length - 1]) return;
        return "string" != typeof t ? "".concat(e.slice(0, -1)).concat(t, "\"") : '"' === t[0] ? e.slice(0, -1) + t.slice(1) : void 0;
      }

      return "string" != typeof t || '"' !== t[0] || e instanceof a ? void 0 : "\"".concat(e).concat(t.slice(1));
    }

    function d(e) {
      return JSON.stringify(e).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029");
    }

    t.str = o, t.addCodeArg = p, t.strConcat = function (e, t) {
      return t.emptyStr() ? e : e.emptyStr() ? t : o(_templateObject || (_templateObject = _taggedTemplateLiteral(["", "", ""])), e, t);
    }, t.stringify = function (e) {
      return new r(d(e));
    }, t.safeStringify = d, t.getProperty = function (e) {
      return "string" == typeof e && t.IDENTIFIER.test(e) ? new r(".".concat(e)) : s(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["[", "]"])), e);
    };
  });
  r(u), u.getProperty, u.safeStringify, u.stringify, u.strConcat, u.addCodeArg, u.str, u._, u.nil, u._Code, u.Name, u.IDENTIFIER, u._CodeOrName;
  var d = s(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ValueScope = t.ValueScopeName = t.Scope = t.varKinds = t.UsedValueState = void 0;

    var n = /*#__PURE__*/function (_Error) {
      _inherits(n, _Error);

      function n(e) {
        var _this3;

        _classCallCheck(this, n);

        _this3 = _possibleConstructorReturn(this, _getPrototypeOf(n).call(this, "CodeGen: \"code\" for ".concat(e, " not defined"))), _this3.value = e.value;
        return _this3;
      }

      return n;
    }(_wrapNativeSuper(Error));

    var a;
    !function (e) {
      e[e.Started = 0] = "Started", e[e.Completed = 1] = "Completed";
    }(a = t.UsedValueState || (t.UsedValueState = {})), t.varKinds = {
      const: new u.Name("const"),
      let: new u.Name("let"),
      var: new u.Name("var")
    };

    var r = /*#__PURE__*/function () {
      function r() {
        var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            e = _ref3.prefixes,
            t = _ref3.parent;

        _classCallCheck(this, r);

        this._names = {}, this._prefixes = e, this._parent = t;
      }

      _createClass(r, [{
        key: "toName",
        value: function toName(e) {
          return e instanceof u.Name ? e : this.name(e);
        }
      }, {
        key: "name",
        value: function name(e) {
          return new u.Name(this._newName(e));
        }
      }, {
        key: "_newName",
        value: function _newName(e) {
          return "".concat(e).concat((this._names[e] || this._nameGroup(e)).index++);
        }
      }, {
        key: "_nameGroup",
        value: function _nameGroup(e) {
          var t, n;
          if ((null === (n = null === (t = this._parent) || void 0 === t ? void 0 : t._prefixes) || void 0 === n ? void 0 : n.has(e)) || this._prefixes && !this._prefixes.has(e)) throw new Error("CodeGen: prefix \"".concat(e, "\" is not allowed in this scope"));
          return this._names[e] = {
            prefix: e,
            index: 0
          };
        }
      }]);

      return r;
    }();

    t.Scope = r;

    var s = /*#__PURE__*/function (_u$Name) {
      _inherits(s, _u$Name);

      function s(e, t) {
        var _this4;

        _classCallCheck(this, s);

        _this4 = _possibleConstructorReturn(this, _getPrototypeOf(s).call(this, t)), _this4.prefix = e;
        return _this4;
      }

      _createClass(s, [{
        key: "setValue",
        value: function setValue(e, _ref4) {
          var t = _ref4.property,
              n = _ref4.itemIndex;
          this.value = e, this.scopePath = u._(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral([".", "[", "]"])), new u.Name(t), n);
        }
      }]);

      return s;
    }(u.Name);

    t.ValueScopeName = s;

    var i = u._(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n"], ["\\n"])));

    t.ValueScope = /*#__PURE__*/function (_r) {
      _inherits(_class, _r);

      function _class(e) {
        var _this5;

        _classCallCheck(this, _class);

        _this5 = _possibleConstructorReturn(this, _getPrototypeOf(_class).call(this, e)), _this5._values = {}, _this5._scope = e.scope, _this5.opts = _objectSpread({}, e, {
          _n: e.lines ? i : u.nil
        });
        return _this5;
      }

      _createClass(_class, [{
        key: "get",
        value: function get() {
          return this._scope;
        }
      }, {
        key: "name",
        value: function name(e) {
          return new s(e, this._newName(e));
        }
      }, {
        key: "value",
        value: function value(e, t) {
          var n;
          if (void 0 === t.ref) throw new Error("CodeGen: ref must be passed in value");
          var a = this.toName(e),
              r = a.prefix,
              s = null !== (n = t.key) && void 0 !== n ? n : t.ref;
          var i = this._values[r];

          if (i) {
            var _e2 = i.get(s);

            if (_e2) return _e2;
          } else i = this._values[r] = new Map();

          i.set(s, a);
          var o = this._scope[r] || (this._scope[r] = []),
              p = o.length;
          return o[p] = t.ref, a.setValue(t, {
            property: r,
            itemIndex: p
          }), a;
        }
      }, {
        key: "getValue",
        value: function getValue(e, t) {
          var n = this._values[e];
          if (n) return n.get(t);
        }
      }, {
        key: "scopeRefs",
        value: function scopeRefs(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._values;
          return this._reduceValues(t, function (t) {
            if (void 0 === t.scopePath) throw new Error("CodeGen: name \"".concat(t, "\" has no value"));
            return u._(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["", "", ""])), e, t.scopePath);
          });
        }
      }, {
        key: "scopeCode",
        value: function scopeCode() {
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._values;
          var t = arguments.length > 1 ? arguments[1] : undefined;
          var n = arguments.length > 2 ? arguments[2] : undefined;
          return this._reduceValues(e, function (e) {
            if (void 0 === e.value) throw new Error("CodeGen: name \"".concat(e, "\" has no value"));
            return e.value.code;
          }, t, n);
        }
      }, {
        key: "_reduceValues",
        value: function _reduceValues(e, r) {
          var _this6 = this;

          var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          var i = arguments.length > 3 ? arguments[3] : undefined;
          var o = u.nil;

          var _loop = function _loop(_p) {
            var d = e[_p];
            if (!d) return "continue";
            var l = s[_p] = s[_p] || new Map();
            d.forEach(function (e) {
              if (l.has(e)) return;
              l.set(e, a.Started);
              var s = r(e);

              if (s) {
                var _n4 = _this6.opts.es5 ? t.varKinds.var : t.varKinds.const;

                o = u._(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["", "", " ", " = ", ";", ""])), o, _n4, e, s, _this6.opts._n);
              } else {
                if (!(s = null == i ? void 0 : i(e))) throw new n(e);
                o = u._(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["", "", "", ""])), o, s, _this6.opts._n);
              }

              l.set(e, a.Completed);
            });
          };

          for (var _p in e) {
            var _ret = _loop(_p);

            if (_ret === "continue") continue;
          }

          return o;
        }
      }]);

      return _class;
    }(r);
  });
  r(d), d.ValueScope, d.ValueScopeName, d.Scope, d.varKinds, d.UsedValueState;
  var l = s(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.or = t.and = t.not = t.CodeGen = t.operators = t.varKinds = t.ValueScopeName = t.ValueScope = t.Scope = t.Name = t.stringify = t.getProperty = t.nil = t.strConcat = t.str = t._ = void 0;
    var n = u;
    Object.defineProperty(t, "_", {
      enumerable: !0,
      get: function get() {
        return n._;
      }
    }), Object.defineProperty(t, "str", {
      enumerable: !0,
      get: function get() {
        return n.str;
      }
    }), Object.defineProperty(t, "strConcat", {
      enumerable: !0,
      get: function get() {
        return n.strConcat;
      }
    }), Object.defineProperty(t, "nil", {
      enumerable: !0,
      get: function get() {
        return n.nil;
      }
    }), Object.defineProperty(t, "getProperty", {
      enumerable: !0,
      get: function get() {
        return n.getProperty;
      }
    }), Object.defineProperty(t, "stringify", {
      enumerable: !0,
      get: function get() {
        return n.stringify;
      }
    }), Object.defineProperty(t, "Name", {
      enumerable: !0,
      get: function get() {
        return n.Name;
      }
    });
    var a = d;
    Object.defineProperty(t, "Scope", {
      enumerable: !0,
      get: function get() {
        return a.Scope;
      }
    }), Object.defineProperty(t, "ValueScope", {
      enumerable: !0,
      get: function get() {
        return a.ValueScope;
      }
    }), Object.defineProperty(t, "ValueScopeName", {
      enumerable: !0,
      get: function get() {
        return a.ValueScopeName;
      }
    }), Object.defineProperty(t, "varKinds", {
      enumerable: !0,
      get: function get() {
        return a.varKinds;
      }
    }), t.operators = {
      GT: new u._Code(">"),
      GTE: new u._Code(">="),
      LT: new u._Code("<"),
      LTE: new u._Code("<="),
      EQ: new u._Code("==="),
      NEQ: new u._Code("!=="),
      NOT: new u._Code("!"),
      OR: new u._Code("||"),
      AND: new u._Code("&&"),
      ADD: new u._Code("+")
    };

    var r = /*#__PURE__*/function () {
      function r() {
        _classCallCheck(this, r);
      }

      _createClass(r, [{
        key: "optimizeNodes",
        value: function optimizeNodes() {
          return this;
        }
      }, {
        key: "optimizeNames",
        value: function optimizeNames(e, t) {
          return this;
        }
      }]);

      return r;
    }();

    var s = /*#__PURE__*/function (_r2) {
      _inherits(s, _r2);

      function s(e, t, n) {
        var _this7;

        _classCallCheck(this, s);

        _this7 = _possibleConstructorReturn(this, _getPrototypeOf(s).call(this)), _this7.varKind = e, _this7.name = t, _this7.rhs = n;
        return _this7;
      }

      _createClass(s, [{
        key: "render",
        value: function render(_ref5) {
          var e = _ref5.es5,
              t = _ref5._n;
          var n = e ? d.varKinds.var : this.varKind,
              a = void 0 === this.rhs ? "" : " = ".concat(this.rhs);
          return "".concat(n, " ").concat(this.name).concat(a, ";") + t;
        }
      }, {
        key: "optimizeNames",
        value: function optimizeNames(e, t) {
          if (e[this.name.str]) return this.rhs && (this.rhs = A(this.rhs, e, t)), this;
        }
      }, {
        key: "names",
        get: function get() {
          return this.rhs instanceof u._CodeOrName ? this.rhs.names : {};
        }
      }]);

      return s;
    }(r);

    var i = /*#__PURE__*/function (_r3) {
      _inherits(i, _r3);

      function i(e, t, n) {
        var _this8;

        _classCallCheck(this, i);

        _this8 = _possibleConstructorReturn(this, _getPrototypeOf(i).call(this)), _this8.lhs = e, _this8.rhs = t, _this8.sideEffects = n;
        return _this8;
      }

      _createClass(i, [{
        key: "render",
        value: function render(_ref6) {
          var e = _ref6._n;
          return "".concat(this.lhs, " = ").concat(this.rhs, ";") + e;
        }
      }, {
        key: "optimizeNames",
        value: function optimizeNames(e, t) {
          if (!(this.lhs instanceof u.Name) || e[this.lhs.str] || this.sideEffects) return this.rhs = A(this.rhs, e, t), this;
        }
      }, {
        key: "names",
        get: function get() {
          return S(this.lhs instanceof u.Name ? {} : _objectSpread({}, this.lhs.names), this.rhs);
        }
      }]);

      return i;
    }(r);

    var o = /*#__PURE__*/function (_i) {
      _inherits(o, _i);

      function o(e, t, n, a) {
        var _this9;

        _classCallCheck(this, o);

        _this9 = _possibleConstructorReturn(this, _getPrototypeOf(o).call(this, e, n, a)), _this9.op = t;
        return _this9;
      }

      _createClass(o, [{
        key: "render",
        value: function render(_ref7) {
          var e = _ref7._n;
          return "".concat(this.lhs, " ").concat(this.op, "= ").concat(this.rhs, ";") + e;
        }
      }]);

      return o;
    }(i);

    var p = /*#__PURE__*/function (_r4) {
      _inherits(p, _r4);

      function p(e) {
        var _this10;

        _classCallCheck(this, p);

        _this10 = _possibleConstructorReturn(this, _getPrototypeOf(p).call(this)), _this10.label = e, _this10.names = {};
        return _this10;
      }

      _createClass(p, [{
        key: "render",
        value: function render(_ref8) {
          var e = _ref8._n;
          return "".concat(this.label, ":") + e;
        }
      }]);

      return p;
    }(r);

    var l = /*#__PURE__*/function (_r5) {
      _inherits(l, _r5);

      function l(e) {
        var _this11;

        _classCallCheck(this, l);

        _this11 = _possibleConstructorReturn(this, _getPrototypeOf(l).call(this)), _this11.label = e, _this11.names = {};
        return _this11;
      }

      _createClass(l, [{
        key: "render",
        value: function render(_ref9) {
          var e = _ref9._n;
          return "break".concat(this.label ? " ".concat(this.label) : "", ";") + e;
        }
      }]);

      return l;
    }(r);

    var c = /*#__PURE__*/function (_r6) {
      _inherits(c, _r6);

      function c(e) {
        var _this12;

        _classCallCheck(this, c);

        _this12 = _possibleConstructorReturn(this, _getPrototypeOf(c).call(this)), _this12.error = e;
        return _this12;
      }

      _createClass(c, [{
        key: "render",
        value: function render(_ref10) {
          var e = _ref10._n;
          return "throw ".concat(this.error, ";") + e;
        }
      }, {
        key: "names",
        get: function get() {
          return this.error.names;
        }
      }]);

      return c;
    }(r);

    var y = /*#__PURE__*/function (_r7) {
      _inherits(y, _r7);

      function y(e) {
        var _this13;

        _classCallCheck(this, y);

        _this13 = _possibleConstructorReturn(this, _getPrototypeOf(y).call(this)), _this13.code = e;
        return _this13;
      }

      _createClass(y, [{
        key: "render",
        value: function render(_ref11) {
          var e = _ref11._n;
          return "".concat(this.code, ";") + e;
        }
      }, {
        key: "optimizeNodes",
        value: function optimizeNodes() {
          return "".concat(this.code) ? this : void 0;
        }
      }, {
        key: "optimizeNames",
        value: function optimizeNames(e, t) {
          return this.code = A(this.code, e, t), this;
        }
      }, {
        key: "names",
        get: function get() {
          return this.code instanceof u._CodeOrName ? this.code.names : {};
        }
      }]);

      return y;
    }(r);

    var m = /*#__PURE__*/function (_r8) {
      _inherits(m, _r8);

      function m() {
        var _this14;

        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        _classCallCheck(this, m);

        _this14 = _possibleConstructorReturn(this, _getPrototypeOf(m).call(this)), _this14.nodes = e;
        return _this14;
      }

      _createClass(m, [{
        key: "render",
        value: function render(e) {
          return this.nodes.reduce(function (t, n) {
            return t + n.render(e);
          }, "");
        }
      }, {
        key: "optimizeNodes",
        value: function optimizeNodes() {
          var e = this.nodes;
          var t = e.length;

          for (; t--;) {
            var _n5 = e[t].optimizeNodes();

            Array.isArray(_n5) ? e.splice.apply(e, [t, 1].concat(_toConsumableArray(_n5))) : _n5 ? e[t] = _n5 : e.splice(t, 1);
          }

          return e.length > 0 ? this : void 0;
        }
      }, {
        key: "optimizeNames",
        value: function optimizeNames(e, t) {
          var n = this.nodes;
          var a = n.length;

          for (; a--;) {
            var _r9 = n[a];
            _r9.optimizeNames(e, t) || (x(e, _r9.names), n.splice(a, 1));
          }

          return n.length > 0 ? this : void 0;
        }
      }, {
        key: "names",
        get: function get() {
          return this.nodes.reduce(function (e, t) {
            return N(e, t.names);
          }, {});
        }
      }]);

      return m;
    }(r);

    var f = /*#__PURE__*/function (_m) {
      _inherits(f, _m);

      function f() {
        _classCallCheck(this, f);

        return _possibleConstructorReturn(this, _getPrototypeOf(f).apply(this, arguments));
      }

      _createClass(f, [{
        key: "render",
        value: function render(e) {
          return "{" + e._n + _get(_getPrototypeOf(f.prototype), "render", this).call(this, e) + "}" + e._n;
        }
      }]);

      return f;
    }(m);

    var h = /*#__PURE__*/function (_m2) {
      _inherits(h, _m2);

      function h() {
        _classCallCheck(this, h);

        return _possibleConstructorReturn(this, _getPrototypeOf(h).apply(this, arguments));
      }

      return h;
    }(m);

    var b = /*#__PURE__*/function (_f) {
      _inherits(b, _f);

      function b() {
        _classCallCheck(this, b);

        return _possibleConstructorReturn(this, _getPrototypeOf(b).apply(this, arguments));
      }

      return b;
    }(f);

    b.kind = "else";

    var v = /*#__PURE__*/function (_f2) {
      _inherits(v, _f2);

      function v(e, t) {
        var _this15;

        _classCallCheck(this, v);

        _this15 = _possibleConstructorReturn(this, _getPrototypeOf(v).call(this, t)), _this15.condition = e;
        return _this15;
      }

      _createClass(v, [{
        key: "render",
        value: function render(e) {
          var t = "if(".concat(this.condition, ")") + _get(_getPrototypeOf(v.prototype), "render", this).call(this, e);

          return this.else && (t += "else " + this.else.render(e)), t;
        }
      }, {
        key: "optimizeNodes",
        value: function optimizeNodes() {
          _get(_getPrototypeOf(v.prototype), "optimizeNodes", this).call(this);

          var e = this.condition;
          if (!0 === e) return this.nodes;
          var t = this.else;

          if (t) {
            var _e3 = t.optimizeNodes();

            t = this.else = Array.isArray(_e3) ? new b(_e3) : _e3;
          }

          return t ? !1 === e ? t instanceof v ? t : t.nodes : this.nodes.length ? this : new v(P(e), t instanceof v ? [t] : t.nodes) : !1 !== e && this.nodes.length ? this : void 0;
        }
      }, {
        key: "optimizeNames",
        value: function optimizeNames(e, t) {
          var n;
          if (this.else = null === (n = this.else) || void 0 === n ? void 0 : n.optimizeNames(e, t), _get(_getPrototypeOf(v.prototype), "optimizeNames", this).call(this, e, t) || this.else) return this.condition = A(this.condition, e, t), this;
        }
      }, {
        key: "names",
        get: function get() {
          var e = _get(_getPrototypeOf(v.prototype), "names", this);

          return S(e, this.condition), this.else && N(e, this.else.names), e;
        }
      }]);

      return v;
    }(f);

    v.kind = "if";

    var g = /*#__PURE__*/function (_f3) {
      _inherits(g, _f3);

      function g() {
        _classCallCheck(this, g);

        return _possibleConstructorReturn(this, _getPrototypeOf(g).apply(this, arguments));
      }

      return g;
    }(f);

    g.kind = "for";

    var _ = /*#__PURE__*/function (_g) {
      _inherits(_, _g);

      function _(e) {
        var _this16;

        _classCallCheck(this, _);

        _this16 = _possibleConstructorReturn(this, _getPrototypeOf(_).call(this)), _this16.iteration = e;
        return _this16;
      }

      _createClass(_, [{
        key: "render",
        value: function render(e) {
          return "for(".concat(this.iteration, ")") + _get(_getPrototypeOf(_.prototype), "render", this).call(this, e);
        }
      }, {
        key: "optimizeNames",
        value: function optimizeNames(e, t) {
          if (_get(_getPrototypeOf(_.prototype), "optimizeNames", this).call(this, e, t)) return this.iteration = A(this.iteration, e, t), this;
        }
      }, {
        key: "names",
        get: function get() {
          return N(_get(_getPrototypeOf(_.prototype), "names", this), this.iteration.names);
        }
      }]);

      return _;
    }(g);

    var T = /*#__PURE__*/function (_g2) {
      _inherits(T, _g2);

      function T(e, t, n, a) {
        var _this17;

        _classCallCheck(this, T);

        _this17 = _possibleConstructorReturn(this, _getPrototypeOf(T).call(this)), _this17.varKind = e, _this17.name = t, _this17.from = n, _this17.to = a;
        return _this17;
      }

      _createClass(T, [{
        key: "render",
        value: function render(e) {
          var t = e.es5 ? d.varKinds.var : this.varKind,
              n = this.name,
              a = this.from,
              r = this.to;
          return "for(".concat(t, " ").concat(n, "=").concat(a, "; ").concat(n, "<").concat(r, "; ").concat(n, "++)") + _get(_getPrototypeOf(T.prototype), "render", this).call(this, e);
        }
      }, {
        key: "names",
        get: function get() {
          var e = S(_get(_getPrototypeOf(T.prototype), "names", this), this.from);
          return S(e, this.to);
        }
      }]);

      return T;
    }(g);

    var w = /*#__PURE__*/function (_g3) {
      _inherits(w, _g3);

      function w(e, t, n, a) {
        var _this18;

        _classCallCheck(this, w);

        _this18 = _possibleConstructorReturn(this, _getPrototypeOf(w).call(this)), _this18.loop = e, _this18.varKind = t, _this18.name = n, _this18.iterable = a;
        return _this18;
      }

      _createClass(w, [{
        key: "render",
        value: function render(e) {
          return "for(".concat(this.varKind, " ").concat(this.name, " ").concat(this.loop, " ").concat(this.iterable, ")") + _get(_getPrototypeOf(w.prototype), "render", this).call(this, e);
        }
      }, {
        key: "optimizeNames",
        value: function optimizeNames(e, t) {
          if (_get(_getPrototypeOf(w.prototype), "optimizeNames", this).call(this, e, t)) return this.iterable = A(this.iterable, e, t), this;
        }
      }, {
        key: "names",
        get: function get() {
          return N(_get(_getPrototypeOf(w.prototype), "names", this), this.iterable.names);
        }
      }]);

      return w;
    }(g);

    var E = /*#__PURE__*/function (_f4) {
      _inherits(E, _f4);

      function E(e, t, n) {
        var _this19;

        _classCallCheck(this, E);

        _this19 = _possibleConstructorReturn(this, _getPrototypeOf(E).call(this)), _this19.name = e, _this19.args = t, _this19.async = n;
        return _this19;
      }

      _createClass(E, [{
        key: "render",
        value: function render(e) {
          return "".concat(this.async ? "async " : "", "function ").concat(this.name, "(").concat(this.args, ")") + _get(_getPrototypeOf(E.prototype), "render", this).call(this, e);
        }
      }]);

      return E;
    }(f);

    E.kind = "func";

    var $ = /*#__PURE__*/function (_m3) {
      _inherits($, _m3);

      function $() {
        _classCallCheck(this, $);

        return _possibleConstructorReturn(this, _getPrototypeOf($).apply(this, arguments));
      }

      _createClass($, [{
        key: "render",
        value: function render(e) {
          return "return " + _get(_getPrototypeOf($.prototype), "render", this).call(this, e);
        }
      }]);

      return $;
    }(m);

    $.kind = "return";

    var M = /*#__PURE__*/function (_f5) {
      _inherits(M, _f5);

      function M() {
        _classCallCheck(this, M);

        return _possibleConstructorReturn(this, _getPrototypeOf(M).apply(this, arguments));
      }

      _createClass(M, [{
        key: "render",
        value: function render(e) {
          var t = "try" + _get(_getPrototypeOf(M.prototype), "render", this).call(this, e);

          return this.catch && (t += this.catch.render(e)), this.finally && (t += this.finally.render(e)), t;
        }
      }, {
        key: "optimizeNodes",
        value: function optimizeNodes() {
          var e, t;
          return _get(_getPrototypeOf(M.prototype), "optimizeNodes", this).call(this), null === (e = this.catch) || void 0 === e || e.optimizeNodes(), null === (t = this.finally) || void 0 === t || t.optimizeNodes(), this;
        }
      }, {
        key: "optimizeNames",
        value: function optimizeNames(e, t) {
          var n, a;
          return _get(_getPrototypeOf(M.prototype), "optimizeNames", this).call(this, e, t), null === (n = this.catch) || void 0 === n || n.optimizeNames(e, t), null === (a = this.finally) || void 0 === a || a.optimizeNames(e, t), this;
        }
      }, {
        key: "names",
        get: function get() {
          var e = _get(_getPrototypeOf(M.prototype), "names", this);

          return this.catch && N(e, this.catch.names), this.finally && N(e, this.finally.names), e;
        }
      }]);

      return M;
    }(f);

    var C = /*#__PURE__*/function (_f6) {
      _inherits(C, _f6);

      function C(e) {
        var _this20;

        _classCallCheck(this, C);

        _this20 = _possibleConstructorReturn(this, _getPrototypeOf(C).call(this)), _this20.error = e;
        return _this20;
      }

      _createClass(C, [{
        key: "render",
        value: function render(e) {
          return "catch(".concat(this.error, ")") + _get(_getPrototypeOf(C.prototype), "render", this).call(this, e);
        }
      }]);

      return C;
    }(f);

    C.kind = "catch";

    var I = /*#__PURE__*/function (_f7) {
      _inherits(I, _f7);

      function I() {
        _classCallCheck(this, I);

        return _possibleConstructorReturn(this, _getPrototypeOf(I).apply(this, arguments));
      }

      _createClass(I, [{
        key: "render",
        value: function render(e) {
          return "finally" + _get(_getPrototypeOf(I.prototype), "render", this).call(this, e);
        }
      }]);

      return I;
    }(f);

    I.kind = "finally";

    function N(e, t) {
      for (var _n6 in t) {
        e[_n6] = (e[_n6] || 0) + (t[_n6] || 0);
      }

      return e;
    }

    function S(e, t) {
      return t instanceof u._CodeOrName ? N(e, t.names) : e;
    }

    function A(e, t, n) {
      return e instanceof u.Name ? r(e) : (a = e) instanceof u._Code && a._items.some(function (e) {
        return e instanceof u.Name && 1 === t[e.str] && void 0 !== n[e.str];
      }) ? new u._Code(e._items.reduce(function (e, t) {
        return t instanceof u.Name && (t = r(t)), t instanceof u._Code ? e.push.apply(e, _toConsumableArray(t._items)) : e.push(t), e;
      }, [])) : e;
      var a;

      function r(e) {
        var a = n[e.str];
        return void 0 === a || 1 !== t[e.str] ? e : (delete t[e.str], a);
      }
    }

    function x(e, t) {
      for (var _n7 in t) {
        e[_n7] = (e[_n7] || 0) - (t[_n7] || 0);
      }
    }

    function P(e) {
      return "boolean" == typeof e || "number" == typeof e || null === e ? !e : u._(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["!", ""])), j(e));
    }

    t.CodeGen = /*#__PURE__*/function () {
      function _class2(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        _classCallCheck(this, _class2);

        this._values = {}, this._blockStarts = [], this._constants = {}, this.opts = _objectSpread({}, t, {
          _n: t.lines ? "\n" : ""
        }), this._extScope = e, this._scope = new d.Scope({
          parent: e
        }), this._nodes = [new h()];
      }

      _createClass(_class2, [{
        key: "toString",
        value: function toString() {
          return this._root.render(this.opts);
        }
      }, {
        key: "name",
        value: function name(e) {
          return this._scope.name(e);
        }
      }, {
        key: "scopeName",
        value: function scopeName(e) {
          return this._extScope.name(e);
        }
      }, {
        key: "scopeValue",
        value: function scopeValue(e, t) {
          var n = this._extScope.value(e, t);

          return (this._values[n.prefix] || (this._values[n.prefix] = new Set())).add(n), n;
        }
      }, {
        key: "getScopeValue",
        value: function getScopeValue(e, t) {
          return this._extScope.getValue(e, t);
        }
      }, {
        key: "scopeRefs",
        value: function scopeRefs(e) {
          return this._extScope.scopeRefs(e, this._values);
        }
      }, {
        key: "scopeCode",
        value: function scopeCode() {
          return this._extScope.scopeCode(this._values);
        }
      }, {
        key: "_def",
        value: function _def(e, t, n, a) {
          var r = this._scope.toName(t);

          return void 0 !== n && a && (this._constants[r.str] = n), this._leafNode(new s(e, r, n)), r;
        }
      }, {
        key: "const",
        value: function _const(e, t, n) {
          return this._def(d.varKinds.const, e, t, n);
        }
      }, {
        key: "let",
        value: function _let(e, t, n) {
          return this._def(d.varKinds.let, e, t, n);
        }
      }, {
        key: "var",
        value: function _var(e, t, n) {
          return this._def(d.varKinds.var, e, t, n);
        }
      }, {
        key: "assign",
        value: function assign(e, t, n) {
          return this._leafNode(new i(e, t, n));
        }
      }, {
        key: "add",
        value: function add(e, n) {
          return this._leafNode(new o(e, t.operators.ADD, n));
        }
      }, {
        key: "code",
        value: function code(e) {
          return "function" == typeof e ? e() : e !== u.nil && this._leafNode(new y(e)), this;
        }
      }, {
        key: "object",
        value: function object() {
          var t = ["{"];

          for (var _len3 = arguments.length, e = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
            e[_key3] = arguments[_key3];
          }

          for (var _i2 = 0, _e4 = e; _i2 < _e4.length; _i2++) {
            var _e4$_i = _slicedToArray(_e4[_i2], 2),
                _n8 = _e4$_i[0],
                _a = _e4$_i[1];

            t.length > 1 && t.push(","), t.push(_n8), (_n8 !== _a || this.opts.es5) && (t.push(":"), u.addCodeArg(t, _a));
          }

          return t.push("}"), new u._Code(t);
        }
      }, {
        key: "if",
        value: function _if(e, t, n) {
          if (this._blockNode(new v(e)), t && n) this.code(t).else().code(n).endIf();else if (t) this.code(t).endIf();else if (n) throw new Error('CodeGen: "else" body without "then" body');
          return this;
        }
      }, {
        key: "elseIf",
        value: function elseIf(e) {
          return this._elseNode(new v(e));
        }
      }, {
        key: "else",
        value: function _else() {
          return this._elseNode(new b());
        }
      }, {
        key: "endIf",
        value: function endIf() {
          return this._endBlockNode(v, b);
        }
      }, {
        key: "_for",
        value: function _for(e, t) {
          return this._blockNode(e), t && this.code(t).endFor(), this;
        }
      }, {
        key: "for",
        value: function _for(e, t) {
          return this._for(new _(e), t);
        }
      }, {
        key: "forRange",
        value: function forRange(e, t, n, a) {
          var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.opts.es5 ? d.varKinds.var : d.varKinds.let;

          var s = this._scope.toName(e);

          return this._for(new T(r, s, t, n), function () {
            return a(s);
          });
        }
      }, {
        key: "forOf",
        value: function forOf(e, t, n) {
          var _this21 = this;

          var a = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : d.varKinds.const;

          var r = this._scope.toName(e);

          if (this.opts.es5) {
            var _e5 = t instanceof u.Name ? t : this.var("_arr", t);

            return this.forRange("_i", 0, u._(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["", ".length"])), _e5), function (t) {
              _this21.var(r, u._(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["", "[", "]"])), _e5, t)), n(r);
            });
          }

          return this._for(new w("of", a, r, t), function () {
            return n(r);
          });
        }
      }, {
        key: "forIn",
        value: function forIn(e, t, n) {
          var a = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : this.opts.es5 ? d.varKinds.var : d.varKinds.const;
          if (this.opts.ownProperties) return this.forOf(e, u._(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["Object.keys(", ")"])), t), n);

          var r = this._scope.toName(e);

          return this._for(new w("in", a, r, t), function () {
            return n(r);
          });
        }
      }, {
        key: "endFor",
        value: function endFor() {
          return this._endBlockNode(g);
        }
      }, {
        key: "label",
        value: function label(e) {
          return this._leafNode(new p(e));
        }
      }, {
        key: "break",
        value: function _break(e) {
          return this._leafNode(new l(e));
        }
      }, {
        key: "return",
        value: function _return(e) {
          var t = new $();
          if (this._blockNode(t), this.code(e), 1 !== t.nodes.length) throw new Error('CodeGen: "return" should have one node');
          return this._endBlockNode($);
        }
      }, {
        key: "try",
        value: function _try(e, t, n) {
          if (!t && !n) throw new Error('CodeGen: "try" without "catch" and "finally"');
          var a = new M();

          if (this._blockNode(a), this.code(e), t) {
            var _e6 = this.name("e");

            this._currNode = a.catch = new C(_e6), t(_e6);
          }

          return n && (this._currNode = a.finally = new I(), this.code(n)), this._endBlockNode(C, I);
        }
      }, {
        key: "throw",
        value: function _throw(e) {
          return this._leafNode(new c(e));
        }
      }, {
        key: "block",
        value: function block(e, t) {
          return this._blockStarts.push(this._nodes.length), e && this.code(e).endBlock(t), this;
        }
      }, {
        key: "endBlock",
        value: function endBlock(e) {
          var t = this._blockStarts.pop();

          if (void 0 === t) throw new Error("CodeGen: not in self-balancing block");
          var n = this._nodes.length - t;
          if (n < 0 || void 0 !== e && n !== e) throw new Error("CodeGen: wrong number of nodes: ".concat(n, " vs ").concat(e, " expected"));
          return this._nodes.length = t, this;
        }
      }, {
        key: "func",
        value: function func(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : u.nil;
          var n = arguments.length > 2 ? arguments[2] : undefined;
          var a = arguments.length > 3 ? arguments[3] : undefined;
          return this._blockNode(new E(e, t, n)), a && this.code(a).endFunc(), this;
        }
      }, {
        key: "endFunc",
        value: function endFunc() {
          return this._endBlockNode(E);
        }
      }, {
        key: "optimize",
        value: function optimize() {
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

          for (; e-- > 0;) {
            this._root.optimizeNodes(), this._root.optimizeNames(this._root.names, this._constants);
          }
        }
      }, {
        key: "_leafNode",
        value: function _leafNode(e) {
          return this._currNode.nodes.push(e), this;
        }
      }, {
        key: "_blockNode",
        value: function _blockNode(e) {
          this._currNode.nodes.push(e), this._nodes.push(e);
        }
      }, {
        key: "_endBlockNode",
        value: function _endBlockNode(e, t) {
          var n = this._currNode;
          if (n instanceof e || t && n instanceof t) return this._nodes.pop(), this;
          throw new Error("CodeGen: not in block \"".concat(t ? "".concat(e.kind, "/").concat(t.kind) : e.kind, "\""));
        }
      }, {
        key: "_elseNode",
        value: function _elseNode(e) {
          var t = this._currNode;
          if (!(t instanceof v)) throw new Error('CodeGen: "else" without "if"');
          return this._currNode = t.else = e, this;
        }
      }, {
        key: "_root",
        get: function get() {
          return this._nodes[0];
        }
      }, {
        key: "_currNode",
        get: function get() {
          var e = this._nodes;
          return e[e.length - 1];
        },
        set: function set(e) {
          var t = this._nodes;
          t[t.length - 1] = e;
        }
      }]);

      return _class2;
    }(), t.not = P;
    var R = k(t.operators.AND);

    t.and = function () {
      for (var _len4 = arguments.length, e = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        e[_key4] = arguments[_key4];
      }

      return e.reduce(R);
    };

    var O = k(t.operators.OR);

    function k(e) {
      return function (t, n) {
        return t === u.nil ? n : n === u.nil ? t : u._(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["", " ", " ", ""])), j(t), e, j(n));
      };
    }

    function j(e) {
      return e instanceof u.Name ? e : u._(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["(", ")"])), e);
    }

    t.or = function () {
      for (var _len5 = arguments.length, e = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        e[_key5] = arguments[_key5];
      }

      return e.reduce(O);
    };
  });
  r(l), l.or, l.and, l.not, l.CodeGen, l.operators, l.varKinds, l.ValueScopeName, l.ValueScope, l.Scope, l.Name, l.stringify, l.getProperty, l.nil, l.strConcat, l.str, l._;
  var c = s(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = {
      data: new l.Name("data"),
      valCxt: new l.Name("valCxt"),
      dataPath: new l.Name("dataPath"),
      parentData: new l.Name("parentData"),
      parentDataProperty: new l.Name("parentDataProperty"),
      rootData: new l.Name("rootData"),
      dynamicAnchors: new l.Name("dynamicAnchors"),
      vErrors: new l.Name("vErrors"),
      errors: new l.Name("errors"),
      this: new l.Name("this"),
      self: new l.Name("self"),
      scope: new l.Name("scope"),
      json: new l.Name("json"),
      jsonPos: new l.Name("jsonPos"),
      jsonLen: new l.Name("jsonLen"),
      jsonPart: new l.Name("jsonPart")
    };
    t.default = n;
  });
  r(c);
  var y = s(function (e, t) {
    function n(e, t) {
      var n = e.const("err", t);
      e.if(l._(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["", " === null"])), c.default.vErrors), function () {
        return e.assign(c.default.vErrors, l._(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["[", "]"])), n));
      }, l._(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["", ".push(", ")"])), c.default.vErrors, n)), e.code(l._(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["", "++"])), c.default.errors));
    }

    function a(e, t) {
      var n = e.gen,
          a = e.validateName,
          r = e.schemaEnv;
      r.$async ? n.throw(l._(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["new ", "(", ")"])), e.ValidationError, t)) : (n.assign(l._(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["", ".errors"])), a), t), n.return(!1));
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.extendErrors = t.resetErrorsCount = t.reportExtraError = t.reportError = t.keyword$DataError = t.keywordError = void 0, t.keywordError = {
      message: function message(_ref12) {
        var e = _ref12.keyword;
        return l.str(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["should pass \"", "\" keyword validation"])), e);
      }
    }, t.keyword$DataError = {
      message: function message(_ref13) {
        var e = _ref13.keyword,
            t = _ref13.schemaType;
        return t ? l.str(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\"", "\" keyword must be ", " ($data)"])), e, t) : l.str(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\"", "\" keyword is invalid ($data)"])), e);
      }
    }, t.reportError = function (e) {
      var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : t.keywordError;
      var i = arguments.length > 2 ? arguments[2] : undefined;
      var o = e.it,
          p = o.gen,
          u = o.compositeRule,
          d = o.allErrors,
          c = s(e, r);
      (null != i ? i : u || d) ? n(p, c) : a(o, l._(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral(["[", "]"])), c));
    }, t.reportExtraError = function (e) {
      var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : t.keywordError;
      var i = e.it,
          o = i.gen,
          p = i.compositeRule,
          u = i.allErrors;
      n(o, s(e, r)), p || u || a(i, c.default.vErrors);
    }, t.resetErrorsCount = function (e, t) {
      e.assign(c.default.errors, t), e.if(l._(_templateObject24 || (_templateObject24 = _taggedTemplateLiteral(["", " !== null"])), c.default.vErrors), function () {
        return e.if(t, function () {
          return e.assign(l._(_templateObject25 || (_templateObject25 = _taggedTemplateLiteral(["", ".length"])), c.default.vErrors), t);
        }, function () {
          return e.assign(c.default.vErrors, null);
        });
      });
    }, t.extendErrors = function (_ref14) {
      var e = _ref14.gen,
          t = _ref14.keyword,
          n = _ref14.schemaValue,
          a = _ref14.data,
          r = _ref14.errsCount,
          s = _ref14.it;
      if (void 0 === r) throw new Error("ajv implementation error");
      var i = e.name("err");
      e.forRange("i", r, c.default.errors, function (r) {
        e.const(i, l._(_templateObject26 || (_templateObject26 = _taggedTemplateLiteral(["", "[", "]"])), c.default.vErrors, r)), e.if(l._(_templateObject27 || (_templateObject27 = _taggedTemplateLiteral(["", ".dataPath === undefined"])), i), function () {
          return e.assign(l._(_templateObject28 || (_templateObject28 = _taggedTemplateLiteral(["", ".dataPath"])), i), l.strConcat(c.default.dataPath, s.errorPath));
        }), e.assign(l._(_templateObject29 || (_templateObject29 = _taggedTemplateLiteral(["", ".schemaPath"])), i), l.str(_templateObject30 || (_templateObject30 = _taggedTemplateLiteral(["", "/", ""])), s.errSchemaPath, t)), s.opts.verbose && (e.assign(l._(_templateObject31 || (_templateObject31 = _taggedTemplateLiteral(["", ".schema"])), i), n), e.assign(l._(_templateObject32 || (_templateObject32 = _taggedTemplateLiteral(["", ".data"])), i), a));
      });
    };
    var r = {
      keyword: new l.Name("keyword"),
      schemaPath: new l.Name("schemaPath"),
      params: new l.Name("params"),
      propertyName: new l.Name("propertyName"),
      message: new l.Name("message"),
      schema: new l.Name("schema"),
      parentSchema: new l.Name("parentSchema"),
      instancePath: new l.Name("instancePath")
    };

    function s(e, t) {
      var _e$it = e.it,
          n = _e$it.createErrors,
          a = _e$it.opts;
      return !1 === n ? l._(_templateObject33 || (_templateObject33 = _taggedTemplateLiteral(["{}"]))) : (a.jtd && !a.ajvErrors ? i : o)(e, t);
    }

    function i(e, _ref15) {
      var t = _ref15.message;
      var n = e.gen,
          a = e.keyword,
          s = e.it,
          i = s.errorPath,
          o = s.errSchemaPath,
          p = s.opts,
          u = [[r.instancePath, l.strConcat(c.default.dataPath, i)], [r.schemaPath, l.str(_templateObject34 || (_templateObject34 = _taggedTemplateLiteral(["", "/", ""])), o, a)]];
      return p.messages && u.push([r.message, "function" == typeof t ? t(e) : t]), n.object.apply(n, u);
    }

    function o(e, t) {
      var n = e.gen,
          a = e.keyword,
          s = e.data,
          i = e.schemaValue,
          o = e.it,
          p = o.topSchemaRef,
          u = o.schemaPath,
          d = o.errorPath,
          y = o.errSchemaPath,
          m = o.propertyName,
          f = o.opts,
          h = t.params,
          b = t.message,
          v = [[r.keyword, a], [c.default.dataPath, l.strConcat(c.default.dataPath, d)], [r.schemaPath, l.str(_templateObject35 || (_templateObject35 = _taggedTemplateLiteral(["", "/", ""])), y, a)], [r.params, "function" == typeof h ? h(e) : h || l._(_templateObject36 || (_templateObject36 = _taggedTemplateLiteral(["{}"])))]];
      return m && v.push([r.propertyName, m]), f.messages && v.push([r.message, "function" == typeof b ? b(e) : b]), f.verbose && v.push([r.schema, i], [r.parentSchema, l._(_templateObject37 || (_templateObject37 = _taggedTemplateLiteral(["", "", ""])), p, u)], [c.default.data, s]), n.object.apply(n, v);
    }
  });
  r(y), y.extendErrors, y.resetErrorsCount, y.reportExtraError, y.reportError, y.keyword$DataError, y.keywordError;
  var m = s(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.boolOrEmptySchema = t.topBoolOrEmptySchema = void 0;
    var n = {
      message: "boolean schema is false"
    };

    function a(e, t) {
      var a = e.gen,
          r = e.data,
          s = {
        gen: a,
        keyword: "false schema",
        data: r,
        schema: !1,
        schemaCode: !1,
        schemaValue: !1,
        params: {},
        it: e
      };
      y.reportError(s, n, t);
    }

    t.topBoolOrEmptySchema = function (e) {
      var t = e.gen,
          n = e.schema,
          r = e.validateName;
      !1 === n ? a(e, !1) : "object" == typeof n && !0 === n.$async ? t.return(c.default.data) : (t.assign(l._(_templateObject38 || (_templateObject38 = _taggedTemplateLiteral(["", ".errors"])), r), null), t.return(!0));
    }, t.boolOrEmptySchema = function (e, t) {
      var n = e.gen,
          r = e.schema;
      !1 === r ? (n.var(t, !1), a(e)) : n.var(t, !0);
    };
  });
  r(m), m.boolOrEmptySchema, m.topBoolOrEmptySchema;
  var f = s(function (e, t) {
    function n(e, t, n) {
      var a = e.gen,
          r = e.compositeRule,
          s = e.data,
          i = e.opts;
      if (void 0 === n) return;

      var o = l._(_templateObject39 || (_templateObject39 = _taggedTemplateLiteral(["", "", ""])), s, l.getProperty(t));

      if (r) return void $.checkStrictMode(e, "default is ignored for: ".concat(o));

      var p = l._(_templateObject40 || (_templateObject40 = _taggedTemplateLiteral(["", " === undefined"])), o);

      "empty" === i.useDefaults && (p = l._(_templateObject41 || (_templateObject41 = _taggedTemplateLiteral(["", " || ", " === null || ", " === \"\""])), p, o, o)), a.if(p, l._(_templateObject42 || (_templateObject42 = _taggedTemplateLiteral(["", " = ", ""])), o, l.stringify(n)));
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.assignDefaults = void 0, t.assignDefaults = function (e, t) {
      var _e$schema = e.schema,
          a = _e$schema.properties,
          r = _e$schema.items;
      if ("object" === t && a) for (var _t in a) {
        n(e, _t, a[_t].default);
      } else "array" === t && Array.isArray(r) && r.forEach(function (t, a) {
        return n(e, a, t.default);
      });
    };
  });
  r(f), f.assignDefaults;
  var h = s(function (e, t) {
    var n;
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.applySubschema = t.Type = void 0, function (e) {
      e[e.Num = 0] = "Num", e[e.Str = 1] = "Str";
    }(n = t.Type || (t.Type = {})), t.applySubschema = function (e, t, a) {
      var r = function (e, _ref16) {
        var t = _ref16.keyword,
            n = _ref16.schemaProp,
            a = _ref16.schema,
            r = _ref16.schemaPath,
            s = _ref16.errSchemaPath,
            i = _ref16.topSchemaRef;
        if (void 0 !== t && void 0 !== a) throw new Error('both "keyword" and "schema" passed, only one allowed');

        if (void 0 !== t) {
          var _a2 = e.schema[t];
          return void 0 === n ? {
            schema: _a2,
            schemaPath: l._(_templateObject43 || (_templateObject43 = _taggedTemplateLiteral(["", "", ""])), e.schemaPath, l.getProperty(t)),
            errSchemaPath: "".concat(e.errSchemaPath, "/").concat(t)
          } : {
            schema: _a2[n],
            schemaPath: l._(_templateObject44 || (_templateObject44 = _taggedTemplateLiteral(["", "", "", ""])), e.schemaPath, l.getProperty(t), l.getProperty(n)),
            errSchemaPath: "".concat(e.errSchemaPath, "/").concat(t, "/").concat(M.escapeFragment(n))
          };
        }

        if (void 0 !== a) {
          if (void 0 === r || void 0 === s || void 0 === i) throw new Error('"schemaPath", "errSchemaPath" and "topSchemaRef" are required with "schema"');
          return {
            schema: a,
            schemaPath: r,
            topSchemaRef: i,
            errSchemaPath: s
          };
        }

        throw new Error('either "keyword" or "schema" must be passed');
      }(e, t);

      !function (e, t, _ref17) {
        var a = _ref17.dataProp,
            r = _ref17.dataPropType,
            s = _ref17.data,
            i = _ref17.dataTypes,
            o = _ref17.propertyName;
        if (void 0 !== s && void 0 !== a) throw new Error('both "data" and "dataProp" passed, only one allowed');
        var p = t.gen;

        if (void 0 !== a) {
          var _s = t.errorPath,
              _i3 = t.dataPathArr,
              _o = t.opts;
          u(p.let("data", l._(_templateObject45 || (_templateObject45 = _taggedTemplateLiteral(["", "", ""])), t.data, l.getProperty(a)), !0)), e.errorPath = l.str(_templateObject46 || (_templateObject46 = _taggedTemplateLiteral(["", "", ""])), _s, function (e, t, a) {
            if (e instanceof l.Name) {
              var _r10 = t === n.Num;

              return a ? _r10 ? l._(_templateObject47 || (_templateObject47 = _taggedTemplateLiteral(["\"[\" + ", " + \"]\""])), e) : l._(_templateObject48 || (_templateObject48 = _taggedTemplateLiteral(["\"['\" + ", " + \"']\""])), e) : _r10 ? l._(_templateObject49 || (_templateObject49 = _taggedTemplateLiteral(["\"/\" + ", ""])), e) : l._(_templateObject50 || (_templateObject50 = _taggedTemplateLiteral(["\"/\" + ", ".replace(/~/g, \"~0\").replace(/\\//g, \"~1\")"], ["\"/\" + ", ".replace(/~/g, \"~0\").replace(/\\\\//g, \"~1\")"])), e);
            }

            return a ? l.getProperty(e).toString() : "/" + M.escapeJsonPointer(e);
          }(a, r, _o.jsPropertySyntax)), e.parentDataProperty = l._(_templateObject51 || (_templateObject51 = _taggedTemplateLiteral(["", ""])), a), e.dataPathArr = [].concat(_toConsumableArray(_i3), [e.parentDataProperty]);
        }

        if (void 0 !== s) {
          u(s instanceof l.Name ? s : p.let("data", s, !0)), void 0 !== o && (e.propertyName = o);
        }

        i && (e.dataTypes = i);

        function u(n) {
          e.data = n, e.dataLevel = t.dataLevel + 1, e.dataTypes = [], t.definedProperties = new Set(), e.parentData = t.data, e.dataNames = [].concat(_toConsumableArray(t.dataNames), [n]);
        }
      }(r, e, t), function (e, _ref18) {
        var t = _ref18.jtdDiscriminator,
            n = _ref18.jtdMetadata,
            a = _ref18.compositeRule,
            r = _ref18.createErrors,
            s = _ref18.allErrors;
        void 0 !== a && (e.compositeRule = a);
        void 0 !== r && (e.createErrors = r);
        void 0 !== s && (e.allErrors = s);
        e.jtdDiscriminator = t, e.jtdMetadata = n;
      }(r, t);

      var s = _objectSpread({}, e, r, {
        items: void 0,
        props: void 0
      });

      return $.subschemaCode(s, a), s;
    };
  });
  r(h), h.applySubschema, h.Type;
  var b = s(function (e, t) {
    function n(e) {
      return e.scopeValue("func", {
        ref: Object.prototype.hasOwnProperty,
        code: l._(_templateObject52 || (_templateObject52 = _taggedTemplateLiteral(["Object.prototype.hasOwnProperty"])))
      });
    }

    function a(e, t, a) {
      return l._(_templateObject53 || (_templateObject53 = _taggedTemplateLiteral(["", ".call(", ", ", ")"])), n(e), t, a);
    }

    function r(e, t, n, r) {
      var s = l._(_templateObject54 || (_templateObject54 = _taggedTemplateLiteral(["", "", " === undefined"])), t, l.getProperty(n));

      return r ? l.or(s, l.not(a(e, t, n))) : s;
    }

    function s(e) {
      return e ? Object.keys(e).filter(function (e) {
        return "__proto__" !== e;
      }) : [];
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.validateUnion = t.validateArray = t.usePattern = t.callValidateCode = t.schemaProperties = t.allSchemaProperties = t.noPropertyInData = t.propertyInData = t.isOwnProperty = t.hasPropFunc = t.reportMissingProp = t.checkMissingProp = t.checkReportMissingProp = void 0, t.checkReportMissingProp = function (e, t) {
      var n = e.gen,
          a = e.data,
          s = e.it;
      n.if(r(n, a, t, s.opts.ownProperties), function () {
        e.setParams({
          missingProperty: l._(_templateObject55 || (_templateObject55 = _taggedTemplateLiteral(["", ""])), t)
        }, !0), e.error();
      });
    }, t.checkMissingProp = function (_ref19, a, s) {
      var e = _ref19.gen,
          t = _ref19.data,
          n = _ref19.it.opts;
      return l.or.apply(l, _toConsumableArray(a.map(function (a) {
        return l.and(r(e, t, a, n.ownProperties), l._(_templateObject56 || (_templateObject56 = _taggedTemplateLiteral(["", " = ", ""])), s, a));
      })));
    }, t.reportMissingProp = function (e, t) {
      e.setParams({
        missingProperty: t
      }, !0), e.error();
    }, t.hasPropFunc = n, t.isOwnProperty = a, t.propertyInData = function (e, t, n, r) {
      var s = l._(_templateObject57 || (_templateObject57 = _taggedTemplateLiteral(["", "", " !== undefined"])), t, l.getProperty(n));

      return r ? l._(_templateObject58 || (_templateObject58 = _taggedTemplateLiteral(["", " && ", ""])), s, a(e, t, n)) : s;
    }, t.noPropertyInData = r, t.allSchemaProperties = s, t.schemaProperties = function (e, t) {
      return s(t).filter(function (n) {
        return !M.alwaysValidSchema(e, t[n]);
      });
    }, t.callValidateCode = function (_ref20, o, p, u) {
      var e = _ref20.schemaCode,
          t = _ref20.data,
          _ref20$it = _ref20.it,
          n = _ref20$it.gen,
          a = _ref20$it.topSchemaRef,
          r = _ref20$it.schemaPath,
          s = _ref20$it.errorPath,
          i = _ref20.it;
      var d = u ? l._(_templateObject59 || (_templateObject59 = _taggedTemplateLiteral(["", ", ", ", ", "", ""])), e, t, a, r) : t,
          y = [[c.default.dataPath, l.strConcat(c.default.dataPath, s)], [c.default.parentData, i.parentData], [c.default.parentDataProperty, i.parentDataProperty], [c.default.rootData, c.default.rootData]];
      i.opts.dynamicRef && y.push([c.default.dynamicAnchors, c.default.dynamicAnchors]);

      var m = l._(_templateObject60 || (_templateObject60 = _taggedTemplateLiteral(["", ", ", ""])), d, n.object.apply(n, y));

      return p !== l.nil ? l._(_templateObject61 || (_templateObject61 = _taggedTemplateLiteral(["", ".call(", ", ", ")"])), o, p, m) : l._(_templateObject62 || (_templateObject62 = _taggedTemplateLiteral(["", "(", ")"])), o, m);
    }, t.usePattern = function (e, t) {
      return e.scopeValue("pattern", {
        key: t,
        ref: new RegExp(t, "u"),
        code: l._(_templateObject63 || (_templateObject63 = _taggedTemplateLiteral(["new RegExp(", ", \"u\")"])), t)
      });
    }, t.validateArray = function (e) {
      var t = e.gen,
          n = e.data,
          a = e.keyword,
          r = e.it,
          s = t.name("valid");

      if (r.allErrors) {
        var _e7 = t.let("valid", !0);

        return i(function () {
          return t.assign(_e7, !1);
        }), _e7;
      }

      return t.var(s, !0), i(function () {
        return t.break();
      }), s;

      function i(r) {
        var i = t.const("len", l._(_templateObject64 || (_templateObject64 = _taggedTemplateLiteral(["", ".length"])), n));
        t.forRange("i", 0, i, function (n) {
          e.subschema({
            keyword: a,
            dataProp: n,
            dataPropType: h.Type.Num
          }, s), t.if(l.not(s), r);
        });
      }
    }, t.validateUnion = function (e) {
      var t = e.gen,
          n = e.schema,
          a = e.keyword,
          r = e.it;
      if (!Array.isArray(n)) throw new Error("ajv implementation error");
      if (n.some(function (e) {
        return M.alwaysValidSchema(r, e);
      }) && !r.opts.unevaluated) return;
      var s = t.let("valid", !1),
          i = t.name("_valid");
      t.block(function () {
        return n.forEach(function (n, r) {
          var o = e.subschema({
            keyword: a,
            schemaProp: r,
            compositeRule: !0
          }, i);
          t.assign(s, l._(_templateObject65 || (_templateObject65 = _taggedTemplateLiteral(["", " || ", ""])), s, i));
          e.mergeValidEvaluated(o, i) || t.if(l.not(s));
        });
      }), e.result(s, function () {
        return e.reset();
      }, function () {
        return e.error(!0);
      });
    };
  });
  r(b), b.validateUnion, b.validateArray, b.usePattern, b.callValidateCode, b.schemaProperties, b.allSchemaProperties, b.noPropertyInData, b.propertyInData, b.isOwnProperty, b.hasPropFunc, b.reportMissingProp, b.checkMissingProp, b.checkReportMissingProp;
  var v = s(function (e, t) {
    function n(e, t) {
      var n;
      var s = e.gen,
          i = e.keyword,
          o = e.schema,
          p = e.parentSchema,
          u = e.$data,
          d = e.it;
      !function (_ref21, t) {
        var e = _ref21.schemaEnv;
        if (t.async && !e.$async) throw new Error("async keyword in sync schema");
      }(d, t);
      var m = !u && t.compile ? t.compile.call(d.self, o, p, d) : t.validate,
          f = r(s, i, m),
          h = s.let("valid");

      function v() {
        var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : t.async ? l._(_templateObject66 || (_templateObject66 = _taggedTemplateLiteral(["await "]))) : l.nil;
        var a = d.opts.passContext ? c.default.this : c.default.self,
            r = !("compile" in t && !u || !1 === t.schema);
        s.assign(h, l._(_templateObject67 || (_templateObject67 = _taggedTemplateLiteral(["", "", ""])), n, b.callValidateCode(e, f, a, r)), t.modifying);
      }

      function g(e) {
        var n;
        s.if(l.not(null !== (n = t.valid) && void 0 !== n ? n : h), e);
      }

      e.block$data(h, function () {
        if (!1 === t.errors) v(), t.modifying && a(e), g(function () {
          return e.error();
        });else {
          var _n9 = t.async ? function () {
            var e = s.let("ruleErrs", null);
            return s.try(function () {
              return v(l._(_templateObject68 || (_templateObject68 = _taggedTemplateLiteral(["await "]))));
            }, function (t) {
              return s.assign(h, !1).if(l._(_templateObject69 || (_templateObject69 = _taggedTemplateLiteral(["", " instanceof ", ""])), t, d.ValidationError), function () {
                return s.assign(e, l._(_templateObject70 || (_templateObject70 = _taggedTemplateLiteral(["", ".errors"])), t));
              }, function () {
                return s.throw(t);
              });
            }), e;
          }() : function () {
            var e = l._(_templateObject71 || (_templateObject71 = _taggedTemplateLiteral(["", ".errors"])), f);

            return s.assign(e, null), v(l.nil), e;
          }();

          t.modifying && a(e), g(function () {
            return function (e, t) {
              var n = e.gen;
              n.if(l._(_templateObject72 || (_templateObject72 = _taggedTemplateLiteral(["Array.isArray(", ")"])), t), function () {
                n.assign(c.default.vErrors, l._(_templateObject73 || (_templateObject73 = _taggedTemplateLiteral(["", " === null ? ", " : ", ".concat(", ")"])), c.default.vErrors, t, c.default.vErrors, t)).assign(c.default.errors, l._(_templateObject74 || (_templateObject74 = _taggedTemplateLiteral(["", ".length"])), c.default.vErrors)), y.extendErrors(e);
              }, function () {
                return e.error();
              });
            }(e, _n9);
          });
        }
      }), e.ok(null !== (n = t.valid) && void 0 !== n ? n : h);
    }

    function a(e) {
      var t = e.gen,
          n = e.data,
          a = e.it;
      t.if(a.parentData, function () {
        return t.assign(n, l._(_templateObject75 || (_templateObject75 = _taggedTemplateLiteral(["", "[", "]"])), a.parentData, a.parentDataProperty));
      });
    }

    function r(e, t, n) {
      if (void 0 === n) throw new Error("keyword \"".concat(t, "\" failed to compile"));
      return e.scopeValue("keyword", "function" == typeof n ? {
        ref: n
      } : {
        ref: n,
        code: l.stringify(n)
      });
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.keywordCode = void 0, t.keywordCode = function (e, t, a, s) {
      var i = new I.default(e, a, t);
      "code" in a ? a.code(i, s) : i.$data && a.validate ? n(i, a) : "macro" in a ? function (e, t) {
        var n = e.gen,
            a = e.keyword,
            s = e.schema,
            i = e.parentSchema,
            o = e.it,
            p = t.macro.call(o.self, s, i, o),
            u = r(n, a, p);
        !1 !== o.opts.validateSchema && o.self.validateSchema(p, !0);
        var d = n.name("valid");
        e.subschema({
          schema: p,
          schemaPath: l.nil,
          errSchemaPath: "".concat(o.errSchemaPath, "/").concat(a),
          topSchemaRef: u,
          compositeRule: !0
        }, d), e.pass(d, function () {
          return e.error(!0);
        });
      }(i, a) : (a.compile || a.validate) && n(i, a);
    };
  });
  r(v), v.keywordCode;
  var g = s(function (e, t) {
    function n(e, t) {
      var n = e.gen,
          a = e.schema,
          r = e.opts.useDefaults;
      r && f.assignDefaults(e, t.type), n.block(function () {
        var _iterator = _createForOfIteratorHelper(t.rules),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _n10 = _step.value;
            p.shouldUseRule(a, _n10) && v.keywordCode(e, _n10.keyword, _n10.definition, t.type);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
    }

    function a(e, t) {
      return e.includes(t) || "number" === t && e.includes("integer");
    }

    function r(e, t) {
      return e.includes(t) || "integer" === t && e.includes("number");
    }

    function s(e, t) {
      t += " at \"".concat(e.schemaEnv.baseId + e.errSchemaPath, "\" (strictTypes)"), $.checkStrictMode(e, t, e.opts.strictTypes);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.schemaKeywords = void 0, t.schemaKeywords = function (e, t, i, o) {
      var u = e.gen,
          d = e.schema,
          y = e.data,
          m = e.allErrors,
          f = e.opts,
          h = e.self,
          b = h.RULES;

      function g(a) {
        p.shouldUseGroup(d, a) && (a.type ? (u.if(C.checkDataType(a.type, y, f.strict)), n(e, a), 1 === t.length && t[0] === a.type && i && (u.else(), C.reportTypeError(e)), u.endIf()) : n(e, a), m || u.if(l._(_templateObject76 || (_templateObject76 = _taggedTemplateLiteral(["", " === ", ""])), c.default.errors, o || 0)));
      }

      !d.$ref || !f.ignoreKeywordsWithRef && M.schemaHasRulesButRef(d, b) ? (f.jtd || function (e, t) {
        if (e.schemaEnv.meta || !e.opts.strictTypes) return;
        (function (e, t) {
          if (!t.length) return;
          if (!e.dataTypes.length) return void (e.dataTypes = t);
          t.forEach(function (t) {
            r(e.dataTypes, t) || s(e, "type \"".concat(t, "\" not allowed by context \"").concat(e.dataTypes.join(","), "\""));
          }), e.dataTypes = e.dataTypes.filter(function (e) {
            return r(t, e);
          });
        })(e, t), e.opts.allowUnionTypes || function (e, t) {
          t.length > 1 && (2 !== t.length || !t.includes("null")) && s(e, "use allowUnionTypes to allow union type keyword");
        }(e, t);
        !function (e, t) {
          var n = e.self.RULES.all;

          for (var _r11 in n) {
            var _i4 = n[_r11];

            if ("object" == typeof _i4 && p.shouldUseRule(e.schema, _i4)) {
              var _n11 = _i4.definition.type;
              _n11.length && !_n11.some(function (e) {
                return a(t, e);
              }) && s(e, "missing type \"".concat(_n11.join(","), "\" for keyword \"").concat(_r11, "\""));
            }
          }
        }(e, e.dataTypes);
      }(e, t), u.block(function () {
        var _iterator2 = _createForOfIteratorHelper(b.rules),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _e8 = _step2.value;
            g(_e8);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        g(b.post);
      })) : u.block(function () {
        return v.keywordCode(e, "$ref", b.all.$ref.definition);
      });
    };
  });
  r(g), g.schemaKeywords;

  var _ = function e(t, n) {
    if (t === n) return !0;

    if (t && n && "object" == typeof t && "object" == typeof n) {
      if (t.constructor !== n.constructor) return !1;
      var a, r, s;

      if (Array.isArray(t)) {
        if ((a = t.length) != n.length) return !1;

        for (r = a; 0 != r--;) {
          if (!e(t[r], n[r])) return !1;
        }

        return !0;
      }

      if (t.constructor === RegExp) return t.source === n.source && t.flags === n.flags;
      if (t.valueOf !== Object.prototype.valueOf) return t.valueOf() === n.valueOf();
      if (t.toString !== Object.prototype.toString) return t.toString() === n.toString();
      if ((a = (s = Object.keys(t)).length) !== Object.keys(n).length) return !1;

      for (r = a; 0 != r--;) {
        if (!Object.prototype.hasOwnProperty.call(n, s[r])) return !1;
      }

      for (r = a; 0 != r--;) {
        var i = s[r];
        if (!e(t[i], n[i])) return !1;
      }

      return !0;
    }

    return t != t && n != n;
  },
      T = s(function (e) {
    var t = e.exports = function (e, t, a) {
      "function" == typeof t && (a = t, t = {}), n(t, "function" == typeof (a = t.cb || a) ? a : a.pre || function () {}, a.post || function () {}, e, "", e);
    };

    function n(e, a, r, s, i, o, p, u, d, l) {
      if (s && "object" == typeof s && !Array.isArray(s)) {
        for (var c in a(s, i, o, p, u, d, l), s) {
          var y = s[c];

          if (Array.isArray(y)) {
            if (c in t.arrayKeywords) for (var m = 0; m < y.length; m++) {
              n(e, a, r, y[m], i + "/" + c + "/" + m, o, i, c, s, m);
            }
          } else if (c in t.propsKeywords) {
            if (y && "object" == typeof y) for (var f in y) {
              n(e, a, r, y[f], i + "/" + c + "/" + f.replace(/~/g, "~0").replace(/\//g, "~1"), o, i, c, s, f);
            }
          } else (c in t.keywords || e.allKeys && !(c in t.skipKeywords)) && n(e, a, r, y, i + "/" + c, o, i, c, s);
        }

        r(s, i, o, p, u, d, l);
      }
    }

    t.keywords = {
      additionalItems: !0,
      items: !0,
      contains: !0,
      additionalProperties: !0,
      propertyNames: !0,
      not: !0,
      if: !0,
      then: !0,
      else: !0
    }, t.arrayKeywords = {
      items: !0,
      allOf: !0,
      anyOf: !0,
      oneOf: !0
    }, t.propsKeywords = {
      $defs: !0,
      definitions: !0,
      properties: !0,
      patternProperties: !0,
      dependencies: !0
    }, t.skipKeywords = {
      default: !0,
      enum: !0,
      const: !0,
      required: !0,
      maximum: !0,
      minimum: !0,
      exclusiveMaximum: !0,
      exclusiveMinimum: !0,
      multipleOf: !0,
      maxLength: !0,
      minLength: !0,
      pattern: !0,
      format: !0,
      maxItems: !0,
      minItems: !0,
      uniqueItems: !0,
      maxProperties: !0,
      minProperties: !0
    };
  }),
      w = s(function (e, t) {
    /** @license URI.js v4.4.1 (c) 2011 Gary Court. License: http://github.com/garycourt/uri-js */
    !function (e) {
      function t() {
        for (var e = arguments.length, t = Array(e), n = 0; n < e; n++) {
          t[n] = arguments[n];
        }

        if (t.length > 1) {
          t[0] = t[0].slice(0, -1);

          for (var a = t.length - 1, r = 1; r < a; ++r) {
            t[r] = t[r].slice(1, -1);
          }

          return t[a] = t[a].slice(1), t.join("");
        }

        return t[0];
      }

      function n(e) {
        return "(?:" + e + ")";
      }

      function a(e) {
        return void 0 === e ? "undefined" : null === e ? "null" : Object.prototype.toString.call(e).split(" ").pop().split("]").shift().toLowerCase();
      }

      function r(e) {
        return e.toUpperCase();
      }

      function s(e) {
        return null != e ? e instanceof Array ? e : "number" != typeof e.length || e.split || e.setInterval || e.call ? [e] : Array.prototype.slice.call(e) : [];
      }

      function i(e, t) {
        var n = e;
        if (t) for (var a in t) {
          n[a] = t[a];
        }
        return n;
      }

      function o(e) {
        var a = "[A-Za-z]",
            r = "[0-9]",
            s = t(r, "[A-Fa-f]"),
            i = n(n("%[EFef]" + s + "%" + s + s + "%" + s + s) + "|" + n("%[89A-Fa-f]" + s + "%" + s + s) + "|" + n("%" + s + s)),
            o = "[\\!\\$\\&\\'\\(\\)\\*\\+\\,\\;\\=]",
            p = t("[\\:\\/\\?\\#\\[\\]\\@]", o),
            u = e ? "[\\uE000-\\uF8FF]" : "[]",
            d = t(a, r, "[\\-\\.\\_\\~]", e ? "[\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]" : "[]");
        n(a + t(a, r, "[\\+\\-\\.]") + "*"), n(n(i + "|" + t(d, o, "[\\:]")) + "*");

        var l = n(n("25[0-5]") + "|" + n("2[0-4]" + r) + "|" + n("1" + r + r) + "|" + n("0?[1-9]" + r) + "|0?0?" + r),
            c = n(l + "\\." + l + "\\." + l + "\\." + l),
            y = n(s + "{1,4}"),
            m = n(n(y + "\\:" + y) + "|" + c),
            f = n(n(y + "\\:") + "{6}" + m),
            h = n("\\:\\:" + n(y + "\\:") + "{5}" + m),
            b = n(n(y) + "?\\:\\:" + n(y + "\\:") + "{4}" + m),
            v = n(n(n(y + "\\:") + "{0,1}" + y) + "?\\:\\:" + n(y + "\\:") + "{3}" + m),
            g = n(n(n(y + "\\:") + "{0,2}" + y) + "?\\:\\:" + n(y + "\\:") + "{2}" + m),
            _ = n(n(n(y + "\\:") + "{0,3}" + y) + "?\\:\\:" + y + "\\:" + m),
            T = n(n(n(y + "\\:") + "{0,4}" + y) + "?\\:\\:" + m),
            w = n(n(n(y + "\\:") + "{0,5}" + y) + "?\\:\\:" + y),
            E = n(n(n(y + "\\:") + "{0,6}" + y) + "?\\:\\:"),
            $ = n([f, h, b, v, g, _, T, w, E].join("|")),
            M = n(n(d + "|" + i) + "+");

        n("[vV]" + s + "+\\." + t(d, o, "[\\:]") + "+"), n(n(i + "|" + t(d, o)) + "*");
        var C = n(i + "|" + t(d, o, "[\\:\\@]"));
        return n(n(i + "|" + t(d, o, "[\\@]")) + "+"), n(n(C + "|" + t("[\\/\\?]", u)) + "*"), {
          NOT_SCHEME: new RegExp(t("[^]", a, r, "[\\+\\-\\.]"), "g"),
          NOT_USERINFO: new RegExp(t("[^\\%\\:]", d, o), "g"),
          NOT_HOST: new RegExp(t("[^\\%\\[\\]\\:]", d, o), "g"),
          NOT_PATH: new RegExp(t("[^\\%\\/\\:\\@]", d, o), "g"),
          NOT_PATH_NOSCHEME: new RegExp(t("[^\\%\\/\\@]", d, o), "g"),
          NOT_QUERY: new RegExp(t("[^\\%]", d, o, "[\\:\\@\\/\\?]", u), "g"),
          NOT_FRAGMENT: new RegExp(t("[^\\%]", d, o, "[\\:\\@\\/\\?]"), "g"),
          ESCAPE: new RegExp(t("[^]", d, o), "g"),
          UNRESERVED: new RegExp(d, "g"),
          OTHER_CHARS: new RegExp(t("[^\\%]", d, p), "g"),
          PCT_ENCODED: new RegExp(i, "g"),
          IPV4ADDRESS: new RegExp("^(" + c + ")$"),
          IPV6ADDRESS: new RegExp("^\\[?(" + $ + ")" + n(n("\\%25|\\%(?!" + s + "{2})") + "(" + M + ")") + "?\\]?$")
        };
      }

      var p = o(!1),
          u = o(!0),
          d = function () {
        function e(e, t) {
          var n = [],
              a = !0,
              r = !1,
              s = void 0;

          try {
            for (var i, o = e[Symbol.iterator](); !(a = (i = o.next()).done) && (n.push(i.value), !t || n.length !== t); a = !0) {
              ;
            }
          } catch (e) {
            r = !0, s = e;
          } finally {
            try {
              !a && o.return && o.return();
            } finally {
              if (r) throw s;
            }
          }

          return n;
        }

        return function (t, n) {
          if (Array.isArray(t)) return t;
          if (Symbol.iterator in Object(t)) return e(t, n);
          throw new TypeError("Invalid attempt to destructure non-iterable instance");
        };
      }(),
          l = function l(e) {
        if (Array.isArray(e)) {
          for (var t = 0, n = Array(e.length); t < e.length; t++) {
            n[t] = e[t];
          }

          return n;
        }

        return Array.from(e);
      },
          c = 2147483647,
          y = 36,
          m = 1,
          f = 26,
          h = 38,
          b = 700,
          v = 72,
          g = 128,
          _ = "-",
          T = /^xn--/,
          w = /[^\0-\x7E]/,
          E = /[\x2E\u3002\uFF0E\uFF61]/g,
          $ = {
        overflow: "Overflow: input needs wider integers to process",
        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
        "invalid-input": "Invalid input"
      },
          M = y - m,
          C = Math.floor,
          I = String.fromCharCode;

      function N(e) {
        throw new RangeError($[e]);
      }

      function S(e, t) {
        for (var n = [], a = e.length; a--;) {
          n[a] = t(e[a]);
        }

        return n;
      }

      function A(e, t) {
        var n = e.split("@"),
            a = "";
        return n.length > 1 && (a = n[0] + "@", e = n[1]), a + S((e = e.replace(E, ".")).split("."), t).join(".");
      }

      function x(e) {
        for (var t = [], n = 0, a = e.length; n < a;) {
          var r = e.charCodeAt(n++);

          if (r >= 55296 && r <= 56319 && n < a) {
            var s = e.charCodeAt(n++);
            56320 == (64512 & s) ? t.push(((1023 & r) << 10) + (1023 & s) + 65536) : (t.push(r), n--);
          } else t.push(r);
        }

        return t;
      }

      var P = function P(e) {
        return e - 48 < 10 ? e - 22 : e - 65 < 26 ? e - 65 : e - 97 < 26 ? e - 97 : y;
      },
          R = function R(e, t) {
        return e + 22 + 75 * (e < 26) - ((0 != t) << 5);
      },
          O = function O(e, t, n) {
        var a = 0;

        for (e = n ? C(e / b) : e >> 1, e += C(e / t); e > M * f >> 1; a += y) {
          e = C(e / M);
        }

        return C(a + (M + 1) * e / (e + h));
      },
          k = function k(e) {
        var t = [],
            n = e.length,
            a = 0,
            r = g,
            s = v,
            i = e.lastIndexOf(_);
        i < 0 && (i = 0);

        for (var o = 0; o < i; ++o) {
          e.charCodeAt(o) >= 128 && N("not-basic"), t.push(e.charCodeAt(o));
        }

        for (var p = i > 0 ? i + 1 : 0; p < n;) {
          for (var u = a, d = 1, l = y;; l += y) {
            p >= n && N("invalid-input");
            var h = P(e.charCodeAt(p++));
            (h >= y || h > C((c - a) / d)) && N("overflow"), a += h * d;
            var b = l <= s ? m : l >= s + f ? f : l - s;
            if (h < b) break;
            var T = y - b;
            d > C(c / T) && N("overflow"), d *= T;
          }

          var w = t.length + 1;
          s = O(a - u, w, 0 == u), C(a / w) > c - r && N("overflow"), r += C(a / w), a %= w, t.splice(a++, 0, r);
        }

        return String.fromCodePoint.apply(String, t);
      },
          j = function j(e) {
        var t = [],
            n = (e = x(e)).length,
            a = g,
            r = 0,
            s = v,
            i = !0,
            o = !1,
            p = void 0;

        try {
          for (var u, d = e[Symbol.iterator](); !(i = (u = d.next()).done); i = !0) {
            var l = u.value;
            l < 128 && t.push(I(l));
          }
        } catch (e) {
          o = !0, p = e;
        } finally {
          try {
            !i && d.return && d.return();
          } finally {
            if (o) throw p;
          }
        }

        var h = t.length,
            b = h;

        for (h && t.push(_); b < n;) {
          var T = c,
              w = !0,
              E = !1,
              $ = void 0;

          try {
            for (var M, S = e[Symbol.iterator](); !(w = (M = S.next()).done); w = !0) {
              var A = M.value;
              A >= a && A < T && (T = A);
            }
          } catch (e) {
            E = !0, $ = e;
          } finally {
            try {
              !w && S.return && S.return();
            } finally {
              if (E) throw $;
            }
          }

          var P = b + 1;
          T - a > C((c - r) / P) && N("overflow"), r += (T - a) * P, a = T;
          var k = !0,
              j = !1,
              D = void 0;

          try {
            for (var U, V = e[Symbol.iterator](); !(k = (U = V.next()).done); k = !0) {
              var F = U.value;

              if (F < a && ++r > c && N("overflow"), F == a) {
                for (var B = r, H = y;; H += y) {
                  var L = H <= s ? m : H >= s + f ? f : H - s;
                  if (B < L) break;
                  var K = B - L,
                      z = y - L;
                  t.push(I(R(L + K % z, 0))), B = C(K / z);
                }

                t.push(I(R(B, 0))), s = O(r, P, b == h), r = 0, ++b;
              }
            }
          } catch (e) {
            j = !0, D = e;
          } finally {
            try {
              !k && V.return && V.return();
            } finally {
              if (j) throw D;
            }
          }

          ++r, ++a;
        }

        return t.join("");
      },
          D = function D(e) {
        return A(e, function (e) {
          return T.test(e) ? k(e.slice(4).toLowerCase()) : e;
        });
      },
          U = function U(e) {
        return A(e, function (e) {
          return w.test(e) ? "xn--" + j(e) : e;
        });
      },
          V = {
        version: "2.1.0",
        ucs2: {
          decode: x,
          encode: function encode(e) {
            return String.fromCodePoint.apply(String, l(e));
          }
        },
        decode: k,
        encode: j,
        toASCII: U,
        toUnicode: D
      },
          F = {};

      function B(e) {
        var t = e.charCodeAt(0);
        return t < 16 ? "%0" + t.toString(16).toUpperCase() : t < 128 ? "%" + t.toString(16).toUpperCase() : t < 2048 ? "%" + (t >> 6 | 192).toString(16).toUpperCase() + "%" + (63 & t | 128).toString(16).toUpperCase() : "%" + (t >> 12 | 224).toString(16).toUpperCase() + "%" + (t >> 6 & 63 | 128).toString(16).toUpperCase() + "%" + (63 & t | 128).toString(16).toUpperCase();
      }

      function H(e) {
        for (var t = "", n = 0, a = e.length; n < a;) {
          var r = parseInt(e.substr(n + 1, 2), 16);
          if (r < 128) t += String.fromCharCode(r), n += 3;else if (r >= 194 && r < 224) {
            if (a - n >= 6) {
              var s = parseInt(e.substr(n + 4, 2), 16);
              t += String.fromCharCode((31 & r) << 6 | 63 & s);
            } else t += e.substr(n, 6);

            n += 6;
          } else if (r >= 224) {
            if (a - n >= 9) {
              var i = parseInt(e.substr(n + 4, 2), 16),
                  o = parseInt(e.substr(n + 7, 2), 16);
              t += String.fromCharCode((15 & r) << 12 | (63 & i) << 6 | 63 & o);
            } else t += e.substr(n, 9);

            n += 9;
          } else t += e.substr(n, 3), n += 3;
        }

        return t;
      }

      function L(e, t) {
        function n(e) {
          var n = H(e);
          return n.match(t.UNRESERVED) ? n : e;
        }

        return e.scheme && (e.scheme = String(e.scheme).replace(t.PCT_ENCODED, n).toLowerCase().replace(t.NOT_SCHEME, "")), void 0 !== e.userinfo && (e.userinfo = String(e.userinfo).replace(t.PCT_ENCODED, n).replace(t.NOT_USERINFO, B).replace(t.PCT_ENCODED, r)), void 0 !== e.host && (e.host = String(e.host).replace(t.PCT_ENCODED, n).toLowerCase().replace(t.NOT_HOST, B).replace(t.PCT_ENCODED, r)), void 0 !== e.path && (e.path = String(e.path).replace(t.PCT_ENCODED, n).replace(e.scheme ? t.NOT_PATH : t.NOT_PATH_NOSCHEME, B).replace(t.PCT_ENCODED, r)), void 0 !== e.query && (e.query = String(e.query).replace(t.PCT_ENCODED, n).replace(t.NOT_QUERY, B).replace(t.PCT_ENCODED, r)), void 0 !== e.fragment && (e.fragment = String(e.fragment).replace(t.PCT_ENCODED, n).replace(t.NOT_FRAGMENT, B).replace(t.PCT_ENCODED, r)), e;
      }

      function K(e) {
        return e.replace(/^0*(.*)/, "$1") || "0";
      }

      function z(e, t) {
        var n = e.match(t.IPV4ADDRESS) || [],
            a = d(n, 2)[1];
        return a ? a.split(".").map(K).join(".") : e;
      }

      function q(e, t) {
        var n = e.match(t.IPV6ADDRESS) || [],
            a = d(n, 3),
            r = a[1],
            s = a[2];

        if (r) {
          for (var i = r.toLowerCase().split("::").reverse(), o = d(i, 2), p = o[0], u = o[1], l = u ? u.split(":").map(K) : [], c = p.split(":").map(K), y = t.IPV4ADDRESS.test(c[c.length - 1]), m = y ? 7 : 8, f = c.length - m, h = Array(m), b = 0; b < m; ++b) {
            h[b] = l[b] || c[f + b] || "";
          }

          y && (h[m - 1] = z(h[m - 1], t));
          var v = h.reduce(function (e, t, n) {
            if (!t || "0" === t) {
              var a = e[e.length - 1];
              a && a.index + a.length === n ? a.length++ : e.push({
                index: n,
                length: 1
              });
            }

            return e;
          }, []).sort(function (e, t) {
            return t.length - e.length;
          })[0],
              g = void 0;

          if (v && v.length > 1) {
            var _ = h.slice(0, v.index),
                T = h.slice(v.index + v.length);

            g = _.join(":") + "::" + T.join(":");
          } else g = h.join(":");

          return s && (g += "%" + s), g;
        }

        return e;
      }

      var G = /^(?:([^:\/?#]+):)?(?:\/\/((?:([^\/?#@]*)@)?(\[[^\/?#\]]+\]|[^\/?#:]*)(?:\:(\d*))?))?([^?#]*)(?:\?([^#]*))?(?:#((?:.|\n|\r)*))?/i,
          J = void 0 === "".match(/(){0}/)[1];

      function Y(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = {},
            a = !1 !== t.iri ? u : p;
        "suffix" === t.reference && (e = (t.scheme ? t.scheme + ":" : "") + "//" + e);
        var r = e.match(G);

        if (r) {
          J ? (n.scheme = r[1], n.userinfo = r[3], n.host = r[4], n.port = parseInt(r[5], 10), n.path = r[6] || "", n.query = r[7], n.fragment = r[8], isNaN(n.port) && (n.port = r[5])) : (n.scheme = r[1] || void 0, n.userinfo = -1 !== e.indexOf("@") ? r[3] : void 0, n.host = -1 !== e.indexOf("//") ? r[4] : void 0, n.port = parseInt(r[5], 10), n.path = r[6] || "", n.query = -1 !== e.indexOf("?") ? r[7] : void 0, n.fragment = -1 !== e.indexOf("#") ? r[8] : void 0, isNaN(n.port) && (n.port = e.match(/\/\/(?:.|\n)*\:(?:\/|\?|\#|$)/) ? r[4] : void 0)), n.host && (n.host = q(z(n.host, a), a)), void 0 !== n.scheme || void 0 !== n.userinfo || void 0 !== n.host || void 0 !== n.port || n.path || void 0 !== n.query ? void 0 === n.scheme ? n.reference = "relative" : void 0 === n.fragment ? n.reference = "absolute" : n.reference = "uri" : n.reference = "same-document", t.reference && "suffix" !== t.reference && t.reference !== n.reference && (n.error = n.error || "URI is not a " + t.reference + " reference.");
          var s = F[(t.scheme || n.scheme || "").toLowerCase()];
          if (t.unicodeSupport || s && s.unicodeSupport) L(n, a);else {
            if (n.host && (t.domainHost || s && s.domainHost)) try {
              n.host = V.toASCII(n.host.replace(a.PCT_ENCODED, H).toLowerCase());
            } catch (e) {
              n.error = n.error || "Host's domain name can not be converted to ASCII via punycode: " + e;
            }
            L(n, p);
          }
          s && s.parse && s.parse(n, t);
        } else n.error = n.error || "URI can not be parsed.";

        return n;
      }

      function W(e, t) {
        var n = !1 !== t.iri ? u : p,
            a = [];
        return void 0 !== e.userinfo && (a.push(e.userinfo), a.push("@")), void 0 !== e.host && a.push(q(z(String(e.host), n), n).replace(n.IPV6ADDRESS, function (e, t, n) {
          return "[" + t + (n ? "%25" + n : "") + "]";
        })), "number" != typeof e.port && "string" != typeof e.port || (a.push(":"), a.push(String(e.port))), a.length ? a.join("") : void 0;
      }

      var Q = /^\.\.?\//,
          Z = /^\/\.(\/|$)/,
          X = /^\/\.\.(\/|$)/,
          ee = /^\/?(?:.|\n)*?(?=\/|$)/;

      function te(e) {
        for (var t = []; e.length;) {
          if (e.match(Q)) e = e.replace(Q, "");else if (e.match(Z)) e = e.replace(Z, "/");else if (e.match(X)) e = e.replace(X, "/"), t.pop();else if ("." === e || ".." === e) e = "";else {
            var n = e.match(ee);
            if (!n) throw new Error("Unexpected dot segment condition");
            var a = n[0];
            e = e.slice(a.length), t.push(a);
          }
        }

        return t.join("");
      }

      function ne(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = t.iri ? u : p,
            a = [],
            r = F[(t.scheme || e.scheme || "").toLowerCase()];
        if (r && r.serialize && r.serialize(e, t), e.host) if (n.IPV6ADDRESS.test(e.host)) ;else if (t.domainHost || r && r.domainHost) try {
          e.host = t.iri ? V.toUnicode(e.host) : V.toASCII(e.host.replace(n.PCT_ENCODED, H).toLowerCase());
        } catch (n) {
          e.error = e.error || "Host's domain name can not be converted to " + (t.iri ? "Unicode" : "ASCII") + " via punycode: " + n;
        }
        L(e, n), "suffix" !== t.reference && e.scheme && (a.push(e.scheme), a.push(":"));
        var s = W(e, t);

        if (void 0 !== s && ("suffix" !== t.reference && a.push("//"), a.push(s), e.path && "/" !== e.path.charAt(0) && a.push("/")), void 0 !== e.path) {
          var i = e.path;
          t.absolutePath || r && r.absolutePath || (i = te(i)), void 0 === s && (i = i.replace(/^\/\//, "/%2F")), a.push(i);
        }

        return void 0 !== e.query && (a.push("?"), a.push(e.query)), void 0 !== e.fragment && (a.push("#"), a.push(e.fragment)), a.join("");
      }

      function ae(e, t) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            a = {};
        return arguments[3] || (e = Y(ne(e, n), n), t = Y(ne(t, n), n)), !(n = n || {}).tolerant && t.scheme ? (a.scheme = t.scheme, a.userinfo = t.userinfo, a.host = t.host, a.port = t.port, a.path = te(t.path || ""), a.query = t.query) : (void 0 !== t.userinfo || void 0 !== t.host || void 0 !== t.port ? (a.userinfo = t.userinfo, a.host = t.host, a.port = t.port, a.path = te(t.path || ""), a.query = t.query) : (t.path ? ("/" === t.path.charAt(0) ? a.path = te(t.path) : (void 0 === e.userinfo && void 0 === e.host && void 0 === e.port || e.path ? e.path ? a.path = e.path.slice(0, e.path.lastIndexOf("/") + 1) + t.path : a.path = t.path : a.path = "/" + t.path, a.path = te(a.path)), a.query = t.query) : (a.path = e.path, void 0 !== t.query ? a.query = t.query : a.query = e.query), a.userinfo = e.userinfo, a.host = e.host, a.port = e.port), a.scheme = e.scheme), a.fragment = t.fragment, a;
      }

      function re(e, t, n) {
        var a = i({
          scheme: "null"
        }, n);
        return ne(ae(Y(e, a), Y(t, a), a, !0), a);
      }

      function se(e, t) {
        return "string" == typeof e ? e = ne(Y(e, t), t) : "object" === a(e) && (e = Y(ne(e, t), t)), e;
      }

      function ie(e, t, n) {
        return "string" == typeof e ? e = ne(Y(e, n), n) : "object" === a(e) && (e = ne(e, n)), "string" == typeof t ? t = ne(Y(t, n), n) : "object" === a(t) && (t = ne(t, n)), e === t;
      }

      function oe(e, t) {
        return e && e.toString().replace(t && t.iri ? u.ESCAPE : p.ESCAPE, B);
      }

      function pe(e, t) {
        return e && e.toString().replace(t && t.iri ? u.PCT_ENCODED : p.PCT_ENCODED, H);
      }

      var ue = {
        scheme: "http",
        domainHost: !0,
        parse: function parse(e, t) {
          return e.host || (e.error = e.error || "HTTP URIs must have a host."), e;
        },
        serialize: function serialize(e, t) {
          var n = "https" === String(e.scheme).toLowerCase();
          return e.port !== (n ? 443 : 80) && "" !== e.port || (e.port = void 0), e.path || (e.path = "/"), e;
        }
      },
          de = {
        scheme: "https",
        domainHost: ue.domainHost,
        parse: ue.parse,
        serialize: ue.serialize
      };

      function le(e) {
        return "boolean" == typeof e.secure ? e.secure : "wss" === String(e.scheme).toLowerCase();
      }

      var ce = {
        scheme: "ws",
        domainHost: !0,
        parse: function parse(e, t) {
          var n = e;
          return n.secure = le(n), n.resourceName = (n.path || "/") + (n.query ? "?" + n.query : ""), n.path = void 0, n.query = void 0, n;
        },
        serialize: function serialize(e, t) {
          if (e.port !== (le(e) ? 443 : 80) && "" !== e.port || (e.port = void 0), "boolean" == typeof e.secure && (e.scheme = e.secure ? "wss" : "ws", e.secure = void 0), e.resourceName) {
            var n = e.resourceName.split("?"),
                a = d(n, 2),
                r = a[0],
                s = a[1];
            e.path = r && "/" !== r ? r : void 0, e.query = s, e.resourceName = void 0;
          }

          return e.fragment = void 0, e;
        }
      },
          ye = {
        scheme: "wss",
        domainHost: ce.domainHost,
        parse: ce.parse,
        serialize: ce.serialize
      },
          me = {},
          fe = "[A-Za-z0-9\\-\\.\\_\\~\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]",
          he = "[0-9A-Fa-f]",
          be = n(n("%[EFef]" + he + "%" + he + he + "%" + he + he) + "|" + n("%[89A-Fa-f]" + he + "%" + he + he) + "|" + n("%" + he + he)),
          ve = "[A-Za-z0-9\\!\\$\\%\\'\\*\\+\\-\\^\\_\\`\\{\\|\\}\\~]",
          ge = t("[\\!\\$\\%\\'\\(\\)\\*\\+\\,\\-\\.0-9\\<\\>A-Z\\x5E-\\x7E]", '[\\"\\\\]'),
          _e = "[\\!\\$\\'\\(\\)\\*\\+\\,\\;\\:\\@]",
          Te = new RegExp(fe, "g"),
          we = new RegExp(be, "g"),
          Ee = new RegExp(t("[^]", ve, "[\\.]", '[\\"]', ge), "g"),
          $e = new RegExp(t("[^]", fe, _e), "g"),
          Me = $e;

      function Ce(e) {
        var t = H(e);
        return t.match(Te) ? t : e;
      }

      var Ie = {
        scheme: "mailto",
        parse: function parse(e, t) {
          var n = e,
              a = n.to = n.path ? n.path.split(",") : [];

          if (n.path = void 0, n.query) {
            for (var r = !1, s = {}, i = n.query.split("&"), o = 0, p = i.length; o < p; ++o) {
              var u = i[o].split("=");

              switch (u[0]) {
                case "to":
                  for (var d = u[1].split(","), l = 0, c = d.length; l < c; ++l) {
                    a.push(d[l]);
                  }

                  break;

                case "subject":
                  n.subject = pe(u[1], t);
                  break;

                case "body":
                  n.body = pe(u[1], t);
                  break;

                default:
                  r = !0, s[pe(u[0], t)] = pe(u[1], t);
              }
            }

            r && (n.headers = s);
          }

          n.query = void 0;

          for (var y = 0, m = a.length; y < m; ++y) {
            var f = a[y].split("@");
            if (f[0] = pe(f[0]), t.unicodeSupport) f[1] = pe(f[1], t).toLowerCase();else try {
              f[1] = V.toASCII(pe(f[1], t).toLowerCase());
            } catch (e) {
              n.error = n.error || "Email address's domain name can not be converted to ASCII via punycode: " + e;
            }
            a[y] = f.join("@");
          }

          return n;
        },
        serialize: function serialize(e, t) {
          var n = e,
              a = s(e.to);

          if (a) {
            for (var i = 0, o = a.length; i < o; ++i) {
              var p = String(a[i]),
                  u = p.lastIndexOf("@"),
                  d = p.slice(0, u).replace(we, Ce).replace(we, r).replace(Ee, B),
                  l = p.slice(u + 1);

              try {
                l = t.iri ? V.toUnicode(l) : V.toASCII(pe(l, t).toLowerCase());
              } catch (e) {
                n.error = n.error || "Email address's domain name can not be converted to " + (t.iri ? "Unicode" : "ASCII") + " via punycode: " + e;
              }

              a[i] = d + "@" + l;
            }

            n.path = a.join(",");
          }

          var c = e.headers = e.headers || {};
          e.subject && (c.subject = e.subject), e.body && (c.body = e.body);
          var y = [];

          for (var m in c) {
            c[m] !== me[m] && y.push(m.replace(we, Ce).replace(we, r).replace($e, B) + "=" + c[m].replace(we, Ce).replace(we, r).replace(Me, B));
          }

          return y.length && (n.query = y.join("&")), n;
        }
      },
          Ne = /^([^\:]+)\:(.*)/,
          Se = {
        scheme: "urn",
        parse: function parse(e, t) {
          var n = e.path && e.path.match(Ne),
              a = e;

          if (n) {
            var r = t.scheme || a.scheme || "urn",
                s = n[1].toLowerCase(),
                i = n[2],
                o = r + ":" + (t.nid || s),
                p = F[o];
            a.nid = s, a.nss = i, a.path = void 0, p && (a = p.parse(a, t));
          } else a.error = a.error || "URN can not be parsed.";

          return a;
        },
        serialize: function serialize(e, t) {
          var n = t.scheme || e.scheme || "urn",
              a = e.nid,
              r = n + ":" + (t.nid || a),
              s = F[r];
          s && (e = s.serialize(e, t));
          var i = e,
              o = e.nss;
          return i.path = (a || t.nid) + ":" + o, i;
        }
      },
          Ae = /^[0-9A-Fa-f]{8}(?:\-[0-9A-Fa-f]{4}){3}\-[0-9A-Fa-f]{12}$/,
          xe = {
        scheme: "urn:uuid",
        parse: function parse(e, t) {
          var n = e;
          return n.uuid = n.nss, n.nss = void 0, t.tolerant || n.uuid && n.uuid.match(Ae) || (n.error = n.error || "UUID is not valid."), n;
        },
        serialize: function serialize(e, t) {
          var n = e;
          return n.nss = (e.uuid || "").toLowerCase(), n;
        }
      };
      F[ue.scheme] = ue, F[de.scheme] = de, F[ce.scheme] = ce, F[ye.scheme] = ye, F[Ie.scheme] = Ie, F[Se.scheme] = Se, F[xe.scheme] = xe, e.SCHEMES = F, e.pctEncChar = B, e.pctDecChars = H, e.parse = Y, e.removeDotSegments = te, e.serialize = ne, e.resolveComponents = ae, e.resolve = re, e.normalize = se, e.equal = ie, e.escapeComponent = oe, e.unescapeComponent = pe, Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }(t);
  });

  r(w);
  var E = s(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getSchemaRefs = t.resolveUrl = t.normalizeId = t._getFullPath = t.getFullPath = t.inlineRef = void 0;
    var n = new Set(["type", "format", "pattern", "maxLength", "minLength", "maxProperties", "minProperties", "maxItems", "minItems", "maximum", "minimum", "uniqueItems", "multipleOf", "required", "enum", "const"]);

    t.inlineRef = function (e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      return "boolean" == typeof e || (!0 === t ? !r(e) : !!t && s(e) <= t);
    };

    var a = new Set(["$ref", "$recursiveRef", "$recursiveAnchor", "$dynamicRef", "$dynamicAnchor"]);

    function r(e) {
      for (var _t2 in e) {
        if (a.has(_t2)) return !0;
        var _n12 = e[_t2];
        if (Array.isArray(_n12) && _n12.some(r)) return !0;
        if ("object" == typeof _n12 && r(_n12)) return !0;
      }

      return !1;
    }

    function s(e) {
      var t = 0;

      for (var _a3 in e) {
        if ("$ref" === _a3) return 1 / 0;
        if (t++, !n.has(_a3) && ("object" == typeof e[_a3] && M.eachItem(e[_a3], function (e) {
          return t += s(e);
        }), t === 1 / 0)) return 1 / 0;
      }

      return t;
    }

    function i() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      var t = arguments.length > 1 ? arguments[1] : undefined;
      !1 !== t && (e = u(e));
      return o(w.parse(e));
    }

    function o(e) {
      return w.serialize(e).split("#")[0] + "#";
    }

    t.getFullPath = i, t._getFullPath = o;
    var p = /#\/?$/;

    function u(e) {
      return e ? e.replace(p, "") : "";
    }

    t.normalizeId = u, t.resolveUrl = function (e, t) {
      return t = u(t), w.resolve(e, t);
    };
    var d = /^[a-z_][-a-z0-9._]*$/i;

    t.getSchemaRefs = function (e) {
      var _this22 = this;

      if ("boolean" == typeof e) return {};
      var t = u(e.$id),
          n = {
        "": t
      },
          a = i(t, !1),
          r = {},
          s = new Set();
      return T(e, {
        allKeys: !0
      }, function (e, t, i, l) {
        if (void 0 === l) return;
        var c = a + t;
        var y = n[l];

        function m(t) {
          if (t = u(y ? w.resolve(y, t) : t), s.has(t)) throw p(t);
          s.add(t);
          var n = this.refs[t];
          return "string" == typeof n && (n = this.refs[n]), "object" == typeof n ? o(e, n.schema, t) : t !== u(c) && ("#" === t[0] ? (o(e, r[t], t), r[t] = e) : this.refs[t] = c), t;
        }

        function f(e) {
          if ("string" == typeof e) {
            if (!d.test(e)) throw new Error("invalid anchor \"".concat(e, "\""));
            m.call(this, "#".concat(e));
          }
        }

        "string" == typeof e.$id && (y = m.call(_this22, e.$id)), f.call(_this22, e.$anchor), f.call(_this22, e.$dynamicAnchor), n[t] = y;
      }), r;

      function o(e, t, n) {
        if (void 0 !== t && !_(e, t)) throw p(n);
      }

      function p(e) {
        return new Error("reference \"".concat(e, "\" resolves to more than one schema"));
      }
    };
  });
  r(E), E.getSchemaRefs, E.resolveUrl, E.normalizeId, E._getFullPath, E.getFullPath, E.inlineRef;
  var $ = s(function (e, t) {
    function n(_ref22, i) {
      var e = _ref22.gen,
          t = _ref22.validateName,
          n = _ref22.schema,
          r = _ref22.schemaEnv,
          s = _ref22.opts;
      s.code.es5 ? e.func(t, l._(_templateObject77 || (_templateObject77 = _taggedTemplateLiteral(["", ", ", ""])), c.default.data, c.default.valCxt), r.$async, function () {
        e.code(l._(_templateObject78 || (_templateObject78 = _taggedTemplateLiteral(["\"use strict\"; ", ""])), a(n, s))), function (e, t) {
          e.if(c.default.valCxt, function () {
            e.var(c.default.dataPath, l._(_templateObject79 || (_templateObject79 = _taggedTemplateLiteral(["", ".", ""])), c.default.valCxt, c.default.dataPath)), e.var(c.default.parentData, l._(_templateObject80 || (_templateObject80 = _taggedTemplateLiteral(["", ".", ""])), c.default.valCxt, c.default.parentData)), e.var(c.default.parentDataProperty, l._(_templateObject81 || (_templateObject81 = _taggedTemplateLiteral(["", ".", ""])), c.default.valCxt, c.default.parentDataProperty)), e.var(c.default.rootData, l._(_templateObject82 || (_templateObject82 = _taggedTemplateLiteral(["", ".", ""])), c.default.valCxt, c.default.rootData)), t.dynamicRef && e.var(c.default.dynamicAnchors, l._(_templateObject83 || (_templateObject83 = _taggedTemplateLiteral(["", ".", ""])), c.default.valCxt, c.default.dynamicAnchors));
          }, function () {
            e.var(c.default.dataPath, l._(_templateObject84 || (_templateObject84 = _taggedTemplateLiteral(["\"\""])))), e.var(c.default.parentData, l._(_templateObject85 || (_templateObject85 = _taggedTemplateLiteral(["undefined"])))), e.var(c.default.parentDataProperty, l._(_templateObject86 || (_templateObject86 = _taggedTemplateLiteral(["undefined"])))), e.var(c.default.rootData, c.default.data), t.dynamicRef && e.var(c.default.dynamicAnchors, l._(_templateObject87 || (_templateObject87 = _taggedTemplateLiteral(["{}"]))));
          });
        }(e, s), e.code(i);
      }) : e.func(t, l._(_templateObject88 || (_templateObject88 = _taggedTemplateLiteral(["", ", ", ""])), c.default.data, function (e) {
        return l._(_templateObject89 || (_templateObject89 = _taggedTemplateLiteral(["{", "=\"\", ", ", ", ", ", "=", "", "}={}"])), c.default.dataPath, c.default.parentData, c.default.parentDataProperty, c.default.rootData, c.default.data, e.dynamicRef ? l._(_templateObject90 || (_templateObject90 = _taggedTemplateLiteral([", ", "={}"])), c.default.dynamicAnchors) : l.nil);
      }(s)), r.$async, function () {
        return e.code(a(n, s)).code(i);
      });
    }

    function a(e, t) {
      return "object" == typeof e && e.$id && (t.code.source || t.code.process) ? l._(_templateObject91 || (_templateObject91 = _taggedTemplateLiteral(["/*# sourceURL=", " */"])), e.$id) : l.nil;
    }

    function r(_ref23) {
      var e = _ref23.schema,
          t = _ref23.self;
      if ("boolean" == typeof e) return !e;

      for (var _n13 in e) {
        if (t.RULES.all[_n13]) return !0;
      }

      return !1;
    }

    function s(e) {
      return "boolean" != typeof e.schema;
    }

    function i(e) {
      M.checkUnknownRules(e), function (e) {
        var t = e.schema,
            n = e.errSchemaPath,
            a = e.opts,
            r = e.self;
        t.$ref && a.ignoreKeywordsWithRef && M.schemaHasRulesButRef(t, r.RULES) && r.logger.warn("$ref: keywords ignored in schema at path \"".concat(n, "\""));
      }(e);
    }

    function o(e, t) {
      if (e.opts.jtd) return g.schemaKeywords(e, [], !1, t);
      var n = C.getSchemaTypes(e.schema),
          a = C.coerceAndCheckDataType(e, n);
      g.schemaKeywords(e, n, !a, t);
    }

    function p(_ref24) {
      var e = _ref24.gen,
          t = _ref24.schemaEnv,
          n = _ref24.schema,
          a = _ref24.errSchemaPath,
          r = _ref24.opts;
      var s = n.$comment;
      if (!0 === r.$comment) e.code(l._(_templateObject92 || (_templateObject92 = _taggedTemplateLiteral(["", ".logger.log(", ")"])), c.default.self, s));else if ("function" == typeof r.$comment) {
        var _n14 = l.str(_templateObject93 || (_templateObject93 = _taggedTemplateLiteral(["", "/$comment"])), a),
            _r12 = e.scopeValue("root", {
          ref: t.root
        });

        e.code(l._(_templateObject94 || (_templateObject94 = _taggedTemplateLiteral(["", ".opts.$comment(", ", ", ", ", ".schema)"])), c.default.self, s, _n14, _r12));
      }
    }

    function u(e, t) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : e.opts.strict;

      if (n) {
        if (t = "strict mode: ".concat(t), !0 === n) throw new Error(t);
        e.self.logger.warn(t);
      }
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.checkStrictMode = t.schemaCxtHasRules = t.subschemaCode = t.validateFunctionCode = void 0, t.validateFunctionCode = function (e) {
      s(e) && (i(e), r(e)) ? function (e) {
        var t = e.schema,
            a = e.opts,
            r = e.gen;
        n(e, function () {
          a.$comment && t.$comment && p(e), function (e) {
            var t = e.schema,
                n = e.opts;
            void 0 !== t.default && n.useDefaults && n.strict && u(e, "default is ignored in the schema root");
          }(e), r.let(c.default.vErrors, null), r.let(c.default.errors, 0), a.unevaluated && function (e) {
            var t = e.gen,
                n = e.validateName;
            e.evaluated = t.const("evaluated", l._(_templateObject95 || (_templateObject95 = _taggedTemplateLiteral(["", ".evaluated"])), n)), t.if(l._(_templateObject96 || (_templateObject96 = _taggedTemplateLiteral(["", ".dynamicProps"])), e.evaluated), function () {
              return t.assign(l._(_templateObject97 || (_templateObject97 = _taggedTemplateLiteral(["", ".props"])), e.evaluated), l._(_templateObject98 || (_templateObject98 = _taggedTemplateLiteral(["undefined"]))));
            }), t.if(l._(_templateObject99 || (_templateObject99 = _taggedTemplateLiteral(["", ".dynamicItems"])), e.evaluated), function () {
              return t.assign(l._(_templateObject100 || (_templateObject100 = _taggedTemplateLiteral(["", ".items"])), e.evaluated), l._(_templateObject101 || (_templateObject101 = _taggedTemplateLiteral(["undefined"]))));
            });
          }(e), o(e), function (e) {
            var t = e.gen,
                n = e.schemaEnv,
                a = e.validateName,
                r = e.ValidationError,
                s = e.opts;
            n.$async ? t.if(l._(_templateObject102 || (_templateObject102 = _taggedTemplateLiteral(["", " === 0"])), c.default.errors), function () {
              return t.return(c.default.data);
            }, function () {
              return t.throw(l._(_templateObject103 || (_templateObject103 = _taggedTemplateLiteral(["new ", "(", ")"])), r, c.default.vErrors));
            }) : (t.assign(l._(_templateObject104 || (_templateObject104 = _taggedTemplateLiteral(["", ".errors"])), a), c.default.vErrors), s.unevaluated && function (_ref25) {
              var e = _ref25.gen,
                  t = _ref25.evaluated,
                  n = _ref25.props,
                  a = _ref25.items;
              n instanceof l.Name && e.assign(l._(_templateObject105 || (_templateObject105 = _taggedTemplateLiteral(["", ".props"])), t), n);
              a instanceof l.Name && e.assign(l._(_templateObject106 || (_templateObject106 = _taggedTemplateLiteral(["", ".items"])), t), a);
            }(e), t.return(l._(_templateObject107 || (_templateObject107 = _taggedTemplateLiteral(["", " === 0"])), c.default.errors)));
          }(e);
        });
      }(e) : n(e, function () {
        return m.topBoolOrEmptySchema(e);
      });
    }, t.subschemaCode = function (e, t) {
      s(e) && (i(e), r(e)) ? function (e, t) {
        var n = e.schema,
            a = e.gen,
            r = e.opts;
        r.$comment && n.$comment && p(e);
        (function (e) {
          e.schema.$id && (e.baseId = E.resolveUrl(e.baseId, e.schema.$id));
        })(e), function (e) {
          if (e.schema.$async && !e.schemaEnv.$async) throw new Error("async schema in sync schema");
        }(e);
        var s = a.const("_errs", c.default.errors);
        o(e, s), a.var(t, l._(_templateObject108 || (_templateObject108 = _taggedTemplateLiteral(["", " === ", ""])), s, c.default.errors));
      }(e, t) : m.boolOrEmptySchema(e, t);
    }, t.schemaCxtHasRules = r, t.checkStrictMode = u;
  });
  r($), $.checkStrictMode, $.schemaCxtHasRules, $.subschemaCode, $.validateFunctionCode;
  var M = s(function (e, t) {
    function n(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : e.schema;
      var n = e.opts,
          a = e.self;
      if (!n.strict) return;
      if ("boolean" == typeof t) return;
      var r = a.RULES.keywords;

      for (var _n15 in t) {
        r[_n15] || $.checkStrictMode(e, "unknown keyword: \"".concat(_n15, "\""));
      }
    }

    function a(e, t) {
      if ("boolean" == typeof e) return !e;

      for (var _n16 in e) {
        if (t[_n16]) return !0;
      }

      return !1;
    }

    function r(e) {
      return "number" == typeof e ? "".concat(e) : e.replace(/~/g, "~0").replace(/\//g, "~1");
    }

    function s(e) {
      return e.replace(/~1/g, "/").replace(/~0/g, "~");
    }

    function i(_ref26) {
      var e = _ref26.mergeNames,
          t = _ref26.mergeToName,
          n = _ref26.mergeValues,
          a = _ref26.resultToName;
      return function (r, s, i, o) {
        var p = void 0 === i ? s : i instanceof l.Name ? (s instanceof l.Name ? e(r, s, i) : t(r, s, i), i) : s instanceof l.Name ? (t(r, i, s), s) : n(s, i);
        return o !== l.Name || p instanceof l.Name ? p : a(r, p);
      };
    }

    function o(e, t) {
      if (!0 === t) return e.var("props", !0);
      var n = e.var("props", l._(_templateObject109 || (_templateObject109 = _taggedTemplateLiteral(["{}"]))));
      return void 0 !== t && p(e, n, t), n;
    }

    function p(e, t, n) {
      Object.keys(n).forEach(function (n) {
        return e.assign(l._(_templateObject110 || (_templateObject110 = _taggedTemplateLiteral(["", "", ""])), t, l.getProperty(n)), !0);
      });
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.func = t.setEvaluated = t.evaluatedPropsToName = t.mergeEvaluated = t.eachItem = t.unescapeJsonPointer = t.escapeJsonPointer = t.escapeFragment = t.unescapeFragment = t.schemaRefOrVal = t.schemaHasRulesButRef = t.schemaHasRules = t.checkUnknownRules = t.alwaysValidSchema = t.toHash = void 0, t.toHash = function (e) {
      var t = {};

      var _iterator3 = _createForOfIteratorHelper(e),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _n17 = _step3.value;
          t[_n17] = !0;
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      return t;
    }, t.alwaysValidSchema = function (e, t) {
      return "boolean" == typeof t ? t : 0 === Object.keys(t).length || (n(e, t), !a(t, e.self.RULES.all));
    }, t.checkUnknownRules = n, t.schemaHasRules = a, t.schemaHasRulesButRef = function (e, t) {
      if ("boolean" == typeof e) return !e;

      for (var _n18 in e) {
        if ("$ref" !== _n18 && t.all[_n18]) return !0;
      }

      return !1;
    }, t.schemaRefOrVal = function (_ref27, n, a, r) {
      var e = _ref27.topSchemaRef,
          t = _ref27.schemaPath;

      if (!r) {
        if ("number" == typeof n || "boolean" == typeof n) return n;
        if ("string" == typeof n) return l._(_templateObject111 || (_templateObject111 = _taggedTemplateLiteral(["", ""])), n);
      }

      return l._(_templateObject112 || (_templateObject112 = _taggedTemplateLiteral(["", "", "", ""])), e, t, l.getProperty(a));
    }, t.unescapeFragment = function (e) {
      return s(decodeURIComponent(e));
    }, t.escapeFragment = function (e) {
      return encodeURIComponent(r(e));
    }, t.escapeJsonPointer = r, t.unescapeJsonPointer = s, t.eachItem = function (e, t) {
      if (Array.isArray(e)) {
        var _iterator4 = _createForOfIteratorHelper(e),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var _n19 = _step4.value;
            t(_n19);
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      } else t(e);
    }, t.mergeEvaluated = {
      props: i({
        mergeNames: function mergeNames(e, t, n) {
          return e.if(l._(_templateObject113 || (_templateObject113 = _taggedTemplateLiteral(["", " !== true && ", " !== undefined"])), n, t), function () {
            e.if(l._(_templateObject114 || (_templateObject114 = _taggedTemplateLiteral(["", " === true"])), t), function () {
              return e.assign(n, !0);
            }, function () {
              return e.assign(n, l._(_templateObject115 || (_templateObject115 = _taggedTemplateLiteral(["", " || {}"])), n)).code(l._(_templateObject116 || (_templateObject116 = _taggedTemplateLiteral(["Object.assign(", ", ", ")"])), n, t));
            });
          });
        },
        mergeToName: function mergeToName(e, t, n) {
          return e.if(l._(_templateObject117 || (_templateObject117 = _taggedTemplateLiteral(["", " !== true"])), n), function () {
            !0 === t ? e.assign(n, !0) : (e.assign(n, l._(_templateObject118 || (_templateObject118 = _taggedTemplateLiteral(["", " || {}"])), n)), p(e, n, t));
          });
        },
        mergeValues: function mergeValues(e, t) {
          return !0 === e || _objectSpread({}, e, t);
        },
        resultToName: o
      }),
      items: i({
        mergeNames: function mergeNames(e, t, n) {
          return e.if(l._(_templateObject119 || (_templateObject119 = _taggedTemplateLiteral(["", " !== true && ", " !== undefined"])), n, t), function () {
            return e.assign(n, l._(_templateObject120 || (_templateObject120 = _taggedTemplateLiteral(["", " === true ? true : ", " > ", " ? ", " : ", ""])), t, n, t, n, t));
          });
        },
        mergeToName: function mergeToName(e, t, n) {
          return e.if(l._(_templateObject121 || (_templateObject121 = _taggedTemplateLiteral(["", " !== true"])), n), function () {
            return e.assign(n, !0 === t || l._(_templateObject122 || (_templateObject122 = _taggedTemplateLiteral(["", " > ", " ? ", " : ", ""])), n, t, n, t));
          });
        },
        mergeValues: function mergeValues(e, t) {
          return !0 === e || Math.max(e, t);
        },
        resultToName: function resultToName(e, t) {
          return e.var("items", t);
        }
      })
    }, t.evaluatedPropsToName = o, t.setEvaluated = p, t.func = function (e, t) {
      return e.scopeValue("func", {
        ref: t,
        code: t.code
      });
    };
  });
  r(M), M.func, M.setEvaluated, M.evaluatedPropsToName, M.mergeEvaluated, M.eachItem, M.unescapeJsonPointer, M.escapeJsonPointer, M.escapeFragment, M.unescapeFragment, M.schemaRefOrVal, M.schemaHasRulesButRef, M.schemaHasRules, M.checkUnknownRules, M.alwaysValidSchema, M.toHash;
  var C = s(function (e, t) {
    var n;

    function a(e) {
      var t = Array.isArray(e) ? e : e ? [e] : [];
      if (t.every(o.isJSONType)) return t;
      throw new Error("type must be JSONType or JSONType[]: " + t.join(","));
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.reportTypeError = t.checkDataTypes = t.checkDataType = t.coerceAndCheckDataType = t.getJSONTypes = t.getSchemaTypes = t.DataType = void 0, function (e) {
      e[e.Correct = 0] = "Correct", e[e.Wrong = 1] = "Wrong";
    }(n = t.DataType || (t.DataType = {})), t.getSchemaTypes = function (e) {
      var t = a(e.type);

      if (t.includes("null")) {
        if (!1 === e.nullable) throw new Error("type: null contradicts nullable: false");
      } else {
        if (!t.length && void 0 !== e.nullable) throw new Error('"nullable" cannot be used without "type"');
        !0 === e.nullable && t.push("null");
      }

      return t;
    }, t.getJSONTypes = a, t.coerceAndCheckDataType = function (e, t) {
      var a = e.gen,
          s = e.data,
          o = e.opts,
          u = function (e, t) {
        return t ? e.filter(function (e) {
          return r.has(e) || "array" === t && "array" === e;
        }) : [];
      }(t, o.coerceTypes),
          c = t.length > 0 && !(0 === u.length && 1 === t.length && p.schemaHasRulesForType(e, t[0]));

      if (c) {
        var _p2 = i(t, s, o.strict, n.Wrong);

        a.if(_p2, function () {
          u.length ? function (e, t, n) {
            var a = e.gen,
                s = e.data,
                o = e.opts,
                p = a.let("dataType", l._(_templateObject123 || (_templateObject123 = _taggedTemplateLiteral(["typeof ", ""])), s)),
                u = a.let("coerced", l._(_templateObject124 || (_templateObject124 = _taggedTemplateLiteral(["undefined"]))));
            "array" === o.coerceTypes && a.if(l._(_templateObject125 || (_templateObject125 = _taggedTemplateLiteral(["", " == 'object' && Array.isArray(", ") && ", ".length == 1"])), p, s, s), function () {
              return a.assign(s, l._(_templateObject126 || (_templateObject126 = _taggedTemplateLiteral(["", "[0]"])), s)).assign(p, l._(_templateObject127 || (_templateObject127 = _taggedTemplateLiteral(["typeof ", ""])), s)).if(i(t, s, o.strict), function () {
                return a.assign(u, s);
              });
            });
            a.if(l._(_templateObject128 || (_templateObject128 = _taggedTemplateLiteral(["", " !== undefined"])), u));

            var _iterator5 = _createForOfIteratorHelper(n),
                _step5;

            try {
              for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                var _e9 = _step5.value;
                (r.has(_e9) || "array" === _e9 && "array" === o.coerceTypes) && c(_e9);
              }
            } catch (err) {
              _iterator5.e(err);
            } finally {
              _iterator5.f();
            }

            function c(e) {
              switch (e) {
                case "string":
                  return void a.elseIf(l._(_templateObject129 || (_templateObject129 = _taggedTemplateLiteral(["", " == \"number\" || ", " == \"boolean\""])), p, p)).assign(u, l._(_templateObject130 || (_templateObject130 = _taggedTemplateLiteral(["\"\" + ", ""])), s)).elseIf(l._(_templateObject131 || (_templateObject131 = _taggedTemplateLiteral(["", " === null"])), s)).assign(u, l._(_templateObject132 || (_templateObject132 = _taggedTemplateLiteral(["\"\""]))));

                case "number":
                  return void a.elseIf(l._(_templateObject133 || (_templateObject133 = _taggedTemplateLiteral(["", " == \"boolean\" || ", " === null\n              || (", " == \"string\" && ", " && ", " == +", ")"])), p, s, p, s, s, s)).assign(u, l._(_templateObject134 || (_templateObject134 = _taggedTemplateLiteral(["+", ""])), s));

                case "integer":
                  return void a.elseIf(l._(_templateObject135 || (_templateObject135 = _taggedTemplateLiteral(["", " === \"boolean\" || ", " === null\n              || (", " === \"string\" && ", " && ", " == +", " && !(", " % 1))"])), p, s, p, s, s, s, s)).assign(u, l._(_templateObject136 || (_templateObject136 = _taggedTemplateLiteral(["+", ""])), s));

                case "boolean":
                  return void a.elseIf(l._(_templateObject137 || (_templateObject137 = _taggedTemplateLiteral(["", " === \"false\" || ", " === 0 || ", " === null"])), s, s, s)).assign(u, !1).elseIf(l._(_templateObject138 || (_templateObject138 = _taggedTemplateLiteral(["", " === \"true\" || ", " === 1"])), s, s)).assign(u, !0);

                case "null":
                  return a.elseIf(l._(_templateObject139 || (_templateObject139 = _taggedTemplateLiteral(["", " === \"\" || ", " === 0 || ", " === false"])), s, s, s)), void a.assign(u, null);

                case "array":
                  a.elseIf(l._(_templateObject140 || (_templateObject140 = _taggedTemplateLiteral(["", " === \"string\" || ", " === \"number\"\n              || ", " === \"boolean\" || ", " === null"])), p, p, p, s)).assign(u, l._(_templateObject141 || (_templateObject141 = _taggedTemplateLiteral(["[", "]"])), s));
              }
            }

            a.else(), d(e), a.endIf(), a.if(l._(_templateObject142 || (_templateObject142 = _taggedTemplateLiteral(["", " !== undefined"])), u), function () {
              a.assign(s, u), function (_ref28, a) {
                var e = _ref28.gen,
                    t = _ref28.parentData,
                    n = _ref28.parentDataProperty;
                e.if(l._(_templateObject143 || (_templateObject143 = _taggedTemplateLiteral(["", " !== undefined"])), t), function () {
                  return e.assign(l._(_templateObject144 || (_templateObject144 = _taggedTemplateLiteral(["", "[", "]"])), t, n), a);
                });
              }(e, u);
            });
          }(e, t, u) : d(e);
        });
      }

      return c;
    };
    var r = new Set(["string", "number", "integer", "boolean", "null"]);

    function s(e, t, a) {
      var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : n.Correct;
      var s = r === n.Correct ? l.operators.EQ : l.operators.NEQ;
      var i;

      switch (e) {
        case "null":
          return l._(_templateObject145 || (_templateObject145 = _taggedTemplateLiteral(["", " ", " null"])), t, s);

        case "array":
          i = l._(_templateObject146 || (_templateObject146 = _taggedTemplateLiteral(["Array.isArray(", ")"])), t);
          break;

        case "object":
          i = l._(_templateObject147 || (_templateObject147 = _taggedTemplateLiteral(["", " && typeof ", " == \"object\" && !Array.isArray(", ")"])), t, t, t);
          break;

        case "integer":
          i = o(l._(_templateObject148 || (_templateObject148 = _taggedTemplateLiteral(["!(", " % 1) && !isNaN(", ")"])), t, t));
          break;

        case "number":
          i = o();
          break;

        default:
          return l._(_templateObject149 || (_templateObject149 = _taggedTemplateLiteral(["typeof ", " ", " ", ""])), t, s, e);
      }

      return r === n.Correct ? i : l.not(i);

      function o() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : l.nil;
        return l.and(l._(_templateObject150 || (_templateObject150 = _taggedTemplateLiteral(["typeof ", " == \"number\""])), t), e, a ? l._(_templateObject151 || (_templateObject151 = _taggedTemplateLiteral(["isFinite(", ")"])), t) : l.nil);
      }
    }

    function i(e, t, n, a) {
      if (1 === e.length) return s(e[0], t, n, a);
      var r;
      var i = M.toHash(e);

      if (i.array && i.object) {
        var _e10 = l._(_templateObject152 || (_templateObject152 = _taggedTemplateLiteral(["typeof ", " != \"object\""])), t);

        r = i.null ? _e10 : l._(_templateObject153 || (_templateObject153 = _taggedTemplateLiteral(["!", " || ", ""])), t, _e10), delete i.null, delete i.array, delete i.object;
      } else r = l.nil;

      i.number && delete i.integer;

      for (var _e11 in i) {
        r = l.and(r, s(_e11, t, n, a));
      }

      return r;
    }

    t.checkDataType = s, t.checkDataTypes = i;
    var u = {
      message: function message(_ref29) {
        var e = _ref29.schema;
        return l.str(_templateObject154 || (_templateObject154 = _taggedTemplateLiteral(["should be ", ""])), e);
      },
      params: function params(_ref30) {
        var e = _ref30.schema,
            t = _ref30.schemaValue;
        return "string" == typeof e ? l._(_templateObject155 || (_templateObject155 = _taggedTemplateLiteral(["{type: ", "}"])), e) : l._(_templateObject156 || (_templateObject156 = _taggedTemplateLiteral(["{type: ", "}"])), t);
      }
    };

    function d(e) {
      var t = function (e) {
        var t = e.gen,
            n = e.data,
            a = e.schema,
            r = M.schemaRefOrVal(e, a, "type");
        return {
          gen: t,
          keyword: "type",
          data: n,
          schema: a.type,
          schemaCode: r,
          schemaValue: r,
          parentSchema: a,
          params: {},
          it: e
        };
      }(e);

      y.reportError(t, u);
    }

    t.reportTypeError = d;
  });
  r(C), C.reportTypeError, C.checkDataTypes, C.checkDataType, C.coerceAndCheckDataType, C.getJSONTypes, C.getSchemaTypes, C.DataType;
  var I = s(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getData = void 0;

    t.default = /*#__PURE__*/function () {
      function _class3(e, t, n) {
        _classCallCheck(this, _class3);

        if (function (_ref31, a, r) {
          var e = _ref31.schema,
              t = _ref31.opts,
              n = _ref31.self;
          if (Array.isArray(a.keyword) ? !a.keyword.includes(r) : a.keyword !== r) throw new Error("ajv implementation error");
          var s = a.dependencies;
          if (null == s ? void 0 : s.some(function (t) {
            return !Object.prototype.hasOwnProperty.call(e, t);
          })) throw new Error("parent schema must have dependencies of ".concat(r, ": ").concat(s.join(",")));

          if (a.validateSchema) {
            if (!a.validateSchema(e[r])) {
              var _e12 = "keyword value is invalid: " + n.errorsText(a.validateSchema.errors);

              if ("log" !== t.validateSchema) throw new Error(_e12);
              n.logger.error(_e12);
            }
          }
        }(e, t, n), this.gen = e.gen, this.allErrors = e.allErrors, this.keyword = n, this.data = e.data, this.schema = e.schema[n], this.$data = t.$data && e.opts.$data && this.schema && this.schema.$data, this.schemaValue = M.schemaRefOrVal(e, this.schema, n, this.$data), this.schemaType = t.schemaType, this.parentSchema = e.schema, this.params = {}, this.it = e, this.def = t, this.$data) this.schemaCode = e.gen.const("vSchema", r(this.$data, e));else if (this.schemaCode = this.schemaValue, !function (e, t) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
          return !t.length || t.some(function (t) {
            return "array" === t ? Array.isArray(e) : "object" === t ? e && "object" == typeof e && !Array.isArray(e) : typeof e == t || n && void 0 === e;
          });
        }(this.schema, t.schemaType, t.allowUndefined)) throw new Error("".concat(n, " value must be ").concat(JSON.stringify(t.schemaType)));
        ("code" in t ? t.trackErrors : !1 !== t.errors) && (this.errsCount = e.gen.const("_errs", c.default.errors));
      }

      _createClass(_class3, [{
        key: "result",
        value: function result(e, t, n) {
          this.gen.if(l.not(e)), n ? n() : this.error(), t ? (this.gen.else(), t(), this.allErrors && this.gen.endIf()) : this.allErrors ? this.gen.endIf() : this.gen.else();
        }
      }, {
        key: "pass",
        value: function pass(e, t) {
          this.result(e, void 0, t);
        }
      }, {
        key: "fail",
        value: function fail(e) {
          if (void 0 === e) return this.error(), void (this.allErrors || this.gen.if(!1));
          this.gen.if(e), this.error(), this.allErrors ? this.gen.endIf() : this.gen.else();
        }
      }, {
        key: "fail$data",
        value: function fail$data(e) {
          if (!this.$data) return this.fail(e);
          var t = this.schemaCode;
          this.fail(l._(_templateObject157 || (_templateObject157 = _taggedTemplateLiteral(["", " !== undefined && (", ")"])), t, l.or(this.invalid$data(), e)));
        }
      }, {
        key: "error",
        value: function error(e) {
          (e ? y.reportExtraError : y.reportError)(this, this.def.error);
        }
      }, {
        key: "$dataError",
        value: function $dataError() {
          y.reportError(this, this.def.$dataError || y.keyword$DataError);
        }
      }, {
        key: "reset",
        value: function reset() {
          if (void 0 === this.errsCount) throw new Error('add "trackErrors" to keyword definition');
          y.resetErrorsCount(this.gen, this.errsCount);
        }
      }, {
        key: "ok",
        value: function ok(e) {
          this.allErrors || this.gen.if(e);
        }
      }, {
        key: "setParams",
        value: function setParams(e, t) {
          t ? Object.assign(this.params, e) : this.params = e;
        }
      }, {
        key: "block$data",
        value: function block$data(e, t) {
          var _this23 = this;

          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : l.nil;
          this.gen.block(function () {
            _this23.check$data(e, n), t();
          });
        }
      }, {
        key: "check$data",
        value: function check$data() {
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : l.nil;
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : l.nil;
          if (!this.$data) return;
          var n = this.gen,
              a = this.schemaCode,
              r = this.schemaType,
              s = this.def;
          n.if(l.or(l._(_templateObject158 || (_templateObject158 = _taggedTemplateLiteral(["", " === undefined"])), a), t)), e !== l.nil && n.assign(e, !0), (r.length || s.validateSchema) && (n.elseIf(this.invalid$data()), this.$dataError(), e !== l.nil && n.assign(e, !1)), n.else();
        }
      }, {
        key: "invalid$data",
        value: function invalid$data() {
          var e = this.gen,
              t = this.schemaCode,
              n = this.schemaType,
              a = this.def,
              r = this.it;
          return l.or(function () {
            if (n.length) {
              if (!(t instanceof l.Name)) throw new Error("ajv implementation error");

              var _e13 = Array.isArray(n) ? n : [n];

              return l._(_templateObject159 || (_templateObject159 = _taggedTemplateLiteral(["", ""])), C.checkDataTypes(_e13, t, r.opts.strict, C.DataType.Wrong));
            }

            return l.nil;
          }(), function () {
            if (a.validateSchema) {
              var _n20 = e.scopeValue("validate$data", {
                ref: a.validateSchema
              });

              return l._(_templateObject160 || (_templateObject160 = _taggedTemplateLiteral(["!", "(", ")"])), _n20, t);
            }

            return l.nil;
          }());
        }
      }, {
        key: "subschema",
        value: function subschema(e, t) {
          return h.applySubschema(this.it, e, t);
        }
      }, {
        key: "mergeEvaluated",
        value: function mergeEvaluated(e, t) {
          var n = this.it,
              a = this.gen;
          n.opts.unevaluated && (!0 !== n.props && void 0 !== e.props && (n.props = M.mergeEvaluated.props(a, e.props, n.props, t)), !0 !== n.items && void 0 !== e.items && (n.items = M.mergeEvaluated.items(a, e.items, n.items, t)));
        }
      }, {
        key: "mergeValidEvaluated",
        value: function mergeValidEvaluated(e, t) {
          var _this24 = this;

          var n = this.it,
              a = this.gen;
          if (n.opts.unevaluated && (!0 !== n.props || !0 !== n.items)) return a.if(t, function () {
            return _this24.mergeEvaluated(e, l.Name);
          }), !0;
        }
      }]);

      return _class3;
    }();

    var n = /^\/(?:[^~]|~0|~1)*$/,
        a = /^([0-9]+)(#|\/(?:[^~]|~0|~1)*)?$/;

    function r(e, _ref32) {
      var t = _ref32.dataLevel,
          r = _ref32.dataNames,
          s = _ref32.dataPathArr;
      var i, o;
      if ("" === e) return c.default.rootData;

      if ("/" === e[0]) {
        if (!n.test(e)) throw new Error("Invalid JSON-pointer: ".concat(e));
        i = e, o = c.default.rootData;
      } else {
        var _n21 = a.exec(e);

        if (!_n21) throw new Error("Invalid JSON-pointer: ".concat(e));

        var _p3 = +_n21[1];

        if (i = _n21[2], "#" === i) {
          if (_p3 >= t) throw new Error(d("property/index", _p3));
          return s[t - _p3];
        }

        if (_p3 > t) throw new Error(d("data", _p3));
        if (o = r[t - _p3], !i) return o;
      }

      var p = o;
      var u = i.split("/");

      var _iterator6 = _createForOfIteratorHelper(u),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var _e14 = _step6.value;
          _e14 && (o = l._(_templateObject161 || (_templateObject161 = _taggedTemplateLiteral(["", "", ""])), o, l.getProperty(M.unescapeJsonPointer(_e14))), p = l._(_templateObject162 || (_templateObject162 = _taggedTemplateLiteral(["", " && ", ""])), p, o));
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }

      return p;

      function d(e, n) {
        return "Cannot access ".concat(e, " ").concat(n, " levels up, current level is ").concat(t);
      }
    }

    t.getData = r;
  });
  r(I), I.getData;
  var N = s(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MissingRefError = t.ValidationError = void 0;

    var n = /*#__PURE__*/function (_Error2) {
      _inherits(n, _Error2);

      function n(e) {
        var _this25;

        _classCallCheck(this, n);

        _this25 = _possibleConstructorReturn(this, _getPrototypeOf(n).call(this, "validation failed")), _this25.errors = e, _this25.ajv = _this25.validation = !0;
        return _this25;
      }

      return n;
    }(_wrapNativeSuper(Error));

    t.ValidationError = n;

    var a = /*#__PURE__*/function (_Error3) {
      _inherits(a, _Error3);

      function a(e, t, n) {
        var _this26;

        _classCallCheck(this, a);

        _this26 = _possibleConstructorReturn(this, _getPrototypeOf(a).call(this, n || "can't resolve reference ".concat(t, " from id ").concat(e))), _this26.missingRef = E.resolveUrl(e, t), _this26.missingSchema = E.normalizeId(E.getFullPath(_this26.missingRef));
        return _this26;
      }

      return a;
    }(_wrapNativeSuper(Error));

    t.MissingRefError = a, e.exports = {
      ValidationError: n,
      MissingRefError: a
    };
  });
  r(N), N.MissingRefError, N.ValidationError;
  var S = s(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.resolveSchema = t.getCompilingSchema = t.resolveRef = t.compileSchema = t.SchemaEnv = void 0;

    var n = function n(e) {
      _classCallCheck(this, n);

      var t;

      var _n22;

      this.refs = {}, this.dynamicAnchors = {}, "object" == typeof e.schema && (_n22 = e.schema), this.schema = e.schema, this.root = e.root || this, this.baseId = null !== (t = e.baseId) && void 0 !== t ? t : E.normalizeId(null == _n22 ? void 0 : _n22.$id), this.localRefs = e.localRefs, this.meta = e.meta, this.$async = null == _n22 ? void 0 : _n22.$async, this.refs = {};
    };

    function a(e) {
      var t = s.call(this, e);
      if (t) return t;
      var n = E.getFullPath(e.root.baseId),
          _this$opts$code = this.opts.code,
          a = _this$opts$code.es5,
          r = _this$opts$code.lines,
          i = this.opts.ownProperties,
          o = new l.CodeGen(this.scope, {
        es5: a,
        lines: r,
        ownProperties: i
      });
      var p;
      e.$async && (p = o.scopeValue("Error", {
        ref: N.ValidationError,
        code: l._(_templateObject163 || (_templateObject163 = _taggedTemplateLiteral(["require(\"ajv/dist/compile/error_classes\").ValidationError"])))
      }));
      var u = o.scopeName("validate");
      e.validateName = u;
      var d = {
        gen: o,
        allErrors: this.opts.allErrors,
        data: c.default.data,
        parentData: c.default.parentData,
        parentDataProperty: c.default.parentDataProperty,
        dataNames: [c.default.data],
        dataPathArr: [l.nil],
        dataLevel: 0,
        dataTypes: [],
        definedProperties: new Set(),
        topSchemaRef: o.scopeValue("schema", !0 === this.opts.code.source ? {
          ref: e.schema,
          code: l.stringify(e.schema)
        } : {
          ref: e.schema
        }),
        validateName: u,
        ValidationError: p,
        schema: e.schema,
        schemaEnv: e,
        rootId: n,
        baseId: e.baseId || n,
        schemaPath: l.nil,
        errSchemaPath: this.opts.jtd ? "" : "#",
        errorPath: l._(_templateObject164 || (_templateObject164 = _taggedTemplateLiteral(["\"\""]))),
        opts: this.opts,
        self: this
      };
      var y;

      try {
        this._compilations.add(e), $.validateFunctionCode(d), o.optimize(this.opts.code.optimize);

        var _t3 = o.toString();

        y = "".concat(o.scopeRefs(c.default.scope), "return ").concat(_t3), this.opts.code.process && (y = this.opts.code.process(y, e));

        var _n23 = new Function("".concat(c.default.self), "".concat(c.default.scope), y)(this, this.scope.get());

        if (this.scope.value(u, {
          ref: _n23
        }), _n23.errors = null, _n23.schema = e.schema, _n23.schemaEnv = e, e.$async && (_n23.$async = !0), !0 === this.opts.code.source && (_n23.source = {
          validateName: u,
          validateCode: _t3,
          scopeValues: o._values
        }), this.opts.unevaluated) {
          var _e15 = d.props,
              _t4 = d.items;
          _n23.evaluated = {
            props: _e15 instanceof l.Name ? void 0 : _e15,
            items: _t4 instanceof l.Name ? void 0 : _t4,
            dynamicProps: _e15 instanceof l.Name,
            dynamicItems: _t4 instanceof l.Name
          }, _n23.source && (_n23.source.evaluated = l.stringify(_n23.evaluated));
        }

        return e.validate = _n23, e;
      } catch (t) {
        throw delete e.validate, delete e.validateName, y && this.logger.error("Error compiling schema, function code:", y), t;
      } finally {
        this._compilations.delete(e);
      }
    }

    function r(e) {
      return E.inlineRef(e.schema, this.opts.inlineRefs) ? e.schema : e.validate ? e : a.call(this, e);
    }

    function s(e) {
      var _iterator7 = _createForOfIteratorHelper(this._compilations),
          _step7;

      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var _a4 = _step7.value;
          if (n = e, (t = _a4).schema === n.schema && t.root === n.root && t.baseId === n.baseId) return _a4;
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }

      var t, n;
    }

    function i(e, t) {
      var n;

      for (; "string" == typeof (n = this.refs[t]);) {
        t = n;
      }

      return n || this.schemas[t] || o.call(this, e, t);
    }

    function o(e, t) {
      var r = w.parse(t),
          s = E._getFullPath(r);

      var i = E.getFullPath(e.baseId);
      if (Object.keys(e.schema).length > 0 && s === i) return u.call(this, r, e);
      var p = E.normalizeId(s),
          d = this.refs[p] || this.schemas[p];

      if ("string" == typeof d) {
        var _t5 = o.call(this, e, d);

        if ("object" != typeof (null == _t5 ? void 0 : _t5.schema)) return;
        return u.call(this, r, _t5);
      }

      if ("object" == typeof (null == d ? void 0 : d.schema)) {
        if (d.validate || a.call(this, d), p === E.normalizeId(t)) {
          var _t6 = d.schema;
          return _t6.$id && (i = E.resolveUrl(i, _t6.$id)), new n({
            schema: _t6,
            root: e,
            baseId: i
          });
        }

        return u.call(this, r, d);
      }
    }

    t.SchemaEnv = n, t.compileSchema = a, t.resolveRef = function (e, t, a) {
      var s;
      a = E.resolveUrl(t, a);
      var o = e.refs[a];
      if (o) return o;
      var p = i.call(this, e, a);

      if (void 0 === p) {
        var _r13 = null === (s = e.localRefs) || void 0 === s ? void 0 : s[a];

        _r13 && (p = new n({
          schema: _r13,
          root: e,
          baseId: t
        }));
      }

      return void 0 !== p ? e.refs[a] = r.call(this, p) : void 0;
    }, t.getCompilingSchema = s, t.resolveSchema = o;
    var p = new Set(["properties", "patternProperties", "enum", "dependencies", "definitions"]);

    function u(e, _ref33) {
      var t = _ref33.baseId,
          a = _ref33.schema,
          r = _ref33.root;
      var s;
      if ("/" !== (null === (s = e.fragment) || void 0 === s ? void 0 : s[0])) return;

      var _iterator8 = _createForOfIteratorHelper(e.fragment.slice(1).split("/")),
          _step8;

      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var _n24 = _step8.value;
          if ("boolean" == typeof a) return;
          if (void 0 === (a = a[M.unescapeFragment(_n24)])) return;
          !p.has(_n24) && "object" == typeof a && a.$id && (t = E.resolveUrl(t, a.$id));
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }

      var i;

      if ("boolean" != typeof a && a.$ref && !M.schemaHasRulesButRef(a, this.RULES)) {
        var _e16 = E.resolveUrl(t, a.$ref);

        i = o.call(this, r, _e16);
      }

      return i = i || new n({
        schema: a,
        root: r,
        baseId: t
      }), i.schema !== i.root.schema ? i : void 0;
    }
  });
  r(S), S.resolveSchema, S.getCompilingSchema, S.resolveRef, S.compileSchema, S.SchemaEnv;
  var A = "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#",
      x = "Meta-schema for $data reference (JSON AnySchema extension proposal)",
      P = "object",
      R = ["$data"],
      O = {
    $data: {
      type: "string",
      anyOf: [{
        format: "relative-json-pointer"
      }, {
        format: "json-pointer"
      }]
    }
  },
      k = {
    $id: A,
    description: x,
    type: P,
    required: R,
    properties: O,
    additionalProperties: false
  },
      j = i(Object.freeze({
    __proto__: null,
    $id: A,
    description: x,
    type: P,
    required: R,
    properties: O,
    additionalProperties: false,
    default: k
  })),
      D = s(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CodeGen = t.Name = t.nil = t.stringify = t.str = t._ = t.KeywordCxt = void 0, t.KeywordCxt = I.default, Object.defineProperty(t, "_", {
      enumerable: !0,
      get: function get() {
        return l._;
      }
    }), Object.defineProperty(t, "str", {
      enumerable: !0,
      get: function get() {
        return l.str;
      }
    }), Object.defineProperty(t, "stringify", {
      enumerable: !0,
      get: function get() {
        return l.stringify;
      }
    }), Object.defineProperty(t, "nil", {
      enumerable: !0,
      get: function get() {
        return l.nil;
      }
    }), Object.defineProperty(t, "Name", {
      enumerable: !0,
      get: function get() {
        return l.Name;
      }
    }), Object.defineProperty(t, "CodeGen", {
      enumerable: !0,
      get: function get() {
        return l.CodeGen;
      }
    });
    var n = l,
        a = ["removeAdditional", "useDefaults", "coerceTypes"],
        r = new Set(["validate", "serialize", "parse", "wrapper", "root", "schema", "keyword", "pattern", "formats", "validate$data", "func", "obj", "Error"]),
        s = {
      errorDataPath: "",
      format: "`validateFormats: false` can be used instead.",
      nullable: '"nullable" keyword is supported by default.',
      jsonPointers: "Deprecated jsPropertySyntax can be used instead.",
      extendRefs: "Deprecated ignoreKeywordsWithRef can be used instead.",
      missingRefs: "Pass empty schema with $id that should be ignored to ajv.addSchema.",
      processCode: "Use option `code: {process: (code, schemaEnv: object) => string}`",
      sourceCode: "Use option `code: {source: true}`",
      schemaId: "JSON Schema draft-04 is not supported in Ajv v7.",
      strictDefaults: "It is default now, see option `strict`.",
      strictKeywords: "It is default now, see option `strict`.",
      strictNumbers: "It is default now, see option `strict`.",
      uniqueItems: '"uniqueItems" keyword is always validated.',
      unknownFormats: "Disable strict mode or pass `true` to `ajv.addFormat` (or `formats` option).",
      cache: "Map is used as cache, schema object as key.",
      serialize: "Map is used as cache, schema object as key."
    },
        i = {
      ignoreKeywordsWithRef: "",
      jsPropertySyntax: "",
      unicode: '"minLength"/"maxLength" account for unicode characters by default.'
    };

    function p(e) {
      var t, n, a, r, s, i, o, p, u, d, l, c;
      var y = null === (t = e.strict) || void 0 === t || t,
          m = !!y && "log",
          f = null === (n = e.code) || void 0 === n ? void 0 : n.optimize,
          h = !0 === f || void 0 === f ? 1 : f || 0;
      return {
        strict: y,
        strictTypes: null !== (a = e.strictTypes) && void 0 !== a ? a : m,
        strictTuples: null !== (r = e.strictTuples) && void 0 !== r ? r : m,
        code: e.code ? _objectSpread({}, e.code, {
          optimize: h
        }) : {
          optimize: h
        },
        loopRequired: null !== (s = e.loopRequired) && void 0 !== s ? s : 1 / 0,
        loopEnum: null !== (i = e.loopEnum) && void 0 !== i ? i : 1 / 0,
        meta: null === (o = e.meta) || void 0 === o || o,
        messages: null === (p = e.messages) || void 0 === p || p,
        inlineRefs: null === (u = e.inlineRefs) || void 0 === u || u,
        addUsedSchema: null === (d = e.addUsedSchema) || void 0 === d || d,
        validateSchema: null === (l = e.validateSchema) || void 0 === l || l,
        validateFormats: null === (c = e.validateFormats) || void 0 === c || c
      };
    }

    var u = /*#__PURE__*/function () {
      function u() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, u);

        this.schemas = {}, this.refs = {}, this.formats = {}, this._compilations = new Set(), this._loading = {}, this._cache = new Map(), e = this.opts = _objectSpread({}, e, p(e));
        var _this$opts$code2 = this.opts.code,
            t = _this$opts$code2.es5,
            a = _this$opts$code2.lines;
        this.scope = new n.ValueScope({
          scope: {},
          prefixes: r,
          es5: t,
          lines: a
        }), this.logger = function (e) {
          if (!1 === e) return b;
          if (void 0 === e) return console;
          if (e.log && e.warn && e.error) return e;
          throw new Error("logger must implement log, warn and error methods");
        }(e.logger);
        var _u = e.validateFormats;
        e.validateFormats = !1, this.RULES = o.getRules(), d.call(this, s, e, "NOT SUPPORTED"), d.call(this, i, e, "DEPRECATED", "warn"), this._metaOpts = h.call(this), e.formats && m.call(this), this._addVocabularies(), this._addDefaultMetaSchema(), e.keywords && f.call(this, e.keywords), "object" == typeof e.meta && this.addMetaSchema(e.meta), y.call(this), e.validateFormats = _u;
      }

      _createClass(u, [{
        key: "_addVocabularies",
        value: function _addVocabularies() {
          this.addKeyword("$async");
        }
      }, {
        key: "_addDefaultMetaSchema",
        value: function _addDefaultMetaSchema() {
          var _this$opts = this.opts,
              e = _this$opts.$data,
              t = _this$opts.meta;
          t && e && this.addMetaSchema(j, j.$id, !1);
        }
      }, {
        key: "defaultMeta",
        value: function defaultMeta() {
          var e = this.opts.meta;
          return this.opts.defaultMeta = "object" == typeof e ? e.$id || e : void 0;
        }
      }, {
        key: "validate",
        value: function validate(e, t) {
          var n;

          if ("string" == typeof e) {
            if (n = this.getSchema(e), !n) throw new Error("no schema with key or ref \"".concat(e, "\""));
          } else n = this.compile(e);

          var a = n(t);
          return "$async" in n || (this.errors = n.errors), a;
        }
      }, {
        key: "compile",
        value: function compile(e, t) {
          var n = this._addSchema(e, t);

          return n.validate || this._compileSchemaEnv(n);
        }
      }, {
        key: "compileAsync",
        value: function compileAsync(e, t) {
          if ("function" != typeof this.opts.loadSchema) throw new Error("options.loadSchema should be a function");
          var n = this.opts.loadSchema;
          return a.call(this, e, t);

          function a(_x, _x2) {
            return _a5.apply(this, arguments);
          }

          function _a5() {
            _a5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e, t) {
              var n;
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2;
                      return r.call(this, e.$schema);

                    case 2:
                      n = this._addSchema(e, t);
                      return _context.abrupt("return", n.validate || s.call(this, n));

                    case 4:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee, this);
            }));
            return _a5.apply(this, arguments);
          }

          function r(_x3) {
            return _r14.apply(this, arguments);
          }

          function _r14() {
            _r14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e) {
              return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      _context2.t0 = e && !this.getSchema(e);

                      if (!_context2.t0) {
                        _context2.next = 4;
                        break;
                      }

                      _context2.next = 4;
                      return a.call(this, {
                        $ref: e
                      }, !0);

                    case 4:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _callee2, this);
            }));
            return _r14.apply(this, arguments);
          }

          function s(_x4) {
            return _s2.apply(this, arguments);
          }

          function _s2() {
            _s2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(e) {
              return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                  switch (_context3.prev = _context3.next) {
                    case 0:
                      _context3.prev = 0;
                      return _context3.abrupt("return", this._compileSchemaEnv(e));

                    case 4:
                      _context3.prev = 4;
                      _context3.t0 = _context3["catch"](0);

                      if (_context3.t0 instanceof N.MissingRefError) {
                        _context3.next = 8;
                        break;
                      }

                      throw _context3.t0;

                    case 8:
                      i.call(this, _context3.t0);
                      _context3.next = 11;
                      return o.call(this, _context3.t0.missingSchema);

                    case 11:
                      return _context3.abrupt("return", s.call(this, e));

                    case 12:
                    case "end":
                      return _context3.stop();
                  }
                }
              }, _callee3, this, [[0, 4]]);
            }));
            return _s2.apply(this, arguments);
          }

          function i(_ref34) {
            var e = _ref34.missingSchema,
                t = _ref34.missingRef;
            if (this.refs[e]) throw new Error("AnySchema ".concat(e, " is loaded but ").concat(t, " cannot be resolved"));
          }

          function o(_x5) {
            return _o2.apply(this, arguments);
          }

          function _o2() {
            _o2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(e) {
              var n;
              return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1) {
                  switch (_context4.prev = _context4.next) {
                    case 0:
                      _context4.next = 2;
                      return p.call(this, e);

                    case 2:
                      n = _context4.sent;
                      _context4.t0 = this.refs[e];

                      if (_context4.t0) {
                        _context4.next = 7;
                        break;
                      }

                      _context4.next = 7;
                      return r.call(this, n.$schema);

                    case 7:
                      this.refs[e] || this.addSchema(n, e, t);

                    case 8:
                    case "end":
                      return _context4.stop();
                  }
                }
              }, _callee4, this);
            }));
            return _o2.apply(this, arguments);
          }

          function p(_x6) {
            return _p4.apply(this, arguments);
          }

          function _p4() {
            _p4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(e) {
              var t;
              return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                while (1) {
                  switch (_context5.prev = _context5.next) {
                    case 0:
                      t = this._loading[e];

                      if (!t) {
                        _context5.next = 3;
                        break;
                      }

                      return _context5.abrupt("return", t);

                    case 3:
                      _context5.prev = 3;
                      _context5.next = 6;
                      return this._loading[e] = n(e);

                    case 6:
                      return _context5.abrupt("return", _context5.sent);

                    case 7:
                      _context5.prev = 7;
                      delete this._loading[e];
                      return _context5.finish(7);

                    case 10:
                    case "end":
                      return _context5.stop();
                  }
                }
              }, _callee5, this, [[3,, 7, 10]]);
            }));
            return _p4.apply(this, arguments);
          }
        }
      }, {
        key: "addSchema",
        value: function addSchema(e, t, n) {
          var a = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : this.opts.validateSchema;

          if (Array.isArray(e)) {
            var _iterator9 = _createForOfIteratorHelper(e),
                _step9;

            try {
              for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
                var _t7 = _step9.value;
                this.addSchema(_t7, void 0, n, a);
              }
            } catch (err) {
              _iterator9.e(err);
            } finally {
              _iterator9.f();
            }

            return this;
          }

          var r;
          if ("object" == typeof e && (r = e.$id, void 0 !== r && "string" != typeof r)) throw new Error("schema id must be string");
          return t = E.normalizeId(t || r), this._checkUnique(t), this.schemas[t] = this._addSchema(e, n, a, !0), this;
        }
      }, {
        key: "addMetaSchema",
        value: function addMetaSchema(e, t) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.opts.validateSchema;
          return this.addSchema(e, t, !0, n), this;
        }
      }, {
        key: "validateSchema",
        value: function validateSchema(e, t) {
          if ("boolean" == typeof e) return !0;
          var n;
          if (n = e.$schema, void 0 !== n && "string" != typeof n) throw new Error("$schema must be a string");
          if (n = n || this.opts.defaultMeta || this.defaultMeta(), !n) return this.logger.warn("meta-schema not available"), this.errors = null, !0;
          var a = this.validate(n, e);

          if (!a && t) {
            var _e17 = "schema is invalid: " + this.errorsText();

            if ("log" !== this.opts.validateSchema) throw new Error(_e17);
            this.logger.error(_e17);
          }

          return a;
        }
      }, {
        key: "getSchema",
        value: function getSchema(e) {
          var t;

          for (; "string" == typeof (t = c.call(this, e));) {
            e = t;
          }

          if (void 0 === t) {
            var _n25 = new S.SchemaEnv({
              schema: {}
            });

            if (t = S.resolveSchema.call(this, _n25, e), !t) return;
            this.refs[e] = t;
          }

          return t.validate || this._compileSchemaEnv(t);
        }
      }, {
        key: "removeSchema",
        value: function removeSchema(e) {
          if (e instanceof RegExp) return this._removeAllSchemas(this.schemas, e), this._removeAllSchemas(this.refs, e), this;

          switch (typeof e) {
            case "undefined":
              return this._removeAllSchemas(this.schemas), this._removeAllSchemas(this.refs), this._cache.clear(), this;

            case "string":
              {
                var _t8 = c.call(this, e);

                return "object" == typeof _t8 && this._cache.delete(_t8.schema), delete this.schemas[e], delete this.refs[e], this;
              }

            case "object":
              {
                var _t9 = e;

                this._cache.delete(_t9);

                var _n26 = e.$id;
                return _n26 && (_n26 = E.normalizeId(_n26), delete this.schemas[_n26], delete this.refs[_n26]), this;
              }

            default:
              throw new Error("ajv.removeSchema: invalid parameter");
          }
        }
      }, {
        key: "addVocabulary",
        value: function addVocabulary(e) {
          var _iterator10 = _createForOfIteratorHelper(e),
              _step10;

          try {
            for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
              var _t10 = _step10.value;
              this.addKeyword(_t10);
            }
          } catch (err) {
            _iterator10.e(err);
          } finally {
            _iterator10.f();
          }

          return this;
        }
      }, {
        key: "addKeyword",
        value: function addKeyword(e, t) {
          var _this27 = this;

          var n;
          if ("string" == typeof e) n = e, "object" == typeof t && (this.logger.warn("these parameters are deprecated, see docs for addKeyword"), t.keyword = n);else {
            if ("object" != typeof e || void 0 !== t) throw new Error("invalid addKeywords parameters");
            if (n = (t = e).keyword, Array.isArray(n) && !n.length) throw new Error("addKeywords: keyword must be string or non-empty array");
          }
          if (g.call(this, n, t), !t) return M.eachItem(n, function (e) {
            return _.call(_this27, e);
          }), this;
          w.call(this, t);

          var a = _objectSpread({}, t, {
            type: C.getJSONTypes(t.type),
            schemaType: C.getJSONTypes(t.schemaType)
          });

          return M.eachItem(n, 0 === a.type.length ? function (e) {
            return _.call(_this27, e, a);
          } : function (e) {
            return a.type.forEach(function (t) {
              return _.call(_this27, e, a, t);
            });
          }), this;
        }
      }, {
        key: "getKeyword",
        value: function getKeyword(e) {
          var t = this.RULES.all[e];
          return "object" == typeof t ? t.definition : !!t;
        }
      }, {
        key: "removeKeyword",
        value: function removeKeyword(e) {
          var t = this.RULES;
          delete t.keywords[e], delete t.all[e];

          var _iterator11 = _createForOfIteratorHelper(t.rules),
              _step11;

          try {
            for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
              var _n27 = _step11.value;

              var _t11 = _n27.rules.findIndex(function (t) {
                return t.keyword === e;
              });

              _t11 >= 0 && _n27.rules.splice(_t11, 1);
            }
          } catch (err) {
            _iterator11.e(err);
          } finally {
            _iterator11.f();
          }

          return this;
        }
      }, {
        key: "addFormat",
        value: function addFormat(e, t) {
          return "string" == typeof t && (t = new RegExp(t)), this.formats[e] = t, this;
        }
      }, {
        key: "errorsText",
        value: function errorsText() {
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.errors;

          var _ref35 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
              _ref35$separator = _ref35.separator,
              t = _ref35$separator === void 0 ? ", " : _ref35$separator,
              _ref35$dataVar = _ref35.dataVar,
              n = _ref35$dataVar === void 0 ? "data" : _ref35$dataVar;

          return e && 0 !== e.length ? e.map(function (e) {
            return "".concat(n).concat(e.dataPath, " ").concat(e.message);
          }).reduce(function (e, n) {
            return e + t + n;
          }) : "No errors";
        }
      }, {
        key: "$dataMetaSchema",
        value: function $dataMetaSchema(e, t) {
          var n = this.RULES.all;
          e = JSON.parse(JSON.stringify(e));

          var _iterator12 = _createForOfIteratorHelper(t),
              _step12;

          try {
            for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
              var _a6 = _step12.value;

              var _t12 = _a6.split("/").slice(1);

              var _r15 = e;

              var _iterator13 = _createForOfIteratorHelper(_t12),
                  _step13;

              try {
                for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
                  var _e19 = _step13.value;
                  _r15 = _r15[_e19];
                }
              } catch (err) {
                _iterator13.e(err);
              } finally {
                _iterator13.f();
              }

              for (var _e18 in n) {
                var _t13 = n[_e18];
                if ("object" != typeof _t13) continue;
                var _a7 = _t13.definition.$data,
                    _s3 = _r15[_e18];
                _a7 && _s3 && (_r15[_e18] = A(_s3));
              }
            }
          } catch (err) {
            _iterator12.e(err);
          } finally {
            _iterator12.f();
          }

          return e;
        }
      }, {
        key: "_removeAllSchemas",
        value: function _removeAllSchemas(e, t) {
          for (var _n28 in e) {
            var _a8 = e[_n28];
            t && !t.test(_n28) || ("string" == typeof _a8 ? delete e[_n28] : _a8 && !_a8.meta && (this._cache.delete(_a8.schema), delete e[_n28]));
          }
        }
      }, {
        key: "_addSchema",
        value: function _addSchema(e, t) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.opts.validateSchema;
          var a = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : this.opts.addUsedSchema;

          if ("object" != typeof e) {
            if (this.opts.jtd) throw new Error("schema must be object");
            if ("boolean" != typeof e) throw new Error("schema must be object or boolean");
          }

          var r = this._cache.get(e);

          if (void 0 !== r) return r;
          var s = E.getSchemaRefs.call(this, e);
          r = new S.SchemaEnv({
            schema: e,
            meta: t,
            localRefs: s
          }), this._cache.set(r.schema, r);
          var i = r.baseId;
          return a && !i.startsWith("#") && (i && this._checkUnique(i), this.refs[i] = r), n && this.validateSchema(e, !0), r;
        }
      }, {
        key: "_checkUnique",
        value: function _checkUnique(e) {
          if (this.schemas[e] || this.refs[e]) throw new Error("schema with key or id \"".concat(e, "\" already exists"));
        }
      }, {
        key: "_compileSchemaEnv",
        value: function _compileSchemaEnv(e) {
          if (e.meta ? this._compileMetaSchema(e) : S.compileSchema.call(this, e), !e.validate) throw new Error("ajv implementation error");
          return e.validate;
        }
      }, {
        key: "_compileMetaSchema",
        value: function _compileMetaSchema(e) {
          var t = this.opts;
          this.opts = this._metaOpts;

          try {
            S.compileSchema.call(this, e);
          } finally {
            this.opts = t;
          }
        }
      }]);

      return u;
    }();

    function d(e, t, n) {
      var a = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "error";

      for (var _r16 in e) {
        var _s4 = _r16;
        _s4 in t && this.logger[a]("".concat(n, ": option ").concat(_r16, ". ").concat(e[_s4]));
      }
    }

    function c(e) {
      return e = E.normalizeId(e), this.schemas[e] || this.refs[e];
    }

    function y() {
      var e = this.opts.schemas;
      if (e) if (Array.isArray(e)) this.addSchema(e);else for (var _t14 in e) {
        this.addSchema(e[_t14], _t14);
      }
    }

    function m() {
      for (var _e20 in this.opts.formats) {
        var _t15 = this.opts.formats[_e20];
        _t15 && this.addFormat(_e20, _t15);
      }
    }

    function f(e) {
      if (Array.isArray(e)) this.addVocabulary(e);else {
        this.logger.warn("keywords option as map is deprecated, pass array");

        for (var _t16 in e) {
          var _n29 = e[_t16];
          _n29.keyword || (_n29.keyword = _t16), this.addKeyword(_n29);
        }
      }
    }

    function h() {
      var e = _objectSpread({}, this.opts);

      var _iterator14 = _createForOfIteratorHelper(a),
          _step14;

      try {
        for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
          var _t17 = _step14.value;
          delete e[_t17];
        }
      } catch (err) {
        _iterator14.e(err);
      } finally {
        _iterator14.f();
      }

      return e;
    }

    t.default = u, u.ValidationError = N.ValidationError, u.MissingRefError = N.MissingRefError;
    var b = {
      log: function log() {},
      warn: function warn() {},
      error: function error() {}
    };
    var v = /^[a-z_$][a-z0-9_$:-]*$/i;

    function g(e, t) {
      var n = this.RULES;
      if (M.eachItem(e, function (e) {
        if (n.keywords[e]) throw new Error("Keyword ".concat(e, " is already defined"));
        if (!v.test(e)) throw new Error("Keyword ".concat(e, " has invalid name"));
      }), t && t.$data && !("code" in t) && !("validate" in t)) throw new Error('$data keyword must have "code" or "validate" function');
    }

    function _(e, t, n) {
      var _this28 = this;

      var a;
      var r = null == t ? void 0 : t.post;
      if (n && r) throw new Error('keyword with "post" flag cannot have "type"');
      var s = this.RULES;
      var i = r ? s.post : s.rules.find(function (_ref36) {
        var e = _ref36.type;
        return e === n;
      });
      if (i || (i = {
        type: n,
        rules: []
      }, s.rules.push(i)), s.keywords[e] = !0, !t) return;
      var o = {
        keyword: e,
        definition: _objectSpread({}, t, {
          type: C.getJSONTypes(t.type),
          schemaType: C.getJSONTypes(t.schemaType)
        })
      };
      t.before ? T.call(this, i, o, t.before) : i.rules.push(o), s.all[e] = o, null === (a = t.implements) || void 0 === a || a.forEach(function (e) {
        return _this28.addKeyword(e);
      });
    }

    function T(e, t, n) {
      var a = e.rules.findIndex(function (e) {
        return e.keyword === n;
      });
      a >= 0 ? e.rules.splice(a, 0, t) : (e.rules.push(t), this.logger.warn("rule ".concat(n, " is not defined")));
    }

    function w(e) {
      var t = e.metaSchema;
      void 0 !== t && (e.$data && this.opts.$data && (t = A(t)), e.validateSchema = this.compile(t, !0));
    }

    var $ = {
      $ref: "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#"
    };

    function A(e) {
      return {
        anyOf: [e, $]
      };
    }
  });
  r(D), D.CodeGen, D.Name, D.nil, D.stringify, D.str, D._, D.KeywordCxt;
  var U = s(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = {
      keyword: "id",
      code: function code() {
        throw new Error('NOT SUPPORTED: keyword "id", use "$id" for schema ID');
      }
    };
    t.default = n;
  });
  r(U);
  var V = s(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.callRef = t.getValidate = void 0;
    var n = {
      keyword: "$ref",
      schemaType: "string",
      code: function code(e) {
        var t = e.gen,
            n = e.schema,
            s = e.it,
            i = s.baseId,
            o = s.schemaEnv,
            p = s.validateName,
            u = s.opts,
            d = s.self;
        if ("#" === n || "#/" === n) return function () {
          if (o === o.root) return r(e, p, o, o.$async);
          var n = t.scopeValue("root", {
            ref: o.root
          });
          return r(e, l._(_templateObject165 || (_templateObject165 = _taggedTemplateLiteral(["", ".validate"])), n), o.root, o.root.$async);
        }();
        var c = S.resolveRef.call(d, o.root, i, n);
        if (void 0 === c) throw new N.MissingRefError(i, n);
        return c instanceof S.SchemaEnv ? function (t) {
          var n = a(e, t);
          r(e, n, t, t.$async);
        }(c) : function (a) {
          var r = t.scopeValue("schema", !0 === u.code.source ? {
            ref: a,
            code: l.stringify(a)
          } : {
            ref: a
          }),
              s = t.name("valid"),
              i = e.subschema({
            schema: a,
            dataTypes: [],
            schemaPath: l.nil,
            topSchemaRef: r,
            errSchemaPath: n
          }, s);
          e.mergeEvaluated(i), e.ok(s);
        }(c);
      }
    };

    function a(e, t) {
      var n = e.gen;
      return t.validate ? n.scopeValue("validate", {
        ref: t.validate
      }) : l._(_templateObject166 || (_templateObject166 = _taggedTemplateLiteral(["", ".validate"])), n.scopeValue("wrapper", {
        ref: t
      }));
    }

    function r(e, t, n, a) {
      var r = e.gen,
          s = e.it,
          i = s.allErrors,
          o = s.schemaEnv,
          p = s.opts,
          u = p.passContext ? c.default.this : l.nil;

      function d(e) {
        var t = l._(_templateObject167 || (_templateObject167 = _taggedTemplateLiteral(["", ".errors"])), e);

        r.assign(c.default.vErrors, l._(_templateObject168 || (_templateObject168 = _taggedTemplateLiteral(["", " === null ? ", " : ", ".concat(", ")"])), c.default.vErrors, t, c.default.vErrors, t)), r.assign(c.default.errors, l._(_templateObject169 || (_templateObject169 = _taggedTemplateLiteral(["", ".length"])), c.default.vErrors));
      }

      function y(e) {
        var t;
        if (!s.opts.unevaluated) return;
        var a = null === (t = null == n ? void 0 : n.validate) || void 0 === t ? void 0 : t.evaluated;
        if (!0 !== s.props) if (a && !a.dynamicProps) void 0 !== a.props && (s.props = M.mergeEvaluated.props(r, a.props, s.props));else {
          var _t18 = r.var("props", l._(_templateObject170 || (_templateObject170 = _taggedTemplateLiteral(["", ".evaluated.props"])), e));

          s.props = M.mergeEvaluated.props(r, _t18, s.props, l.Name);
        }
        if (!0 !== s.items) if (a && !a.dynamicItems) void 0 !== a.items && (s.items = M.mergeEvaluated.items(r, a.items, s.items));else {
          var _t19 = r.var("items", l._(_templateObject171 || (_templateObject171 = _taggedTemplateLiteral(["", ".evaluated.items"])), e));

          s.items = M.mergeEvaluated.items(r, _t19, s.items, l.Name);
        }
      }

      a ? function () {
        if (!o.$async) throw new Error("async schema referenced by sync schema");
        var n = r.let("valid");
        r.try(function () {
          r.code(l._(_templateObject172 || (_templateObject172 = _taggedTemplateLiteral(["await ", ""])), b.callValidateCode(e, t, u))), y(t), i || r.assign(n, !0);
        }, function (e) {
          r.if(l._(_templateObject173 || (_templateObject173 = _taggedTemplateLiteral(["!(", " instanceof ", ")"])), e, s.ValidationError), function () {
            return r.throw(e);
          }), d(e), i || r.assign(n, !1);
        }), e.ok(n);
      }() : e.result(b.callValidateCode(e, t, u), function () {
        return y(t);
      }, function () {
        return d(t);
      });
    }

    t.getValidate = a, t.callRef = r, t.default = n;
  });
  r(V), V.callRef, V.getValidate;
  var F = s(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = ["$schema", "$id", "$defs", "$vocabulary", {
      keyword: "$comment"
    }, "definitions", U.default, V.default];
    t.default = n;
  });
  r(F);
  var B = s(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = l.operators,
        a = {
      maximum: {
        okStr: "<=",
        ok: n.LTE,
        fail: n.GT
      },
      minimum: {
        okStr: ">=",
        ok: n.GTE,
        fail: n.LT
      },
      exclusiveMaximum: {
        okStr: "<",
        ok: n.LT,
        fail: n.GTE
      },
      exclusiveMinimum: {
        okStr: ">",
        ok: n.GT,
        fail: n.LTE
      }
    },
        r = {
      message: function message(_ref37) {
        var e = _ref37.keyword,
            t = _ref37.schemaCode;
        return l.str(_templateObject174 || (_templateObject174 = _taggedTemplateLiteral(["should be ", " ", ""])), a[e].okStr, t);
      },
      params: function params(_ref38) {
        var e = _ref38.keyword,
            t = _ref38.schemaCode;
        return l._(_templateObject175 || (_templateObject175 = _taggedTemplateLiteral(["{comparison: ", ", limit: ", "}"])), a[e].okStr, t);
      }
    },
        s = {
      keyword: Object.keys(a),
      type: "number",
      schemaType: "number",
      $data: !0,
      error: r,
      code: function code(e) {
        var t = e.keyword,
            n = e.data,
            r = e.schemaCode;
        e.fail$data(l._(_templateObject176 || (_templateObject176 = _taggedTemplateLiteral(["", " ", " ", " || isNaN(", ")"])), n, a[t].fail, r, n));
      }
    };
    t.default = s;
  });
  r(B);
  var H = s(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = {
      keyword: "multipleOf",
      type: "number",
      schemaType: "number",
      $data: !0,
      error: {
        message: function message(_ref39) {
          var e = _ref39.schemaCode;
          return l.str(_templateObject177 || (_templateObject177 = _taggedTemplateLiteral(["should be multiple of ", ""])), e);
        },
        params: function params(_ref40) {
          var e = _ref40.schemaCode;
          return l._(_templateObject178 || (_templateObject178 = _taggedTemplateLiteral(["{multipleOf: ", "}"])), e);
        }
      },
      code: function code(e) {
        var t = e.gen,
            n = e.data,
            a = e.schemaCode,
            r = e.it,
            s = r.opts.multipleOfPrecision,
            i = t.let("res"),
            o = s ? l._(_templateObject179 || (_templateObject179 = _taggedTemplateLiteral(["Math.abs(Math.round(", ") - ", ") > 1e-", ""])), i, i, s) : l._(_templateObject180 || (_templateObject180 = _taggedTemplateLiteral(["", " !== parseInt(", ")"])), i, i);
        e.fail$data(l._(_templateObject181 || (_templateObject181 = _taggedTemplateLiteral(["(", " === 0 || (", " = ", "/", ", ", "))"])), a, i, n, a, o));
      }
    };
    t.default = n;
  });
  r(H);
  var L = s(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = function (e) {
      var t = e.length;
      var n,
          a = 0,
          r = 0;

      for (; r < t;) {
        a++, n = e.charCodeAt(r++), n >= 55296 && n <= 56319 && r < t && (n = e.charCodeAt(r), 56320 == (64512 & n) && r++);
      }

      return a;
    };
  });
  r(L);
  var K = s(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = {
      keyword: ["maxLength", "minLength"],
      type: "string",
      schemaType: "number",
      $data: !0,
      error: {
        message: function message(_ref41) {
          var e = _ref41.keyword,
              t = _ref41.schemaCode;
          var n = "maxLength" === e ? "more" : "fewer";
          return l.str(_templateObject182 || (_templateObject182 = _taggedTemplateLiteral(["should NOT have ", " than ", " characters"])), n, t);
        },
        params: function params(_ref42) {
          var e = _ref42.schemaCode;
          return l._(_templateObject183 || (_templateObject183 = _taggedTemplateLiteral(["{limit: ", "}"])), e);
        }
      },
      code: function code(e) {
        var t = e.keyword,
            n = e.data,
            a = e.schemaCode,
            r = e.it,
            s = "maxLength" === t ? l.operators.GT : l.operators.LT;
        var i;
        if (!1 === r.opts.unicode) i = l._(_templateObject184 || (_templateObject184 = _taggedTemplateLiteral(["", ".length"])), n);else {
          var _t20 = e.gen.scopeValue("func", {
            ref: L.default,
            code: l._(_templateObject185 || (_templateObject185 = _taggedTemplateLiteral(["require(\"ajv/dist/compile/ucs2length\").default"])))
          });

          i = l._(_templateObject186 || (_templateObject186 = _taggedTemplateLiteral(["", "(", ")"])), _t20, n);
        }
        e.fail$data(l._(_templateObject187 || (_templateObject187 = _taggedTemplateLiteral(["", " ", " ", ""])), i, s, a));
      }
    };
    t.default = n;
  });
  r(K);
  var z = s(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = {
      keyword: "pattern",
      type: "string",
      schemaType: "string",
      $data: !0,
      error: {
        message: function message(_ref43) {
          var e = _ref43.schemaCode;
          return l.str(_templateObject188 || (_templateObject188 = _taggedTemplateLiteral(["should match pattern \"", "\""])), e);
        },
        params: function params(_ref44) {
          var e = _ref44.schemaCode;
          return l._(_templateObject189 || (_templateObject189 = _taggedTemplateLiteral(["{pattern: ", "}"])), e);
        }
      },
      code: function code(e) {
        var t = e.gen,
            n = e.data,
            a = e.$data,
            r = e.schema,
            s = e.schemaCode,
            i = a ? l._(_templateObject190 || (_templateObject190 = _taggedTemplateLiteral(["(new RegExp(", ", \"u\"))"])), s) : b.usePattern(t, r);
        e.fail$data(l._(_templateObject191 || (_templateObject191 = _taggedTemplateLiteral(["!", ".test(", ")"])), i, n));
      }
    };
    t.default = n;
  });
  r(z);
  var q = s(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = {
      keyword: ["maxProperties", "minProperties"],
      type: "object",
      schemaType: "number",
      $data: !0,
      error: {
        message: function message(_ref45) {
          var e = _ref45.keyword,
              t = _ref45.schemaCode;
          var n = "maxProperties" === e ? "more" : "fewer";
          return l.str(_templateObject192 || (_templateObject192 = _taggedTemplateLiteral(["should NOT have ", " than ", " items"])), n, t);
        },
        params: function params(_ref46) {
          var e = _ref46.schemaCode;
          return l._(_templateObject193 || (_templateObject193 = _taggedTemplateLiteral(["{limit: ", "}"])), e);
        }
      },
      code: function code(e) {
        var t = e.keyword,
            n = e.data,
            a = e.schemaCode,
            r = "maxProperties" === t ? l.operators.GT : l.operators.LT;
        e.fail$data(l._(_templateObject194 || (_templateObject194 = _taggedTemplateLiteral(["Object.keys(", ").length ", " ", ""])), n, r, a));
      }
    };
    t.default = n;
  });
  r(q);
  var G = s(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = {
      keyword: "required",
      type: "object",
      schemaType: "array",
      $data: !0,
      error: {
        message: function message(_ref47) {
          var e = _ref47.params.missingProperty;
          return l.str(_templateObject195 || (_templateObject195 = _taggedTemplateLiteral(["should have required property '", "'"])), e);
        },
        params: function params(_ref48) {
          var e = _ref48.params.missingProperty;
          return l._(_templateObject196 || (_templateObject196 = _taggedTemplateLiteral(["{missingProperty: ", "}"])), e);
        }
      },
      code: function code(e) {
        var t = e.gen,
            n = e.schema,
            a = e.schemaCode,
            r = e.data,
            s = e.$data,
            i = e.it,
            o = i.opts;
        if (!s && 0 === n.length) return;
        var p = n.length >= o.loopRequired;

        if (i.allErrors ? function () {
          if (p || s) e.block$data(l.nil, u);else {
            var _iterator15 = _createForOfIteratorHelper(n),
                _step15;

            try {
              for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
                var _t21 = _step15.value;
                b.checkReportMissingProp(e, _t21);
              }
            } catch (err) {
              _iterator15.e(err);
            } finally {
              _iterator15.f();
            }
          }
        }() : function () {
          var i = t.let("missing");

          if (p || s) {
            var _n30 = t.let("valid", !0);

            e.block$data(_n30, function () {
              return function (n, s) {
                e.setParams({
                  missingProperty: n
                }), t.forOf(n, a, function () {
                  t.assign(s, b.propertyInData(t, r, n, o.ownProperties)), t.if(l.not(s), function () {
                    e.error(), t.break();
                  });
                }, l.nil);
              }(i, _n30);
            }), e.ok(_n30);
          } else t.if(b.checkMissingProp(e, n, i)), b.reportMissingProp(e, i), t.else();
        }(), o.strictRequired) {
          var _t22 = e.parentSchema.properties,
              _a9 = e.it.definedProperties;

          var _iterator16 = _createForOfIteratorHelper(n),
              _step16;

          try {
            for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
              var _e21 = _step16.value;

              if (void 0 === (null == _t22 ? void 0 : _t22[_e21]) && !_a9.has(_e21)) {
                var _t23 = "required property \"".concat(_e21, "\" is not defined at \"").concat(i.schemaEnv.baseId + i.errSchemaPath, "\" (strictRequired)");

                $.checkStrictMode(i, _t23, i.opts.strictRequired);
              }
            }
          } catch (err) {
            _iterator16.e(err);
          } finally {
            _iterator16.f();
          }
        }

        function u() {
          t.forOf("prop", a, function (n) {
            e.setParams({
              missingProperty: n
            }), t.if(b.noPropertyInData(t, r, n, o.ownProperties), function () {
              return e.error();
            });
          });
        }
      }
    };
    t.default = n;
  });
  r(G);
  var J = s(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = {
      keyword: ["maxItems", "minItems"],
      type: "array",
      schemaType: "number",
      $data: !0,
      error: {
        message: function message(_ref49) {
          var e = _ref49.keyword,
              t = _ref49.schemaCode;
          var n = "maxItems" === e ? "more" : "fewer";
          return l.str(_templateObject197 || (_templateObject197 = _taggedTemplateLiteral(["should NOT have ", " than ", " items"])), n, t);
        },
        params: function params(_ref50) {
          var e = _ref50.schemaCode;
          return l._(_templateObject198 || (_templateObject198 = _taggedTemplateLiteral(["{limit: ", "}"])), e);
        }
      },
      code: function code(e) {
        var t = e.keyword,
            n = e.data,
            a = e.schemaCode,
            r = "maxItems" === t ? l.operators.GT : l.operators.LT;
        e.fail$data(l._(_templateObject199 || (_templateObject199 = _taggedTemplateLiteral(["", ".length ", " ", ""])), n, r, a));
      }
    };
    t.default = n;
  });
  r(J);
  var Y = s(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = {
      keyword: "uniqueItems",
      type: "array",
      schemaType: "boolean",
      $data: !0,
      error: {
        message: function message(_ref51) {
          var _ref51$params = _ref51.params,
              e = _ref51$params.i,
              t = _ref51$params.j;
          return l.str(_templateObject200 || (_templateObject200 = _taggedTemplateLiteral(["should NOT have duplicate items (items ## ", " and ", " are identical)"])), t, e);
        },
        params: function params(_ref52) {
          var _ref52$params = _ref52.params,
              e = _ref52$params.i,
              t = _ref52$params.j;
          return l._(_templateObject201 || (_templateObject201 = _taggedTemplateLiteral(["{i: ", ", j: ", "}"])), e, t);
        }
      },
      code: function code(e) {
        var t = e.gen,
            n = e.data,
            a = e.$data,
            r = e.schema,
            s = e.parentSchema,
            i = e.schemaCode,
            o = e.it;
        if (!a && !r) return;
        var p = t.let("valid"),
            u = s.items ? C.getSchemaTypes(s.items) : [];

        function d(a, r) {
          var s = t.name("item"),
              i = C.checkDataTypes(u, s, o.opts.strict, C.DataType.Wrong),
              d = t.const("indices", l._(_templateObject202 || (_templateObject202 = _taggedTemplateLiteral(["{}"]))));
          t.for(l._(_templateObject203 || (_templateObject203 = _taggedTemplateLiteral([";", "--;"])), a), function () {
            t.let(s, l._(_templateObject204 || (_templateObject204 = _taggedTemplateLiteral(["", "[", "]"])), n, a)), t.if(i, l._(_templateObject205 || (_templateObject205 = _taggedTemplateLiteral(["continue"])))), u.length > 1 && t.if(l._(_templateObject206 || (_templateObject206 = _taggedTemplateLiteral(["typeof ", " == \"string\""])), s), l._(_templateObject207 || (_templateObject207 = _taggedTemplateLiteral(["", " += \"_\""])), s)), t.if(l._(_templateObject208 || (_templateObject208 = _taggedTemplateLiteral(["typeof ", "[", "] == \"number\""])), d, s), function () {
              t.assign(r, l._(_templateObject209 || (_templateObject209 = _taggedTemplateLiteral(["", "[", "]"])), d, s)), e.error(), t.assign(p, !1).break();
            }).code(l._(_templateObject210 || (_templateObject210 = _taggedTemplateLiteral(["", "[", "] = ", ""])), d, s, a));
          });
        }

        function c(a, r) {
          var s = e.gen.scopeValue("func", {
            ref: _,
            code: l._(_templateObject211 || (_templateObject211 = _taggedTemplateLiteral(["require(\"ajv/dist/compile/equal\")"])))
          }),
              i = t.name("outer");
          t.label(i).for(l._(_templateObject212 || (_templateObject212 = _taggedTemplateLiteral([";", "--;"])), a), function () {
            return t.for(l._(_templateObject213 || (_templateObject213 = _taggedTemplateLiteral(["", " = ", "; ", "--;"])), r, a, r), function () {
              return t.if(l._(_templateObject214 || (_templateObject214 = _taggedTemplateLiteral(["", "(", "[", "], ", "[", "])"])), s, n, a, n, r), function () {
                e.error(), t.assign(p, !1).break(i);
              });
            });
          });
        }

        e.block$data(p, function () {
          var a = t.let("i", l._(_templateObject215 || (_templateObject215 = _taggedTemplateLiteral(["", ".length"])), n)),
              r = t.let("j");
          e.setParams({
            i: a,
            j: r
          }), t.assign(p, !0), t.if(l._(_templateObject216 || (_templateObject216 = _taggedTemplateLiteral(["", " > 1"])), a), function () {
            return (u.length > 0 && !u.some(function (e) {
              return "object" === e || "array" === e;
            }) ? d : c)(a, r);
          });
        }, l._(_templateObject217 || (_templateObject217 = _taggedTemplateLiteral(["", " === false"])), i)), e.ok(p);
      }
    };
    t.default = n;
  });
  r(Y);
  var W = s(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = {
      keyword: "const",
      $data: !0,
      error: {
        message: "should be equal to constant",
        params: function params(_ref53) {
          var e = _ref53.schemaCode;
          return l._(_templateObject218 || (_templateObject218 = _taggedTemplateLiteral(["{allowedValue: ", "}"])), e);
        }
      },
      code: function code(e) {
        var t = e.gen.scopeValue("func", {
          ref: _,
          code: l._(_templateObject219 || (_templateObject219 = _taggedTemplateLiteral(["require(\"ajv/dist/compile/equal\")"])))
        });
        e.fail$data(l._(_templateObject220 || (_templateObject220 = _taggedTemplateLiteral(["!", "(", ", ", ")"])), t, e.data, e.schemaCode));
      }
    };
    t.default = n;
  });
  r(W);
  var Q = s(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = {
      keyword: "enum",
      schemaType: "array",
      $data: !0,
      error: {
        message: "should be equal to one of the allowed values",
        params: function params(_ref54) {
          var e = _ref54.schemaCode;
          return l._(_templateObject221 || (_templateObject221 = _taggedTemplateLiteral(["{allowedValues: ", "}"])), e);
        }
      },
      code: function code(e) {
        var t = e.gen,
            n = e.data,
            a = e.$data,
            r = e.schema,
            s = e.schemaCode,
            i = e.it;
        if (!a && 0 === r.length) throw new Error("enum must have non-empty array");
        var o = r.length >= i.opts.loopEnum,
            p = e.gen.scopeValue("func", {
          ref: _,
          code: l._(_templateObject222 || (_templateObject222 = _taggedTemplateLiteral(["require(\"ajv/dist/compile/equal\")"])))
        });
        var u;
        if (o || a) u = t.let("valid"), e.block$data(u, function () {
          t.assign(u, !1), t.forOf("v", s, function (e) {
            return t.if(l._(_templateObject223 || (_templateObject223 = _taggedTemplateLiteral(["", "(", ", ", ")"])), p, n, e), function () {
              return t.assign(u, !0).break();
            });
          });
        });else {
          if (!Array.isArray(r)) throw new Error("ajv implementation error");

          var _e22 = t.const("vSchema", s);

          u = l.or.apply(l, _toConsumableArray(r.map(function (t, a) {
            return function (e, t) {
              var a = r[t];
              return a && "object" == typeof a ? l._(_templateObject224 || (_templateObject224 = _taggedTemplateLiteral(["", "(", ", ", "[", "])"])), p, n, e, t) : l._(_templateObject225 || (_templateObject225 = _taggedTemplateLiteral(["", " === ", ""])), n, a);
            }(_e22, a);
          })));
        }
        e.pass(u);
      }
    };
    t.default = n;
  });
  r(Q);
  var Z = s(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = [B.default, H.default, K.default, z.default, q.default, G.default, J.default, Y.default, {
      keyword: "type",
      schemaType: ["string", "array"]
    }, {
      keyword: "nullable",
      schemaType: "boolean"
    }, W.default, Q.default];
    t.default = n;
  });
  r(Z);
  var X = s(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = {
      keyword: "additionalItems",
      type: "array",
      schemaType: ["boolean", "object"],
      before: "uniqueItems",
      error: {
        message: function message(_ref55) {
          var e = _ref55.params.len;
          return l.str(_templateObject226 || (_templateObject226 = _taggedTemplateLiteral(["should NOT have more than ", " items"])), e);
        },
        params: function params(_ref56) {
          var e = _ref56.params.len;
          return l._(_templateObject227 || (_templateObject227 = _taggedTemplateLiteral(["{limit: ", "}"])), e);
        }
      },
      code: function code(e) {
        var t = e.gen,
            n = e.schema,
            a = e.parentSchema,
            r = e.data,
            s = e.it,
            i = a.items;
        if (!Array.isArray(i)) return void $.checkStrictMode(s, '"additionalItems" is ignored when "items" is not an array of schemas');
        s.items = !0;
        var o = t.const("len", l._(_templateObject228 || (_templateObject228 = _taggedTemplateLiteral(["", ".length"])), r));
        if (!1 === n) e.setParams({
          len: i.length
        }), e.pass(l._(_templateObject229 || (_templateObject229 = _taggedTemplateLiteral(["", " <= ", ""])), o, i.length));else if ("object" == typeof n && !M.alwaysValidSchema(s, n)) {
          var _n31 = t.var("valid", l._(_templateObject230 || (_templateObject230 = _taggedTemplateLiteral(["", " <= ", ""])), o, i.length));

          t.if(l.not(_n31), function () {
            return function (n) {
              t.forRange("i", i.length, o, function (a) {
                e.subschema({
                  keyword: "additionalItems",
                  dataProp: a,
                  dataPropType: h.Type.Num
                }, n), s.allErrors || t.if(l.not(n), function () {
                  return t.break();
                });
              });
            }(_n31);
          }), e.ok(_n31);
        }
      }
    };
    t.default = n;
  });
  r(X);
  var ee = s(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = {
      keyword: "items",
      type: "array",
      schemaType: ["object", "array", "boolean"],
      before: "uniqueItems",
      code: function code(e) {
        var t = e.gen,
            n = e.schema,
            a = e.it;
        if (Array.isArray(n)) a.opts.unevaluated && n.length && !0 !== a.items && (a.items = M.mergeEvaluated.items(t, n.length, a.items)), function (n) {
          var r = e.parentSchema,
              s = e.data;

          if (a.opts.strictTuples && !function (e, t) {
            return e === t.minItems && (e === t.maxItems || !1 === t.additionalItems);
          }(n.length, r)) {
            var _e23 = "\"items\" is ".concat(n.length, "-tuple, but minItems or maxItems/additionalItems are not specified or different");

            $.checkStrictMode(a, _e23, a.opts.strictTuples);
          }

          var i = t.name("valid"),
              o = t.const("len", l._(_templateObject231 || (_templateObject231 = _taggedTemplateLiteral(["", ".length"])), s));
          n.forEach(function (n, r) {
            M.alwaysValidSchema(a, n) || (t.if(l._(_templateObject232 || (_templateObject232 = _taggedTemplateLiteral(["", " > ", ""])), o, r), function () {
              return e.subschema({
                keyword: "items",
                schemaProp: r,
                dataProp: r
              }, i);
            }), e.ok(i));
          });
        }(n);else {
          if (a.items = !0, M.alwaysValidSchema(a, n)) return;
          e.ok(b.validateArray(e));
        }
      }
    };
    t.default = n;
  });
  r(ee);
  var te = s(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = {
      keyword: "contains",
      type: "array",
      schemaType: ["object", "boolean"],
      before: "uniqueItems",
      trackErrors: !0,
      error: {
        message: function message(_ref57) {
          var _ref57$params = _ref57.params,
              e = _ref57$params.min,
              t = _ref57$params.max;
          return void 0 === t ? l.str(_templateObject233 || (_templateObject233 = _taggedTemplateLiteral(["should contain at least ", " valid item(s)"])), e) : l.str(_templateObject234 || (_templateObject234 = _taggedTemplateLiteral(["should contain at least ", " and no more than ", " valid item(s)"])), e, t);
        },
        params: function params(_ref58) {
          var _ref58$params = _ref58.params,
              e = _ref58$params.min,
              t = _ref58$params.max;
          return void 0 === t ? l._(_templateObject235 || (_templateObject235 = _taggedTemplateLiteral(["{minContains: ", "}"])), e) : l._(_templateObject236 || (_templateObject236 = _taggedTemplateLiteral(["{minContains: ", ", maxContains: ", "}"])), e, t);
        }
      },
      code: function code(e) {
        var t = e.gen,
            n = e.schema,
            a = e.parentSchema,
            r = e.data,
            s = e.it;
        var i, o;
        var p = a.minContains,
            u = a.maxContains;
        s.opts.next ? (i = void 0 === p ? 1 : p, o = u) : i = 1;
        var d = t.const("len", l._(_templateObject237 || (_templateObject237 = _taggedTemplateLiteral(["", ".length"])), r));
        if (e.setParams({
          min: i,
          max: o
        }), void 0 === o && 0 === i) return void $.checkStrictMode(s, '"minContains" == 0 without "maxContains": "contains" keyword ignored');
        if (void 0 !== o && i > o) return $.checkStrictMode(s, '"minContains" > "maxContains" is always invalid'), void e.fail();

        if (M.alwaysValidSchema(s, n)) {
          var _t24 = l._(_templateObject238 || (_templateObject238 = _taggedTemplateLiteral(["", " >= ", ""])), d, i);

          return void 0 !== o && (_t24 = l._(_templateObject239 || (_templateObject239 = _taggedTemplateLiteral(["", " && ", " <= ", ""])), _t24, d, o)), void e.pass(_t24);
        }

        s.items = !0;
        var c = t.name("valid");
        if (void 0 === o && 1 === i) y(c, function () {
          return t.if(c, function () {
            return t.break();
          });
        });else {
          t.let(c, !1);

          var _e24 = t.name("_valid"),
              _n32 = t.let("count", 0);

          y(_e24, function () {
            return t.if(_e24, function () {
              return function (e) {
                t.code(l._(_templateObject240 || (_templateObject240 = _taggedTemplateLiteral(["", "++"])), e)), void 0 === o ? t.if(l._(_templateObject241 || (_templateObject241 = _taggedTemplateLiteral(["", " >= ", ""])), e, i), function () {
                  return t.assign(c, !0).break();
                }) : (t.if(l._(_templateObject242 || (_templateObject242 = _taggedTemplateLiteral(["", " > ", ""])), e, o), function () {
                  return t.assign(c, !1).break();
                }), 1 === i ? t.assign(c, !0) : t.if(l._(_templateObject243 || (_templateObject243 = _taggedTemplateLiteral(["", " >= ", ""])), e, i), function () {
                  return t.assign(c, !0);
                }));
              }(_n32);
            });
          });
        }

        function y(n, a) {
          t.forRange("i", 0, d, function (t) {
            e.subschema({
              keyword: "contains",
              dataProp: t,
              dataPropType: h.Type.Num,
              compositeRule: !0
            }, n), a();
          });
        }

        e.result(c, function () {
          return e.reset();
        });
      }
    };
    t.default = n;
  });
  r(te);
  var ne = s(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.validateSchemaDeps = t.validatePropertyDeps = t.error = void 0, t.error = {
      message: function message(_ref59) {
        var _ref59$params = _ref59.params,
            e = _ref59$params.property,
            t = _ref59$params.depsCount,
            n = _ref59$params.deps;
        var a = 1 === t ? "property" : "properties";
        return l.str(_templateObject244 || (_templateObject244 = _taggedTemplateLiteral(["should have ", " ", " when property ", " is present"])), a, n, e);
      },
      params: function params(_ref60) {
        var _ref60$params = _ref60.params,
            e = _ref60$params.property,
            t = _ref60$params.depsCount,
            n = _ref60$params.deps,
            a = _ref60$params.missingProperty;
        return l._(_templateObject245 || (_templateObject245 = _taggedTemplateLiteral(["{property: ", ",\n    missingProperty: ", ",\n    depsCount: ", ",\n    deps: ", "}"])), e, a, t, n);
      }
    };
    var n = {
      keyword: "dependencies",
      type: "object",
      schemaType: "object",
      error: t.error,
      code: function code(e) {
        var _ref61 = function (_ref63) {
          var e = _ref63.schema;
          var t = {},
              n = {};

          for (var _a10 in e) {
            if ("__proto__" === _a10) continue;
            (Array.isArray(e[_a10]) ? t : n)[_a10] = e[_a10];
          }

          return [t, n];
        }(e),
            _ref62 = _slicedToArray(_ref61, 2),
            t = _ref62[0],
            n = _ref62[1];

        a(e, t), r(e, n);
      }
    };

    function a(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : e.schema;
      var n = e.gen,
          a = e.data,
          r = e.it;
      if (0 === Object.keys(t).length) return;
      var s = n.let("missing");

      var _loop2 = function _loop2(_i5) {
        var o = t[_i5];
        if (0 === o.length) return "continue";
        var p = b.propertyInData(n, a, _i5, r.opts.ownProperties);
        e.setParams({
          property: _i5,
          depsCount: o.length,
          deps: o.join(", ")
        }), r.allErrors ? n.if(p, function () {
          var _iterator17 = _createForOfIteratorHelper(o),
              _step17;

          try {
            for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
              var _t25 = _step17.value;
              b.checkReportMissingProp(e, _t25);
            }
          } catch (err) {
            _iterator17.e(err);
          } finally {
            _iterator17.f();
          }
        }) : (n.if(l._(_templateObject246 || (_templateObject246 = _taggedTemplateLiteral(["", " && (", ")"])), p, b.checkMissingProp(e, o, s))), b.reportMissingProp(e, s), n.else());
      };

      for (var _i5 in t) {
        var _ret2 = _loop2(_i5);

        if (_ret2 === "continue") continue;
      }
    }

    function r(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : e.schema;
      var n = e.gen,
          a = e.data,
          r = e.keyword,
          s = e.it,
          i = n.name("valid");

      var _loop3 = function _loop3(_o3) {
        M.alwaysValidSchema(s, t[_o3]) || (n.if(b.propertyInData(n, a, _o3, s.opts.ownProperties), function () {
          var t = e.subschema({
            keyword: r,
            schemaProp: _o3
          }, i);
          e.mergeValidEvaluated(t, i);
        }, function () {
          return n.var(i, !0);
        }), e.ok(i));
      };

      for (var _o3 in t) {
        _loop3(_o3);
      }
    }

    t.validatePropertyDeps = a, t.validateSchemaDeps = r, t.default = n;
  });
  r(ne), ne.validateSchemaDeps, ne.validatePropertyDeps, ne.error;
  var ae = s(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = {
      keyword: "propertyNames",
      type: "object",
      schemaType: ["object", "boolean"],
      error: {
        message: function message(_ref64) {
          var e = _ref64.params;
          return l.str(_templateObject247 || (_templateObject247 = _taggedTemplateLiteral(["property name '", "' is invalid"])), e.propertyName);
        },
        params: function params(_ref65) {
          var e = _ref65.params;
          return l._(_templateObject248 || (_templateObject248 = _taggedTemplateLiteral(["{propertyName: ", "}"])), e.propertyName);
        }
      },
      code: function code(e) {
        var t = e.gen,
            n = e.schema,
            a = e.data,
            r = e.it;
        if (M.alwaysValidSchema(r, n)) return;
        var s = t.name("valid");
        t.forIn("key", a, function (n) {
          e.setParams({
            propertyName: n
          }), e.subschema({
            keyword: "propertyNames",
            data: n,
            dataTypes: ["string"],
            propertyName: n,
            compositeRule: !0
          }, s), t.if(l.not(s), function () {
            e.error(!0), r.allErrors || t.break();
          });
        }), e.ok(s);
      }
    };
    t.default = n;
  });
  r(ae);
  var re = s(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = {
      keyword: "additionalProperties",
      type: ["object"],
      schemaType: ["boolean", "object"],
      allowUndefined: !0,
      trackErrors: !0,
      error: {
        message: "should NOT have additional properties",
        params: function params(_ref66) {
          var e = _ref66.params;
          return l._(_templateObject249 || (_templateObject249 = _taggedTemplateLiteral(["{additionalProperty: ", "}"])), e.additionalProperty);
        }
      },
      code: function code(e) {
        var t = e.gen,
            n = e.schema,
            a = e.parentSchema,
            r = e.data,
            s = e.errsCount,
            i = e.it;
        if (!s) throw new Error("ajv implementation error");
        var o = i.allErrors,
            p = i.opts;
        if (i.props = !0, "all" !== p.removeAdditional && M.alwaysValidSchema(i, n)) return;
        var u = b.allSchemaProperties(a.properties),
            d = b.allSchemaProperties(a.patternProperties);

        function y(e) {
          t.code(l._(_templateObject250 || (_templateObject250 = _taggedTemplateLiteral(["delete ", "[", "]"])), r, e));
        }

        function m(a) {
          if ("all" === p.removeAdditional || p.removeAdditional && !1 === n) y(a);else {
            if (!1 === n) return e.setParams({
              additionalProperty: a
            }), e.error(), void (o || t.break());

            if ("object" == typeof n && !M.alwaysValidSchema(i, n)) {
              var _n33 = t.name("valid");

              "failing" === p.removeAdditional ? (f(a, _n33, !1), t.if(l.not(_n33), function () {
                e.reset(), y(a);
              })) : (f(a, _n33), o || t.if(l.not(_n33), function () {
                return t.break();
              }));
            }
          }
        }

        function f(t, n, a) {
          var r = {
            keyword: "additionalProperties",
            dataProp: t,
            dataPropType: h.Type.Str
          };
          !1 === a && Object.assign(r, {
            compositeRule: !0,
            createErrors: !1,
            allErrors: !1
          }), e.subschema(r, n);
        }

        t.forIn("key", r, function (e) {
          u.length || d.length ? t.if(function (e) {
            var n;

            if (u.length > 8) {
              var _r17 = M.schemaRefOrVal(i, a.properties, "properties");

              n = b.isOwnProperty(t, _r17, e);
            } else n = u.length ? l.or.apply(l, _toConsumableArray(u.map(function (t) {
              return l._(_templateObject251 || (_templateObject251 = _taggedTemplateLiteral(["", " === ", ""])), e, t);
            }))) : l.nil;

            return d.length && (n = l.or.apply(l, [n].concat(_toConsumableArray(d.map(function (n) {
              return l._(_templateObject252 || (_templateObject252 = _taggedTemplateLiteral(["", ".test(", ")"])), b.usePattern(t, n), e);
            }))))), l.not(n);
          }(e), function () {
            return m(e);
          }) : m(e);
        }), e.ok(l._(_templateObject253 || (_templateObject253 = _taggedTemplateLiteral(["", " === ", ""])), s, c.default.errors));
      }
    };
    t.default = n;
  });
  r(re);
  var se = s(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = {
      keyword: "properties",
      type: "object",
      schemaType: "object",
      code: function code(e) {
        var t = e.gen,
            n = e.schema,
            a = e.parentSchema,
            r = e.data,
            s = e.it;
        "all" === s.opts.removeAdditional && void 0 === a.additionalProperties && re.default.code(new I.default(s, re.default, "additionalProperties"));
        var i = b.allSchemaProperties(n);

        var _iterator18 = _createForOfIteratorHelper(i),
            _step18;

        try {
          for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
            var _e25 = _step18.value;
            s.definedProperties.add(_e25);
          }
        } catch (err) {
          _iterator18.e(err);
        } finally {
          _iterator18.f();
        }

        s.opts.unevaluated && i.length && !0 !== s.props && (s.props = M.mergeEvaluated.props(t, M.toHash(i), s.props));
        var o = i.filter(function (e) {
          return !M.alwaysValidSchema(s, n[e]);
        });
        if (0 === o.length) return;
        var p = t.name("valid");

        var _iterator19 = _createForOfIteratorHelper(o),
            _step19;

        try {
          for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
            var _n34 = _step19.value;
            u(_n34) ? d(_n34) : (t.if(b.propertyInData(t, r, _n34, s.opts.ownProperties)), d(_n34), s.allErrors || t.else().var(p, !0), t.endIf()), e.it.definedProperties.add(_n34), e.ok(p);
          }
        } catch (err) {
          _iterator19.e(err);
        } finally {
          _iterator19.f();
        }

        function u(e) {
          return s.opts.useDefaults && !s.compositeRule && void 0 !== n[e].default;
        }

        function d(t) {
          e.subschema({
            keyword: "properties",
            schemaProp: t,
            dataProp: t
          }, p);
        }
      }
    };
    t.default = n;
  });
  r(se);
  var ie = s(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = {
      keyword: "patternProperties",
      type: "object",
      schemaType: "object",
      code: function code(e) {
        var t = e.gen,
            n = e.schema,
            a = e.data,
            r = e.parentSchema,
            s = e.it,
            i = s.opts,
            o = b.schemaProperties(s, n);
        if (0 === o.length) return;
        var p = i.strict && !i.allowMatchingProperties && r.properties,
            u = t.name("valid");
        !0 === s.props || s.props instanceof l.Name || (s.props = M.evaluatedPropsToName(t, s.props));
        var d = s.props;

        function c(e) {
          for (var _t26 in p) {
            new RegExp(e).test(_t26) && $.checkStrictMode(s, "property ".concat(_t26, " matches pattern ").concat(e, " (use allowMatchingProperties)"));
          }
        }

        function y(n) {
          t.forIn("key", a, function (a) {
            t.if(l._(_templateObject254 || (_templateObject254 = _taggedTemplateLiteral(["", ".test(", ")"])), b.usePattern(t, n), a), function () {
              e.subschema({
                keyword: "patternProperties",
                schemaProp: n,
                dataProp: a,
                dataPropType: h.Type.Str
              }, u), s.opts.unevaluated && !0 !== d ? t.assign(l._(_templateObject255 || (_templateObject255 = _taggedTemplateLiteral(["", "[", "]"])), d, a), !0) : s.allErrors || t.if(l.not(u), function () {
                return t.break();
              });
            });
          });
        }

        !function () {
          var _iterator20 = _createForOfIteratorHelper(o),
              _step20;

          try {
            for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
              var _e26 = _step20.value;
              p && c(_e26), s.allErrors ? y(_e26) : (t.var(u, !0), y(_e26), t.if(u));
            }
          } catch (err) {
            _iterator20.e(err);
          } finally {
            _iterator20.f();
          }
        }();
      }
    };
    t.default = n;
  });
  r(ie);
  var oe = s(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = {
      keyword: "not",
      schemaType: ["object", "boolean"],
      trackErrors: !0,
      code: function code(e) {
        var t = e.gen,
            n = e.schema,
            a = e.it;
        if (M.alwaysValidSchema(a, n)) return void e.fail();
        var r = t.name("valid");
        e.subschema({
          keyword: "not",
          compositeRule: !0,
          createErrors: !1,
          allErrors: !1
        }, r), e.result(r, function () {
          return e.error();
        }, function () {
          return e.reset();
        });
      },
      error: {
        message: "should NOT be valid"
      }
    };
    t.default = n;
  });
  r(oe);
  var pe = s(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = {
      keyword: "anyOf",
      schemaType: "array",
      trackErrors: !0,
      code: b.validateUnion,
      error: {
        message: "should match some schema in anyOf"
      }
    };
    t.default = n;
  });
  r(pe);
  var ue = s(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = {
      keyword: "oneOf",
      schemaType: "array",
      trackErrors: !0,
      error: {
        message: "should match exactly one schema in oneOf",
        params: function params(_ref67) {
          var e = _ref67.params;
          return l._(_templateObject256 || (_templateObject256 = _taggedTemplateLiteral(["{passingSchemas: ", "}"])), e.passing);
        }
      },
      code: function code(e) {
        var t = e.gen,
            n = e.schema,
            a = e.it;
        if (!Array.isArray(n)) throw new Error("ajv implementation error");
        var r = n,
            s = t.let("valid", !1),
            i = t.let("passing", null),
            o = t.name("_valid");
        e.setParams({
          passing: i
        }), t.block(function () {
          r.forEach(function (n, r) {
            var p;
            M.alwaysValidSchema(a, n) ? t.var(o, !0) : p = e.subschema({
              keyword: "oneOf",
              schemaProp: r,
              compositeRule: !0
            }, o), r > 0 && t.if(l._(_templateObject257 || (_templateObject257 = _taggedTemplateLiteral(["", " && ", ""])), o, s)).assign(s, !1).assign(i, l._(_templateObject258 || (_templateObject258 = _taggedTemplateLiteral(["[", ", ", "]"])), i, r)).else(), t.if(o, function () {
              t.assign(s, !0), t.assign(i, r), p && e.mergeEvaluated(p, l.Name);
            });
          });
        }), e.result(s, function () {
          return e.reset();
        }, function () {
          return e.error(!0);
        });
      }
    };
    t.default = n;
  });
  r(ue);
  var de = s(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = {
      keyword: "allOf",
      schemaType: "array",
      code: function code(e) {
        var t = e.gen,
            n = e.schema,
            a = e.it;
        if (!Array.isArray(n)) throw new Error("ajv implementation error");
        var r = t.name("valid");
        n.forEach(function (t, n) {
          if (M.alwaysValidSchema(a, t)) return;
          var s = e.subschema({
            keyword: "allOf",
            schemaProp: n
          }, r);
          e.ok(r), e.mergeEvaluated(s);
        });
      }
    };
    t.default = n;
  });
  r(de);
  var le = s(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = {
      keyword: "if",
      schemaType: ["object", "boolean"],
      trackErrors: !0,
      error: {
        message: function message(_ref68) {
          var e = _ref68.params;
          return l.str(_templateObject259 || (_templateObject259 = _taggedTemplateLiteral(["should match \"", "\" schema"])), e.ifClause);
        },
        params: function params(_ref69) {
          var e = _ref69.params;
          return l._(_templateObject260 || (_templateObject260 = _taggedTemplateLiteral(["{failingKeyword: ", "}"])), e.ifClause);
        }
      },
      code: function code(e) {
        var t = e.gen,
            n = e.parentSchema,
            r = e.it;
        void 0 === n.then && void 0 === n.else && $.checkStrictMode(r, '"if" without "then" and "else" is ignored');
        var s = a(r, "then"),
            i = a(r, "else");
        if (!s && !i) return;
        var o = t.let("valid", !0),
            p = t.name("_valid");

        if (function () {
          var t = e.subschema({
            keyword: "if",
            compositeRule: !0,
            createErrors: !1,
            allErrors: !1
          }, p);
          e.mergeEvaluated(t);
        }(), e.reset(), s && i) {
          var _n35 = t.let("ifClause");

          e.setParams({
            ifClause: _n35
          }), t.if(p, u("then", _n35), u("else", _n35));
        } else s ? t.if(p, u("then")) : t.if(l.not(p), u("else"));

        function u(n, a) {
          return function () {
            var r = e.subschema({
              keyword: n
            }, p);
            t.assign(o, p), e.mergeValidEvaluated(r, o), a ? t.assign(a, l._(_templateObject261 || (_templateObject261 = _taggedTemplateLiteral(["", ""])), n)) : e.setParams({
              ifClause: n
            });
          };
        }

        e.pass(o, function () {
          return e.error(!0);
        });
      }
    };

    function a(e, t) {
      var n = e.schema[t];
      return void 0 !== n && !M.alwaysValidSchema(e, n);
    }

    t.default = n;
  });
  r(le);
  var ce = s(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = {
      keyword: ["then", "else"],
      schemaType: ["object", "boolean"],
      code: function code(_ref70) {
        var e = _ref70.keyword,
            t = _ref70.parentSchema,
            n = _ref70.it;
        void 0 === t.if && $.checkStrictMode(n, "\"".concat(e, "\" without \"if\" is ignored"));
      }
    };
    t.default = n;
  });
  r(ce);
  var ye = s(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = [oe.default, pe.default, ue.default, de.default, le.default, ce.default, X.default, ee.default, te.default, ae.default, re.default, ne.default, se.default, ie.default];
    t.default = n;
  });
  r(ye);
  var me = s(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = {
      keyword: "format",
      type: ["number", "string"],
      schemaType: "string",
      $data: !0,
      error: {
        message: function message(_ref71) {
          var e = _ref71.schemaCode;
          return l.str(_templateObject262 || (_templateObject262 = _taggedTemplateLiteral(["should match format \"", "\""])), e);
        },
        params: function params(_ref72) {
          var e = _ref72.schemaCode;
          return l._(_templateObject263 || (_templateObject263 = _taggedTemplateLiteral(["{format: ", "}"])), e);
        }
      },
      code: function code(e, t) {
        var n = e.gen,
            a = e.data,
            r = e.$data,
            s = e.schema,
            i = e.schemaCode,
            o = e.it,
            p = o.opts,
            u = o.errSchemaPath,
            d = o.schemaEnv,
            c = o.self;
        p.validateFormats && (r ? function () {
          var r = n.scopeValue("formats", {
            ref: c.formats,
            code: p.code.formats
          }),
              s = n.const("fDef", l._(_templateObject264 || (_templateObject264 = _taggedTemplateLiteral(["", "[", "]"])), r, i)),
              o = n.let("fType"),
              u = n.let("format");
          n.if(l._(_templateObject265 || (_templateObject265 = _taggedTemplateLiteral(["typeof ", " == \"object\" && !(", " instanceof RegExp)"])), s, s), function () {
            return n.assign(o, l._(_templateObject266 || (_templateObject266 = _taggedTemplateLiteral(["", ".type || \"string\""])), s)).assign(u, l._(_templateObject267 || (_templateObject267 = _taggedTemplateLiteral(["", ".validate"])), s));
          }, function () {
            return n.assign(o, l._(_templateObject268 || (_templateObject268 = _taggedTemplateLiteral(["\"string\""])))).assign(u, s);
          }), e.fail$data(l.or(!1 === p.strict ? l.nil : l._(_templateObject269 || (_templateObject269 = _taggedTemplateLiteral(["", " && !", ""])), i, u), function () {
            var e = d.$async ? l._(_templateObject270 || (_templateObject270 = _taggedTemplateLiteral(["(", ".async ? await ", "(", ") : ", "(", "))"])), s, u, a, u, a) : l._(_templateObject271 || (_templateObject271 = _taggedTemplateLiteral(["", "(", ")"])), u, a),
                n = l._(_templateObject272 || (_templateObject272 = _taggedTemplateLiteral(["(typeof ", " == \"function\" ? ", " : ", ".test(", "))"])), u, e, u, a);

            return l._(_templateObject273 || (_templateObject273 = _taggedTemplateLiteral(["", " && ", " !== true && ", " === ", " && !", ""])), u, u, o, t, n);
          }()));
        }() : function () {
          var r = c.formats[s];
          if (!r) return void function () {
            if (!1 === p.strict) return void c.logger.warn(e());
            throw new Error(e());

            function e() {
              return "unknown format \"".concat(s, "\" ignored in schema at path \"").concat(u, "\"");
            }
          }();
          if (!0 === r) return;

          var _ref73 = function (e) {
            var t = n.scopeValue("formats", {
              key: s,
              ref: e,
              code: p.code.formats ? l._(_templateObject274 || (_templateObject274 = _taggedTemplateLiteral(["", "", ""])), p.code.formats, l.getProperty(s)) : void 0
            });
            if ("object" == typeof e && !(e instanceof RegExp)) return [e.type || "string", e.validate, l._(_templateObject275 || (_templateObject275 = _taggedTemplateLiteral(["", ".validate"])), t)];
            return ["string", e, t];
          }(r),
              _ref74 = _slicedToArray(_ref73, 3),
              i = _ref74[0],
              o = _ref74[1],
              y = _ref74[2];

          i === t && e.pass(function () {
            if ("object" == typeof r && !(r instanceof RegExp) && r.async) {
              if (!d.$async) throw new Error("async format in sync schema");
              return l._(_templateObject276 || (_templateObject276 = _taggedTemplateLiteral(["await ", "(", ")"])), y, a);
            }

            return "function" == typeof o ? l._(_templateObject277 || (_templateObject277 = _taggedTemplateLiteral(["", "(", ")"])), y, a) : l._(_templateObject278 || (_templateObject278 = _taggedTemplateLiteral(["", ".test(", ")"])), y, a);
          }());
        }());
      }
    };
    t.default = n;
  });
  r(me);
  var fe = s(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = [me.default];
    t.default = n;
  });
  r(fe);
  var he = s(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.contentVocabulary = t.metadataVocabulary = void 0, t.metadataVocabulary = ["title", "description", "default", "deprecated", "readOnly", "writeOnly", "examples"], t.contentVocabulary = ["contentMediaType", "contentEncoding", "contentSchema"];
  });
  r(he), he.contentVocabulary, he.metadataVocabulary;
  var be = s(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = [F.default, Z.default, ye.default, fe.default, he.metadataVocabulary, he.contentVocabulary];
    t.default = n;
  });
  r(be);
  var ve = "http://json-schema.org/draft-07/schema#",
      ge = "http://json-schema.org/draft-07/schema#",
      _e = "Core schema meta-schema",
      Te = {
    schemaArray: {
      type: "array",
      minItems: 1,
      items: {
        $ref: "#"
      }
    },
    nonNegativeInteger: {
      type: "integer",
      minimum: 0
    },
    nonNegativeIntegerDefault0: {
      allOf: [{
        $ref: "#/definitions/nonNegativeInteger"
      }, {
        default: 0
      }]
    },
    simpleTypes: {
      enum: ["array", "boolean", "integer", "null", "number", "object", "string"]
    },
    stringArray: {
      type: "array",
      items: {
        type: "string"
      },
      uniqueItems: !0,
      default: []
    }
  },
      we = ["object", "boolean"],
      Ee = {
    $id: {
      type: "string",
      format: "uri-reference"
    },
    $schema: {
      type: "string",
      format: "uri"
    },
    $ref: {
      type: "string",
      format: "uri-reference"
    },
    $comment: {
      type: "string"
    },
    title: {
      type: "string"
    },
    description: {
      type: "string"
    },
    default: !0,
    readOnly: {
      type: "boolean",
      default: !1
    },
    examples: {
      type: "array",
      items: !0
    },
    multipleOf: {
      type: "number",
      exclusiveMinimum: 0
    },
    maximum: {
      type: "number"
    },
    exclusiveMaximum: {
      type: "number"
    },
    minimum: {
      type: "number"
    },
    exclusiveMinimum: {
      type: "number"
    },
    maxLength: {
      $ref: "#/definitions/nonNegativeInteger"
    },
    minLength: {
      $ref: "#/definitions/nonNegativeIntegerDefault0"
    },
    pattern: {
      type: "string",
      format: "regex"
    },
    additionalItems: {
      $ref: "#"
    },
    items: {
      anyOf: [{
        $ref: "#"
      }, {
        $ref: "#/definitions/schemaArray"
      }],
      default: !0
    },
    maxItems: {
      $ref: "#/definitions/nonNegativeInteger"
    },
    minItems: {
      $ref: "#/definitions/nonNegativeIntegerDefault0"
    },
    uniqueItems: {
      type: "boolean",
      default: !1
    },
    contains: {
      $ref: "#"
    },
    maxProperties: {
      $ref: "#/definitions/nonNegativeInteger"
    },
    minProperties: {
      $ref: "#/definitions/nonNegativeIntegerDefault0"
    },
    required: {
      $ref: "#/definitions/stringArray"
    },
    additionalProperties: {
      $ref: "#"
    },
    definitions: {
      type: "object",
      additionalProperties: {
        $ref: "#"
      },
      default: {}
    },
    properties: {
      type: "object",
      additionalProperties: {
        $ref: "#"
      },
      default: {}
    },
    patternProperties: {
      type: "object",
      additionalProperties: {
        $ref: "#"
      },
      propertyNames: {
        format: "regex"
      },
      default: {}
    },
    dependencies: {
      type: "object",
      additionalProperties: {
        anyOf: [{
          $ref: "#"
        }, {
          $ref: "#/definitions/stringArray"
        }]
      }
    },
    propertyNames: {
      $ref: "#"
    },
    const: !0,
    enum: {
      type: "array",
      items: !0,
      minItems: 1,
      uniqueItems: !0
    },
    type: {
      anyOf: [{
        $ref: "#/definitions/simpleTypes"
      }, {
        type: "array",
        items: {
          $ref: "#/definitions/simpleTypes"
        },
        minItems: 1,
        uniqueItems: !0
      }]
    },
    format: {
      type: "string"
    },
    contentMediaType: {
      type: "string"
    },
    contentEncoding: {
      type: "string"
    },
    if: {
      $ref: "#"
    },
    then: {
      $ref: "#"
    },
    else: {
      $ref: "#"
    },
    allOf: {
      $ref: "#/definitions/schemaArray"
    },
    anyOf: {
      $ref: "#/definitions/schemaArray"
    },
    oneOf: {
      $ref: "#/definitions/schemaArray"
    },
    not: {
      $ref: "#"
    }
  },
      $e = {
    $schema: ve,
    $id: ge,
    title: _e,
    definitions: Te,
    type: we,
    properties: Ee,
    default: !0
  },
      Me = i(Object.freeze({
    __proto__: null,
    $schema: ve,
    $id: ge,
    title: _e,
    definitions: Te,
    type: we,
    properties: Ee,
    default: $e
  })),
      Ce = s(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CodeGen = t.Name = t.nil = t.stringify = t.str = t._ = t.KeywordCxt = void 0, t.KeywordCxt = I.default, Object.defineProperty(t, "_", {
      enumerable: !0,
      get: function get() {
        return l._;
      }
    }), Object.defineProperty(t, "str", {
      enumerable: !0,
      get: function get() {
        return l.str;
      }
    }), Object.defineProperty(t, "stringify", {
      enumerable: !0,
      get: function get() {
        return l.stringify;
      }
    }), Object.defineProperty(t, "nil", {
      enumerable: !0,
      get: function get() {
        return l.nil;
      }
    }), Object.defineProperty(t, "Name", {
      enumerable: !0,
      get: function get() {
        return l.Name;
      }
    }), Object.defineProperty(t, "CodeGen", {
      enumerable: !0,
      get: function get() {
        return l.CodeGen;
      }
    });
    var n = ["/properties"],
        a = "http://json-schema.org/draft-07/schema";

    var r = /*#__PURE__*/function (_D$default) {
      _inherits(r, _D$default);

      function r() {
        _classCallCheck(this, r);

        return _possibleConstructorReturn(this, _getPrototypeOf(r).apply(this, arguments));
      }

      _createClass(r, [{
        key: "_addVocabularies",
        value: function _addVocabularies() {
          var _this29 = this;

          _get(_getPrototypeOf(r.prototype), "_addVocabularies", this).call(this), be.default.forEach(function (e) {
            return _this29.addVocabulary(e);
          });
        }
      }, {
        key: "_addDefaultMetaSchema",
        value: function _addDefaultMetaSchema() {
          if (_get(_getPrototypeOf(r.prototype), "_addDefaultMetaSchema", this).call(this), !this.opts.meta) return;
          var e = this.opts.$data ? this.$dataMetaSchema(Me, n) : Me;
          this.addMetaSchema(e, a, !1), this.refs["http://json-schema.org/schema"] = a;
        }
      }, {
        key: "defaultMeta",
        value: function defaultMeta() {
          return this.opts.defaultMeta = _get(_getPrototypeOf(r.prototype), "defaultMeta", this).call(this) || (this.getSchema(a) ? a : void 0);
        }
      }]);

      return r;
    }(D.default);

    t.default = r;
  });
  r(Ce), Ce.CodeGen, Ce.Name, Ce.nil, Ce.stringify, Ce.str, Ce._, Ce.KeywordCxt;
  var Ie = s(function (e, t) {
    var n = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.validateType = t.generateValidator = t.Ajv = void 0;
    var a = n(Ce);
    t.Ajv = a.default, t.generateValidator = function (e) {
      return new a.default().compile(e);
    }, t.validateType = function (e, t) {
      return e.validate(t);
    };
  });
  r(Ie), Ie.validateType, Ie.generateValidator, Ie.Ajv;
  var Ne = s(function (e, t) {
    var n;
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getChainId = t.ChainName = void 0, function (e) {
      e.ETHEREUM_MAINNET = "MAINNET", e.ETHEREUM_ROPSTEN = "ROPSTEN", e.ETHEREUM_RINKEBY = "RINKEBY", e.ETHEREUM_GOERLI = "GOERLI", e.ETHEREUM_KOVAN = "KOVAN", e.MATIC_MAINNET = "MATIC", e.MATIC_MUMBAI = "MUMBAI";
    }(n = t.ChainName || (t.ChainName = {})), t.getChainId = function (e) {
      switch (e) {
        case n.ETHEREUM_MAINNET:
          return Se.ChainId.ETHEREUM_MAINNET;

        case n.ETHEREUM_ROPSTEN:
          return Se.ChainId.ETHEREUM_ROPSTEN;

        case n.ETHEREUM_RINKEBY:
          return Se.ChainId.ETHEREUM_RINKEBY;

        case n.ETHEREUM_GOERLI:
          return Se.ChainId.ETHEREUM_GOERLI;

        case n.ETHEREUM_KOVAN:
          return Se.ChainId.ETHEREUM_KOVAN;

        case n.MATIC_MAINNET:
          return Se.ChainId.MATIC_MAINNET;

        case n.MATIC_MUMBAI:
          return Se.ChainId.MATIC_MUMBAI;

        default:
          return null;
      }
    }, function (e) {
      e.schema = {
        type: "string",
        enum: Object.values(e)
      }, e.validate = Ie.generateValidator(e.schema);
    }(n = t.ChainName || (t.ChainName = {}));
  });
  r(Ne), Ne.getChainId, Ne.ChainName;
  var Se = s(function (e, t) {
    var n;
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getChainName = t.ChainId = void 0, function (e) {
      e[e.ETHEREUM_MAINNET = 1] = "ETHEREUM_MAINNET", e[e.ETHEREUM_ROPSTEN = 3] = "ETHEREUM_ROPSTEN", e[e.ETHEREUM_RINKEBY = 4] = "ETHEREUM_RINKEBY", e[e.ETHEREUM_GOERLI = 5] = "ETHEREUM_GOERLI", e[e.ETHEREUM_KOVAN = 42] = "ETHEREUM_KOVAN", e[e.MATIC_MAINNET = 137] = "MATIC_MAINNET", e[e.MATIC_MUMBAI = 80001] = "MATIC_MUMBAI";
    }(n = t.ChainId || (t.ChainId = {})), t.getChainName = function (e) {
      switch (e) {
        case n.ETHEREUM_MAINNET:
          return Ne.ChainName.ETHEREUM_MAINNET;

        case n.ETHEREUM_ROPSTEN:
          return Ne.ChainName.ETHEREUM_ROPSTEN;

        case n.ETHEREUM_RINKEBY:
          return Ne.ChainName.ETHEREUM_RINKEBY;

        case n.ETHEREUM_GOERLI:
          return Ne.ChainName.ETHEREUM_GOERLI;

        case n.ETHEREUM_KOVAN:
          return Ne.ChainName.ETHEREUM_KOVAN;

        case n.MATIC_MAINNET:
          return Ne.ChainName.MATIC_MAINNET;

        case n.MATIC_MUMBAI:
          return Ne.ChainName.MATIC_MUMBAI;

        default:
          return null;
      }
    }, function (e) {
      e.schema = {
        type: "number",
        enum: Object.values(e)
      }, e.validate = Ie.generateValidator(e.schema);
    }(n = t.ChainId || (t.ChainId = {}));
  });
  r(Se), Se.getChainName, Se.ChainId;
  var Ae = s(function (e, t) {
    var n;
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Network = void 0, (n = t.Network || (t.Network = {})).ETHEREUM = "ETHEREUM", n.MATIC = "MATIC", function (e) {
      e.schema = {
        type: "string",
        enum: Object.values(e)
      }, e.validate = Ie.generateValidator(e.schema);
    }(t.Network || (t.Network = {}));
  });
  r(Ae), Ae.Network;
  var xe = s(function (e, t) {
    var n;
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MetaTransaction = void 0, (n = t.MetaTransaction || (t.MetaTransaction = {})).schema = {
      type: "object",
      properties: {
        from: {
          type: "string"
        },
        params: {
          type: "array",
          items: [{
            type: "string"
          }, {
            type: "string"
          }],
          additionalItems: !1,
          minItems: 2
        }
      },
      additionalProperties: !1,
      required: ["from", "params"]
    }, n.validate = Ie.generateValidator(n.schema);
  });
  r(xe), xe.MetaTransaction;
  var Pe = s(function (e, t) {
    var n = this && this.__createBinding || (Object.create ? function (e, t, n, a) {
      void 0 === a && (a = n), Object.defineProperty(e, a, {
        enumerable: !0,
        get: function get() {
          return t[n];
        }
      });
    } : function (e, t, n, a) {
      void 0 === a && (a = n), e[a] = t[n];
    }),
        a = this && this.__exportStar || function (e, t) {
      for (var a in e) {
        "default" === a || Object.prototype.hasOwnProperty.call(t, a) || n(t, e, a);
      }
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MetaTransaction = t.Network = t.getChainId = t.ChainName = t.getChainName = t.ChainId = void 0, a(Ie, t), Object.defineProperty(t, "ChainId", {
      enumerable: !0,
      get: function get() {
        return Se.ChainId;
      }
    }), Object.defineProperty(t, "getChainName", {
      enumerable: !0,
      get: function get() {
        return Se.getChainName;
      }
    }), Object.defineProperty(t, "ChainName", {
      enumerable: !0,
      get: function get() {
        return Ne.ChainName;
      }
    }), Object.defineProperty(t, "getChainId", {
      enumerable: !0,
      get: function get() {
        return Ne.getChainId;
      }
    }), Object.defineProperty(t, "Network", {
      enumerable: !0,
      get: function get() {
        return Ae.Network;
      }
    }), Object.defineProperty(t, "MetaTransaction", {
      enumerable: !0,
      get: function get() {
        return xe.MetaTransaction;
      }
    });
  });
  r(Pe), Pe.MetaTransaction, Pe.Network, Pe.getChainId, Pe.ChainName, Pe.getChainName;
  var Re = Pe.ChainId;
  var Oe = (_Oe = {}, _defineProperty(_Oe, e.ContractName.Bid, [{
    constant: !0,
    inputs: [{
      name: "_tokenAddress",
      type: "address"
    }, {
      name: "_tokenId",
      type: "uint256"
    }, {
      name: "_bidder",
      type: "address"
    }],
    name: "getBidByBidder",
    outputs: [{
      name: "bidIndex",
      type: "uint256"
    }, {
      name: "bidId",
      type: "bytes32"
    }, {
      name: "bidder",
      type: "address"
    }, {
      name: "price",
      type: "uint256"
    }, {
      name: "expiresAt",
      type: "uint256"
    }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  }, {
    constant: !0,
    inputs: [],
    name: "ERC721Composable_ValidateFingerprint",
    outputs: [{
      name: "",
      type: "bytes4"
    }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  }, {
    constant: !1,
    inputs: [{
      name: "_from",
      type: "address"
    }, {
      name: "",
      type: "address"
    }, {
      name: "_tokenId",
      type: "uint256"
    }, {
      name: "_data",
      type: "bytes"
    }],
    name: "onERC721Received",
    outputs: [{
      name: "",
      type: "bytes4"
    }],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  }, {
    constant: !1,
    inputs: [{
      name: "_ownerCutPerMillion",
      type: "uint256"
    }],
    name: "setOwnerCutPerMillion",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  }, {
    constant: !0,
    inputs: [{
      name: "",
      type: "address"
    }, {
      name: "",
      type: "uint256"
    }, {
      name: "",
      type: "address"
    }],
    name: "bidIdByTokenAndBidder",
    outputs: [{
      name: "",
      type: "bytes32"
    }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  }, {
    constant: !0,
    inputs: [{
      name: "",
      type: "address"
    }, {
      name: "",
      type: "uint256"
    }],
    name: "bidCounterByToken",
    outputs: [{
      name: "",
      type: "uint256"
    }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  }, {
    constant: !0,
    inputs: [],
    name: "ERC721_Interface",
    outputs: [{
      name: "",
      type: "bytes4"
    }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  }, {
    constant: !1,
    inputs: [{
      name: "_tokenAddress",
      type: "address"
    }, {
      name: "_tokenId",
      type: "uint256"
    }],
    name: "cancelBid",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  }, {
    constant: !1,
    inputs: [],
    name: "unpause",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  }, {
    constant: !0,
    inputs: [{
      name: "_tokenAddress",
      type: "address"
    }, {
      name: "_tokenId",
      type: "uint256"
    }, {
      name: "_index",
      type: "uint256"
    }],
    name: "getBidByToken",
    outputs: [{
      name: "",
      type: "bytes32"
    }, {
      name: "",
      type: "address"
    }, {
      name: "",
      type: "uint256"
    }, {
      name: "",
      type: "uint256"
    }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  }, {
    constant: !0,
    inputs: [{
      name: "account",
      type: "address"
    }],
    name: "isPauser",
    outputs: [{
      name: "",
      type: "bool"
    }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  }, {
    constant: !0,
    inputs: [],
    name: "ERC721_Received",
    outputs: [{
      name: "",
      type: "bytes4"
    }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  }, {
    constant: !0,
    inputs: [],
    name: "paused",
    outputs: [{
      name: "",
      type: "bool"
    }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  }, {
    constant: !1,
    inputs: [],
    name: "renouncePauser",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  }, {
    constant: !1,
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  }, {
    constant: !0,
    inputs: [],
    name: "manaToken",
    outputs: [{
      name: "",
      type: "address"
    }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  }, {
    constant: !1,
    inputs: [{
      name: "_tokenAddress",
      type: "address"
    }, {
      name: "_tokenId",
      type: "uint256"
    }, {
      name: "_price",
      type: "uint256"
    }, {
      name: "_duration",
      type: "uint256"
    }],
    name: "placeBid",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  }, {
    constant: !1,
    inputs: [{
      name: "account",
      type: "address"
    }],
    name: "addPauser",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  }, {
    constant: !1,
    inputs: [],
    name: "pause",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  }, {
    constant: !0,
    inputs: [],
    name: "owner",
    outputs: [{
      name: "",
      type: "address"
    }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  }, {
    constant: !0,
    inputs: [],
    name: "isOwner",
    outputs: [{
      name: "",
      type: "bool"
    }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  }, {
    constant: !0,
    inputs: [],
    name: "ONE_MILLION",
    outputs: [{
      name: "",
      type: "uint256"
    }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  }, {
    constant: !0,
    inputs: [],
    name: "ownerCutPerMillion",
    outputs: [{
      name: "",
      type: "uint256"
    }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  }, {
    constant: !0,
    inputs: [],
    name: "MAX_BID_DURATION",
    outputs: [{
      name: "",
      type: "uint256"
    }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  }, {
    constant: !1,
    inputs: [{
      name: "_tokenAddress",
      type: "address"
    }, {
      name: "_tokenId",
      type: "uint256"
    }, {
      name: "_price",
      type: "uint256"
    }, {
      name: "_duration",
      type: "uint256"
    }, {
      name: "_fingerprint",
      type: "bytes"
    }],
    name: "placeBid",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  }, {
    constant: !0,
    inputs: [{
      name: "",
      type: "bytes32"
    }],
    name: "bidIndexByBidId",
    outputs: [{
      name: "",
      type: "uint256"
    }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  }, {
    constant: !1,
    inputs: [{
      name: "_tokenAddresses",
      type: "address[]"
    }, {
      name: "_tokenIds",
      type: "uint256[]"
    }, {
      name: "_bidders",
      type: "address[]"
    }],
    name: "removeExpiredBids",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  }, {
    constant: !1,
    inputs: [{
      name: "newOwner",
      type: "address"
    }],
    name: "transferOwnership",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  }, {
    constant: !0,
    inputs: [],
    name: "MIN_BID_DURATION",
    outputs: [{
      name: "",
      type: "uint256"
    }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [{
      name: "_manaToken",
      type: "address"
    }, {
      name: "_owner",
      type: "address"
    }],
    payable: !1,
    stateMutability: "nonpayable",
    type: "constructor"
  }, {
    anonymous: !1,
    inputs: [{
      indexed: !1,
      name: "_id",
      type: "bytes32"
    }, {
      indexed: !0,
      name: "_tokenAddress",
      type: "address"
    }, {
      indexed: !0,
      name: "_tokenId",
      type: "uint256"
    }, {
      indexed: !0,
      name: "_bidder",
      type: "address"
    }, {
      indexed: !1,
      name: "_price",
      type: "uint256"
    }, {
      indexed: !1,
      name: "_expiresAt",
      type: "uint256"
    }, {
      indexed: !1,
      name: "_fingerprint",
      type: "bytes"
    }],
    name: "BidCreated",
    type: "event"
  }, {
    anonymous: !1,
    inputs: [{
      indexed: !1,
      name: "_id",
      type: "bytes32"
    }, {
      indexed: !0,
      name: "_tokenAddress",
      type: "address"
    }, {
      indexed: !0,
      name: "_tokenId",
      type: "uint256"
    }, {
      indexed: !1,
      name: "_bidder",
      type: "address"
    }, {
      indexed: !0,
      name: "_seller",
      type: "address"
    }, {
      indexed: !1,
      name: "_price",
      type: "uint256"
    }, {
      indexed: !1,
      name: "_fee",
      type: "uint256"
    }],
    name: "BidAccepted",
    type: "event"
  }, {
    anonymous: !1,
    inputs: [{
      indexed: !1,
      name: "_id",
      type: "bytes32"
    }, {
      indexed: !0,
      name: "_tokenAddress",
      type: "address"
    }, {
      indexed: !0,
      name: "_tokenId",
      type: "uint256"
    }, {
      indexed: !0,
      name: "_bidder",
      type: "address"
    }],
    name: "BidCancelled",
    type: "event"
  }, {
    anonymous: !1,
    inputs: [{
      indexed: !1,
      name: "_ownerCutPerMillion",
      type: "uint256"
    }],
    name: "ChangedOwnerCutPerMillion",
    type: "event"
  }, {
    anonymous: !1,
    inputs: [{
      indexed: !1,
      name: "account",
      type: "address"
    }],
    name: "Paused",
    type: "event"
  }, {
    anonymous: !1,
    inputs: [{
      indexed: !1,
      name: "account",
      type: "address"
    }],
    name: "Unpaused",
    type: "event"
  }, {
    anonymous: !1,
    inputs: [{
      indexed: !0,
      name: "account",
      type: "address"
    }],
    name: "PauserAdded",
    type: "event"
  }, {
    anonymous: !1,
    inputs: [{
      indexed: !0,
      name: "account",
      type: "address"
    }],
    name: "PauserRemoved",
    type: "event"
  }, {
    anonymous: !1,
    inputs: [{
      indexed: !0,
      name: "previousOwner",
      type: "address"
    }, {
      indexed: !0,
      name: "newOwner",
      type: "address"
    }],
    name: "OwnershipTransferred",
    type: "event"
  }]), _defineProperty(_Oe, e.ContractName.CollectionFactory, [{
    inputs: [{
      internalType: "address",
      name: "_owner",
      type: "address"
    }, {
      internalType: "address",
      name: "_implementation",
      type: "address"
    }],
    stateMutability: "nonpayable",
    type: "constructor"
  }, {
    anonymous: !1,
    inputs: [{
      indexed: !0,
      internalType: "address",
      name: "_implementation",
      type: "address"
    }, {
      indexed: !1,
      internalType: "bytes32",
      name: "_codeHash",
      type: "bytes32"
    }, {
      indexed: !1,
      internalType: "bytes",
      name: "_code",
      type: "bytes"
    }],
    name: "ImplementationSet",
    type: "event"
  }, {
    anonymous: !1,
    inputs: [{
      indexed: !0,
      internalType: "address",
      name: "previousOwner",
      type: "address"
    }, {
      indexed: !0,
      internalType: "address",
      name: "newOwner",
      type: "address"
    }],
    name: "OwnershipTransferred",
    type: "event"
  }, {
    anonymous: !1,
    inputs: [{
      indexed: !0,
      internalType: "address",
      name: "_address",
      type: "address"
    }, {
      indexed: !1,
      internalType: "bytes32",
      name: "_salt",
      type: "bytes32"
    }],
    name: "ProxyCreated",
    type: "event"
  }, {
    inputs: [],
    name: "code",
    outputs: [{
      internalType: "bytes",
      name: "",
      type: "bytes"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [],
    name: "codeHash",
    outputs: [{
      internalType: "bytes32",
      name: "",
      type: "bytes32"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [{
      internalType: "uint256",
      name: "",
      type: "uint256"
    }],
    name: "collections",
    outputs: [{
      internalType: "address",
      name: "",
      type: "address"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [],
    name: "collectionsSize",
    outputs: [{
      internalType: "uint256",
      name: "",
      type: "uint256"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [{
      internalType: "bytes32",
      name: "_salt",
      type: "bytes32"
    }, {
      internalType: "bytes",
      name: "_data",
      type: "bytes"
    }],
    name: "createCollection",
    outputs: [{
      internalType: "address",
      name: "addr",
      type: "address"
    }],
    stateMutability: "nonpayable",
    type: "function"
  }, {
    inputs: [{
      internalType: "bytes32",
      name: "_salt",
      type: "bytes32"
    }, {
      internalType: "address",
      name: "_address",
      type: "address"
    }, {
      internalType: "bytes",
      name: "_data",
      type: "bytes"
    }],
    name: "getAddress",
    outputs: [{
      internalType: "address",
      name: "",
      type: "address"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [],
    name: "implementation",
    outputs: [{
      internalType: "address",
      name: "",
      type: "address"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [{
      internalType: "address",
      name: "",
      type: "address"
    }],
    name: "isCollectionFromFactory",
    outputs: [{
      internalType: "bool",
      name: "",
      type: "bool"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [],
    name: "owner",
    outputs: [{
      internalType: "address",
      name: "",
      type: "address"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }, {
    inputs: [{
      internalType: "address",
      name: "newOwner",
      type: "address"
    }],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }]), _defineProperty(_Oe, e.ContractName.CollectionManager, [{
    inputs: [{
      internalType: "address",
      name: "_owner",
      type: "address"
    }, {
      internalType: "contract IERC20",
      name: "_acceptedToken",
      type: "address"
    }, {
      internalType: "address",
      name: "_committee",
      type: "address"
    }, {
      internalType: "address",
      name: "_feesCollector",
      type: "address"
    }, {
      internalType: "contract IRarities",
      name: "_rarities",
      type: "address"
    }, {
      internalType: "bytes4[]",
      name: "_committeeMethods",
      type: "bytes4[]"
    }, {
      internalType: "bool[]",
      name: "_committeeValues",
      type: "bool[]"
    }],
    stateMutability: "nonpayable",
    type: "constructor"
  }, {
    anonymous: !1,
    inputs: [{
      indexed: !0,
      internalType: "contract IERC20",
      name: "_oldAcceptedToken",
      type: "address"
    }, {
      indexed: !0,
      internalType: "contract IERC20",
      name: "_newAcceptedToken",
      type: "address"
    }],
    name: "AcceptedTokenSet",
    type: "event"
  }, {
    anonymous: !1,
    inputs: [{
      indexed: !0,
      internalType: "bytes4",
      name: "_method",
      type: "bytes4"
    }, {
      indexed: !1,
      internalType: "bool",
      name: "_isAllowed",
      type: "bool"
    }],
    name: "CommitteeMethodSet",
    type: "event"
  }, {
    anonymous: !1,
    inputs: [{
      indexed: !0,
      internalType: "address",
      name: "_oldCommittee",
      type: "address"
    }, {
      indexed: !0,
      internalType: "address",
      name: "_newCommittee",
      type: "address"
    }],
    name: "CommitteeSet",
    type: "event"
  }, {
    anonymous: !1,
    inputs: [{
      indexed: !0,
      internalType: "address",
      name: "_oldFeesCollector",
      type: "address"
    }, {
      indexed: !0,
      internalType: "address",
      name: "_newFeesCollector",
      type: "address"
    }],
    name: "FeesCollectorSet",
    type: "event"
  }, {
    anonymous: !1,
    inputs: [{
      indexed: !1,
      internalType: "address",
      name: "userAddress",
      type: "address"
    }, {
      indexed: !1,
      internalType: "address",
      name: "relayerAddress",
      type: "address"
    }, {
      indexed: !1,
      internalType: "bytes",
      name: "functionSignature",
      type: "bytes"
    }],
    name: "MetaTransactionExecuted",
    type: "event"
  }, {
    anonymous: !1,
    inputs: [{
      indexed: !0,
      internalType: "address",
      name: "previousOwner",
      type: "address"
    }, {
      indexed: !0,
      internalType: "address",
      name: "newOwner",
      type: "address"
    }],
    name: "OwnershipTransferred",
    type: "event"
  }, {
    anonymous: !1,
    inputs: [{
      indexed: !0,
      internalType: "contract IRarities",
      name: "_oldRarities",
      type: "address"
    }, {
      indexed: !0,
      internalType: "contract IRarities",
      name: "_newRarities",
      type: "address"
    }],
    name: "RaritiesSet",
    type: "event"
  }, {
    inputs: [],
    name: "acceptedToken",
    outputs: [{
      internalType: "contract IERC20",
      name: "",
      type: "address"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [{
      internalType: "bytes4",
      name: "",
      type: "bytes4"
    }],
    name: "allowedCommitteeMethods",
    outputs: [{
      internalType: "bool",
      name: "",
      type: "bool"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [],
    name: "committee",
    outputs: [{
      internalType: "address",
      name: "",
      type: "address"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [{
      internalType: "contract IForwarder",
      name: "_forwarder",
      type: "address"
    }, {
      internalType: "contract IERC721CollectionFactoryV2",
      name: "_factory",
      type: "address"
    }, {
      internalType: "bytes32",
      name: "_salt",
      type: "bytes32"
    }, {
      internalType: "string",
      name: "_name",
      type: "string"
    }, {
      internalType: "string",
      name: "_symbol",
      type: "string"
    }, {
      internalType: "string",
      name: "_baseURI",
      type: "string"
    }, {
      internalType: "address",
      name: "_creator",
      type: "address"
    }, {
      components: [{
        internalType: "string",
        name: "rarity",
        type: "string"
      }, {
        internalType: "uint256",
        name: "price",
        type: "uint256"
      }, {
        internalType: "address",
        name: "beneficiary",
        type: "address"
      }, {
        internalType: "string",
        name: "metadata",
        type: "string"
      }],
      internalType: "struct IERC721CollectionV2.ItemParam[]",
      name: "_items",
      type: "tuple[]"
    }],
    name: "createCollection",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }, {
    inputs: [],
    name: "domainSeparator",
    outputs: [{
      internalType: "bytes32",
      name: "",
      type: "bytes32"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [{
      internalType: "address",
      name: "userAddress",
      type: "address"
    }, {
      internalType: "bytes",
      name: "functionSignature",
      type: "bytes"
    }, {
      internalType: "bytes32",
      name: "sigR",
      type: "bytes32"
    }, {
      internalType: "bytes32",
      name: "sigS",
      type: "bytes32"
    }, {
      internalType: "uint8",
      name: "sigV",
      type: "uint8"
    }],
    name: "executeMetaTransaction",
    outputs: [{
      internalType: "bytes",
      name: "",
      type: "bytes"
    }],
    stateMutability: "payable",
    type: "function"
  }, {
    inputs: [],
    name: "feesCollector",
    outputs: [{
      internalType: "address",
      name: "",
      type: "address"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [],
    name: "getChainId",
    outputs: [{
      internalType: "uint256",
      name: "",
      type: "uint256"
    }],
    stateMutability: "pure",
    type: "function"
  }, {
    inputs: [{
      internalType: "address",
      name: "user",
      type: "address"
    }],
    name: "getNonce",
    outputs: [{
      internalType: "uint256",
      name: "nonce",
      type: "uint256"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [{
      internalType: "contract IForwarder",
      name: "_forwarder",
      type: "address"
    }, {
      internalType: "contract IERC721CollectionV2",
      name: "_collection",
      type: "address"
    }, {
      internalType: "bytes",
      name: "_data",
      type: "bytes"
    }],
    name: "manageCollection",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }, {
    inputs: [],
    name: "owner",
    outputs: [{
      internalType: "address",
      name: "",
      type: "address"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [],
    name: "pricePerItem",
    outputs: [{
      internalType: "uint256",
      name: "",
      type: "uint256"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [],
    name: "rarities",
    outputs: [{
      internalType: "contract IRarities",
      name: "",
      type: "address"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }, {
    inputs: [{
      internalType: "contract IERC20",
      name: "_newAcceptedToken",
      type: "address"
    }],
    name: "setAcceptedToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }, {
    inputs: [{
      internalType: "address",
      name: "_newCommittee",
      type: "address"
    }],
    name: "setCommittee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }, {
    inputs: [{
      internalType: "bytes4[]",
      name: "_methods",
      type: "bytes4[]"
    }, {
      internalType: "bool[]",
      name: "_values",
      type: "bool[]"
    }],
    name: "setCommitteeMethods",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }, {
    inputs: [{
      internalType: "address",
      name: "_newFeesCollector",
      type: "address"
    }],
    name: "setFeesCollector",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }, {
    inputs: [{
      internalType: "contract IRarities",
      name: "_newRarities",
      type: "address"
    }],
    name: "setRarities",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }, {
    inputs: [{
      internalType: "address",
      name: "newOwner",
      type: "address"
    }],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }]), _defineProperty(_Oe, e.ContractName.CollectionStore, [{
    inputs: [{
      internalType: "address",
      name: "_owner",
      type: "address"
    }, {
      internalType: "contract IERC20",
      name: "_acceptedToken",
      type: "address"
    }, {
      internalType: "address",
      name: "_feeOwner",
      type: "address"
    }, {
      internalType: "uint256",
      name: "_fee",
      type: "uint256"
    }],
    stateMutability: "nonpayable",
    type: "constructor"
  }, {
    anonymous: !1,
    inputs: [{
      components: [{
        internalType: "contract IERC721CollectionV2",
        name: "collection",
        type: "address"
      }, {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]"
      }, {
        internalType: "uint256[]",
        name: "prices",
        type: "uint256[]"
      }, {
        internalType: "address[]",
        name: "beneficiaries",
        type: "address[]"
      }],
      indexed: !1,
      internalType: "struct CollectionStore.ItemToBuy[]",
      name: "_itemsToBuy",
      type: "tuple[]"
    }],
    name: "Bought",
    type: "event"
  }, {
    anonymous: !1,
    inputs: [{
      indexed: !1,
      internalType: "address",
      name: "userAddress",
      type: "address"
    }, {
      indexed: !1,
      internalType: "address",
      name: "relayerAddress",
      type: "address"
    }, {
      indexed: !1,
      internalType: "bytes",
      name: "functionSignature",
      type: "bytes"
    }],
    name: "MetaTransactionExecuted",
    type: "event"
  }, {
    anonymous: !1,
    inputs: [{
      indexed: !0,
      internalType: "address",
      name: "previousOwner",
      type: "address"
    }, {
      indexed: !0,
      internalType: "address",
      name: "newOwner",
      type: "address"
    }],
    name: "OwnershipTransferred",
    type: "event"
  }, {
    anonymous: !1,
    inputs: [{
      indexed: !1,
      internalType: "uint256",
      name: "_oldFee",
      type: "uint256"
    }, {
      indexed: !1,
      internalType: "uint256",
      name: "_newFee",
      type: "uint256"
    }],
    name: "SetFee",
    type: "event"
  }, {
    anonymous: !1,
    inputs: [{
      indexed: !0,
      internalType: "address",
      name: "_oldFeeOwner",
      type: "address"
    }, {
      indexed: !0,
      internalType: "address",
      name: "_newFeeOwner",
      type: "address"
    }],
    name: "SetFeeOwner",
    type: "event"
  }, {
    inputs: [],
    name: "BASE_FEE",
    outputs: [{
      internalType: "uint256",
      name: "",
      type: "uint256"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [],
    name: "acceptedToken",
    outputs: [{
      internalType: "contract IERC20",
      name: "",
      type: "address"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [{
      components: [{
        internalType: "contract IERC721CollectionV2",
        name: "collection",
        type: "address"
      }, {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]"
      }, {
        internalType: "uint256[]",
        name: "prices",
        type: "uint256[]"
      }, {
        internalType: "address[]",
        name: "beneficiaries",
        type: "address[]"
      }],
      internalType: "struct CollectionStore.ItemToBuy[]",
      name: "_itemsToBuy",
      type: "tuple[]"
    }],
    name: "buy",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }, {
    inputs: [],
    name: "domainSeparator",
    outputs: [{
      internalType: "bytes32",
      name: "",
      type: "bytes32"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [{
      internalType: "address",
      name: "userAddress",
      type: "address"
    }, {
      internalType: "bytes",
      name: "functionSignature",
      type: "bytes"
    }, {
      internalType: "bytes32",
      name: "sigR",
      type: "bytes32"
    }, {
      internalType: "bytes32",
      name: "sigS",
      type: "bytes32"
    }, {
      internalType: "uint8",
      name: "sigV",
      type: "uint8"
    }],
    name: "executeMetaTransaction",
    outputs: [{
      internalType: "bytes",
      name: "",
      type: "bytes"
    }],
    stateMutability: "payable",
    type: "function"
  }, {
    inputs: [],
    name: "fee",
    outputs: [{
      internalType: "uint256",
      name: "",
      type: "uint256"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [],
    name: "feeOwner",
    outputs: [{
      internalType: "address",
      name: "",
      type: "address"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [],
    name: "getChainId",
    outputs: [{
      internalType: "uint256",
      name: "",
      type: "uint256"
    }],
    stateMutability: "pure",
    type: "function"
  }, {
    inputs: [{
      internalType: "contract IERC721CollectionV2",
      name: "_collection",
      type: "address"
    }, {
      internalType: "uint256",
      name: "_itemId",
      type: "uint256"
    }],
    name: "getItemBuyData",
    outputs: [{
      internalType: "uint256",
      name: "",
      type: "uint256"
    }, {
      internalType: "address",
      name: "",
      type: "address"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [{
      internalType: "address",
      name: "user",
      type: "address"
    }],
    name: "getNonce",
    outputs: [{
      internalType: "uint256",
      name: "nonce",
      type: "uint256"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [],
    name: "owner",
    outputs: [{
      internalType: "address",
      name: "",
      type: "address"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }, {
    inputs: [{
      internalType: "uint256",
      name: "_newFee",
      type: "uint256"
    }],
    name: "setFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }, {
    inputs: [{
      internalType: "address",
      name: "_newFeeOwner",
      type: "address"
    }],
    name: "setFeeOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }, {
    inputs: [{
      internalType: "address",
      name: "newOwner",
      type: "address"
    }],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }]), _defineProperty(_Oe, e.ContractName.Committee, [{
    inputs: [{
      internalType: "address",
      name: "_owner",
      type: "address"
    }, {
      internalType: "address[]",
      name: "_members",
      type: "address[]"
    }],
    stateMutability: "nonpayable",
    type: "constructor"
  }, {
    anonymous: !1,
    inputs: [{
      indexed: !0,
      internalType: "address",
      name: "_member",
      type: "address"
    }, {
      indexed: !1,
      internalType: "bool",
      name: "_value",
      type: "bool"
    }],
    name: "MemberSet",
    type: "event"
  }, {
    anonymous: !1,
    inputs: [{
      indexed: !1,
      internalType: "address",
      name: "userAddress",
      type: "address"
    }, {
      indexed: !1,
      internalType: "address",
      name: "relayerAddress",
      type: "address"
    }, {
      indexed: !1,
      internalType: "bytes",
      name: "functionSignature",
      type: "bytes"
    }],
    name: "MetaTransactionExecuted",
    type: "event"
  }, {
    anonymous: !1,
    inputs: [{
      indexed: !0,
      internalType: "address",
      name: "previousOwner",
      type: "address"
    }, {
      indexed: !0,
      internalType: "address",
      name: "newOwner",
      type: "address"
    }],
    name: "OwnershipTransferred",
    type: "event"
  }, {
    inputs: [],
    name: "domainSeparator",
    outputs: [{
      internalType: "bytes32",
      name: "",
      type: "bytes32"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [{
      internalType: "address",
      name: "userAddress",
      type: "address"
    }, {
      internalType: "bytes",
      name: "functionSignature",
      type: "bytes"
    }, {
      internalType: "bytes32",
      name: "sigR",
      type: "bytes32"
    }, {
      internalType: "bytes32",
      name: "sigS",
      type: "bytes32"
    }, {
      internalType: "uint8",
      name: "sigV",
      type: "uint8"
    }],
    name: "executeMetaTransaction",
    outputs: [{
      internalType: "bytes",
      name: "",
      type: "bytes"
    }],
    stateMutability: "payable",
    type: "function"
  }, {
    inputs: [],
    name: "getChainId",
    outputs: [{
      internalType: "uint256",
      name: "",
      type: "uint256"
    }],
    stateMutability: "pure",
    type: "function"
  }, {
    inputs: [{
      internalType: "address",
      name: "user",
      type: "address"
    }],
    name: "getNonce",
    outputs: [{
      internalType: "uint256",
      name: "nonce",
      type: "uint256"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [{
      internalType: "contract ICollectionManager",
      name: "_collectionManager",
      type: "address"
    }, {
      internalType: "address",
      name: "_forwarder",
      type: "address"
    }, {
      internalType: "address",
      name: "_collection",
      type: "address"
    }, {
      internalType: "bytes[]",
      name: "_data",
      type: "bytes[]"
    }],
    name: "manageCollection",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }, {
    inputs: [{
      internalType: "address",
      name: "",
      type: "address"
    }],
    name: "members",
    outputs: [{
      internalType: "bool",
      name: "",
      type: "bool"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [],
    name: "owner",
    outputs: [{
      internalType: "address",
      name: "",
      type: "address"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }, {
    inputs: [{
      internalType: "address[]",
      name: "_members",
      type: "address[]"
    }, {
      internalType: "bool[]",
      name: "_values",
      type: "bool[]"
    }],
    name: "setMembers",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }, {
    inputs: [{
      internalType: "address",
      name: "newOwner",
      type: "address"
    }],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }]), _defineProperty(_Oe, e.ContractName.ERC20, [{
    constant: !0,
    inputs: [],
    name: "mintingFinished",
    outputs: [{
      name: "",
      type: "bool"
    }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  }, {
    constant: !0,
    inputs: [],
    name: "name",
    outputs: [{
      name: "",
      type: "string"
    }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  }, {
    constant: !1,
    inputs: [{
      name: "_spender",
      type: "address"
    }, {
      name: "_value",
      type: "uint256"
    }],
    name: "approve",
    outputs: [{
      name: "",
      type: "bool"
    }],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  }, {
    constant: !0,
    inputs: [],
    name: "totalSupply",
    outputs: [{
      name: "",
      type: "uint256"
    }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  }, {
    constant: !1,
    inputs: [{
      name: "_from",
      type: "address"
    }, {
      name: "_to",
      type: "address"
    }, {
      name: "_value",
      type: "uint256"
    }],
    name: "transferFrom",
    outputs: [{
      name: "",
      type: "bool"
    }],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  }, {
    constant: !0,
    inputs: [],
    name: "decimals",
    outputs: [{
      name: "",
      type: "uint8"
    }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  }, {
    constant: !1,
    inputs: [],
    name: "unpause",
    outputs: [{
      name: "",
      type: "bool"
    }],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  }, {
    constant: !1,
    inputs: [{
      name: "_to",
      type: "address"
    }, {
      name: "_amount",
      type: "uint256"
    }],
    name: "mint",
    outputs: [{
      name: "",
      type: "bool"
    }],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  }, {
    constant: !1,
    inputs: [{
      name: "_value",
      type: "uint256"
    }],
    name: "burn",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  }, {
    constant: !0,
    inputs: [],
    name: "paused",
    outputs: [{
      name: "",
      type: "bool"
    }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  }, {
    constant: !0,
    inputs: [{
      name: "_owner",
      type: "address"
    }],
    name: "balanceOf",
    outputs: [{
      name: "balance",
      type: "uint256"
    }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  }, {
    constant: !1,
    inputs: [],
    name: "finishMinting",
    outputs: [{
      name: "",
      type: "bool"
    }],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  }, {
    constant: !1,
    inputs: [],
    name: "pause",
    outputs: [{
      name: "",
      type: "bool"
    }],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  }, {
    constant: !0,
    inputs: [],
    name: "owner",
    outputs: [{
      name: "",
      type: "address"
    }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  }, {
    constant: !0,
    inputs: [],
    name: "symbol",
    outputs: [{
      name: "",
      type: "string"
    }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  }, {
    constant: !1,
    inputs: [{
      name: "_to",
      type: "address"
    }, {
      name: "_value",
      type: "uint256"
    }],
    name: "transfer",
    outputs: [{
      name: "",
      type: "bool"
    }],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  }, {
    constant: !0,
    inputs: [{
      name: "_owner",
      type: "address"
    }, {
      name: "_spender",
      type: "address"
    }],
    name: "allowance",
    outputs: [{
      name: "remaining",
      type: "uint256"
    }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  }, {
    constant: !1,
    inputs: [{
      name: "to",
      type: "address"
    }, {
      name: "amount",
      type: "uint256"
    }],
    name: "setBalance",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  }, {
    constant: !1,
    inputs: [{
      name: "newOwner",
      type: "address"
    }],
    name: "transferOwnership",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  }, {
    anonymous: !1,
    inputs: [{
      indexed: !0,
      name: "to",
      type: "address"
    }, {
      indexed: !1,
      name: "amount",
      type: "uint256"
    }],
    name: "Mint",
    type: "event"
  }, {
    anonymous: !1,
    inputs: [],
    name: "MintFinished",
    type: "event"
  }, {
    anonymous: !1,
    inputs: [],
    name: "Pause",
    type: "event"
  }, {
    anonymous: !1,
    inputs: [],
    name: "Unpause",
    type: "event"
  }, {
    anonymous: !1,
    inputs: [{
      indexed: !0,
      name: "burner",
      type: "address"
    }, {
      indexed: !1,
      name: "value",
      type: "uint256"
    }],
    name: "Burn",
    type: "event"
  }, {
    anonymous: !1,
    inputs: [{
      indexed: !0,
      name: "owner",
      type: "address"
    }, {
      indexed: !0,
      name: "spender",
      type: "address"
    }, {
      indexed: !1,
      name: "value",
      type: "uint256"
    }],
    name: "Approval",
    type: "event"
  }, {
    anonymous: !1,
    inputs: [{
      indexed: !0,
      name: "from",
      type: "address"
    }, {
      indexed: !0,
      name: "to",
      type: "address"
    }, {
      indexed: !1,
      name: "value",
      type: "uint256"
    }],
    name: "Transfer",
    type: "event"
  }]), _defineProperty(_Oe, e.ContractName.ERC721, [{
    constant: !0,
    inputs: [{
      name: "_interfaceId",
      type: "bytes4"
    }],
    name: "supportsInterface",
    outputs: [{
      name: "",
      type: "bool"
    }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  }, {
    constant: !0,
    inputs: [],
    name: "name",
    outputs: [{
      name: "",
      type: "string"
    }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  }, {
    constant: !0,
    inputs: [{
      name: "_tokenId",
      type: "uint256"
    }],
    name: "getApproved",
    outputs: [{
      name: "",
      type: "address"
    }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  }, {
    constant: !1,
    inputs: [{
      name: "_to",
      type: "address"
    }, {
      name: "_tokenId",
      type: "uint256"
    }],
    name: "approve",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  }, {
    constant: !0,
    inputs: [],
    name: "totalSupply",
    outputs: [{
      name: "",
      type: "uint256"
    }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  }, {
    constant: !0,
    inputs: [],
    name: "InterfaceId_ERC165",
    outputs: [{
      name: "",
      type: "bytes4"
    }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  }, {
    constant: !1,
    inputs: [{
      name: "_from",
      type: "address"
    }, {
      name: "_to",
      type: "address"
    }, {
      name: "_tokenId",
      type: "uint256"
    }],
    name: "transferFrom",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  }, {
    constant: !1,
    inputs: [{
      name: "_to",
      type: "address"
    }, {
      name: "_tokenId",
      type: "uint256"
    }],
    name: "transfer",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  }, {
    constant: !0,
    inputs: [{
      name: "_owner",
      type: "address"
    }, {
      name: "_index",
      type: "uint256"
    }],
    name: "tokenOfOwnerByIndex",
    outputs: [{
      name: "",
      type: "uint256"
    }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  }, {
    constant: !1,
    inputs: [{
      name: "_from",
      type: "address"
    }, {
      name: "_to",
      type: "address"
    }, {
      name: "_tokenId",
      type: "uint256"
    }],
    name: "safeTransferFrom",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  }, {
    constant: !0,
    inputs: [{
      name: "_tokenId",
      type: "uint256"
    }],
    name: "exists",
    outputs: [{
      name: "",
      type: "bool"
    }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  }, {
    constant: !0,
    inputs: [{
      name: "_index",
      type: "uint256"
    }],
    name: "tokenByIndex",
    outputs: [{
      name: "",
      type: "uint256"
    }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  }, {
    constant: !0,
    inputs: [{
      name: "_tokenId",
      type: "uint256"
    }],
    name: "ownerOf",
    outputs: [{
      name: "",
      type: "address"
    }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  }, {
    constant: !0,
    inputs: [{
      name: "_owner",
      type: "address"
    }],
    name: "balanceOf",
    outputs: [{
      name: "",
      type: "uint256"
    }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  }, {
    constant: !0,
    inputs: [],
    name: "symbol",
    outputs: [{
      name: "",
      type: "string"
    }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  }, {
    constant: !1,
    inputs: [{
      name: "_to",
      type: "address"
    }, {
      name: "_approved",
      type: "bool"
    }],
    name: "setApprovalForAll",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  }, {
    constant: !1,
    inputs: [{
      name: "_from",
      type: "address"
    }, {
      name: "_to",
      type: "address"
    }, {
      name: "_tokenId",
      type: "uint256"
    }, {
      name: "_data",
      type: "bytes"
    }],
    name: "safeTransferFrom",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  }, {
    constant: !0,
    inputs: [{
      name: "_tokenId",
      type: "uint256"
    }],
    name: "tokenURI",
    outputs: [{
      name: "",
      type: "string"
    }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  }, {
    constant: !0,
    inputs: [{
      name: "_owner",
      type: "address"
    }, {
      name: "_operator",
      type: "address"
    }],
    name: "isApprovedForAll",
    outputs: [{
      name: "",
      type: "bool"
    }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [{
      name: "_name",
      type: "string"
    }, {
      name: "_symbol",
      type: "string"
    }],
    payable: !1,
    stateMutability: "nonpayable",
    type: "constructor"
  }, {
    anonymous: !1,
    inputs: [{
      indexed: !0,
      name: "_from",
      type: "address"
    }, {
      indexed: !0,
      name: "_to",
      type: "address"
    }, {
      indexed: !0,
      name: "_tokenId",
      type: "uint256"
    }],
    name: "Transfer",
    type: "event"
  }, {
    anonymous: !1,
    inputs: [{
      indexed: !0,
      name: "_owner",
      type: "address"
    }, {
      indexed: !0,
      name: "_approved",
      type: "address"
    }, {
      indexed: !0,
      name: "_tokenId",
      type: "uint256"
    }],
    name: "Approval",
    type: "event"
  }, {
    anonymous: !1,
    inputs: [{
      indexed: !0,
      name: "_owner",
      type: "address"
    }, {
      indexed: !0,
      name: "_operator",
      type: "address"
    }, {
      indexed: !1,
      name: "_approved",
      type: "bool"
    }],
    name: "ApprovalForAll",
    type: "event"
  }, {
    constant: !1,
    inputs: [{
      name: "_to",
      type: "address"
    }, {
      name: "_tokenId",
      type: "uint256"
    }, {
      name: "_tokenURI",
      type: "string"
    }],
    name: "mintUniqueTokenTo",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  }]), _defineProperty(_Oe, e.ContractName.ERC721CollectionV2, [{
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor"
  }, {
    anonymous: !1,
    inputs: [{
      indexed: !0,
      internalType: "uint256",
      name: "_itemId",
      type: "uint256"
    }, {
      components: [{
        internalType: "string",
        name: "rarity",
        type: "string"
      }, {
        internalType: "uint256",
        name: "maxSupply",
        type: "uint256"
      }, {
        internalType: "uint256",
        name: "totalSupply",
        type: "uint256"
      }, {
        internalType: "uint256",
        name: "price",
        type: "uint256"
      }, {
        internalType: "address",
        name: "beneficiary",
        type: "address"
      }, {
        internalType: "string",
        name: "metadata",
        type: "string"
      }, {
        internalType: "string",
        name: "contentHash",
        type: "string"
      }],
      indexed: !1,
      internalType: "struct ERC721BaseCollectionV2.Item",
      name: "_item",
      type: "tuple"
    }],
    name: "AddItem",
    type: "event"
  }, {
    anonymous: !1,
    inputs: [{
      indexed: !0,
      internalType: "address",
      name: "owner",
      type: "address"
    }, {
      indexed: !0,
      internalType: "address",
      name: "approved",
      type: "address"
    }, {
      indexed: !0,
      internalType: "uint256",
      name: "tokenId",
      type: "uint256"
    }],
    name: "Approval",
    type: "event"
  }, {
    anonymous: !1,
    inputs: [{
      indexed: !0,
      internalType: "address",
      name: "owner",
      type: "address"
    }, {
      indexed: !0,
      internalType: "address",
      name: "operator",
      type: "address"
    }, {
      indexed: !1,
      internalType: "bool",
      name: "approved",
      type: "bool"
    }],
    name: "ApprovalForAll",
    type: "event"
  }, {
    anonymous: !1,
    inputs: [{
      indexed: !1,
      internalType: "string",
      name: "_oldBaseURI",
      type: "string"
    }, {
      indexed: !1,
      internalType: "string",
      name: "_newBaseURI",
      type: "string"
    }],
    name: "BaseURI",
    type: "event"
  }, {
    anonymous: !1,
    inputs: [],
    name: "Complete",
    type: "event"
  }, {
    anonymous: !1,
    inputs: [{
      indexed: !0,
      internalType: "address",
      name: "_previousCreator",
      type: "address"
    }, {
      indexed: !0,
      internalType: "address",
      name: "_newCreator",
      type: "address"
    }],
    name: "CreatorshipTransferred",
    type: "event"
  }, {
    anonymous: !1,
    inputs: [{
      indexed: !0,
      internalType: "address",
      name: "_beneficiary",
      type: "address"
    }, {
      indexed: !0,
      internalType: "uint256",
      name: "_tokenId",
      type: "uint256"
    }, {
      indexed: !0,
      internalType: "uint256",
      name: "_itemId",
      type: "uint256"
    }, {
      indexed: !1,
      internalType: "uint256",
      name: "_issuedId",
      type: "uint256"
    }, {
      indexed: !1,
      internalType: "address",
      name: "_caller",
      type: "address"
    }],
    name: "Issue",
    type: "event"
  }, {
    anonymous: !1,
    inputs: [{
      indexed: !1,
      internalType: "address",
      name: "userAddress",
      type: "address"
    }, {
      indexed: !1,
      internalType: "address",
      name: "relayerAddress",
      type: "address"
    }, {
      indexed: !1,
      internalType: "bytes",
      name: "functionSignature",
      type: "bytes"
    }],
    name: "MetaTransactionExecuted",
    type: "event"
  }, {
    anonymous: !1,
    inputs: [{
      indexed: !0,
      internalType: "address",
      name: "previousOwner",
      type: "address"
    }, {
      indexed: !0,
      internalType: "address",
      name: "newOwner",
      type: "address"
    }],
    name: "OwnershipTransferred",
    type: "event"
  }, {
    anonymous: !1,
    inputs: [{
      indexed: !0,
      internalType: "uint256",
      name: "_itemId",
      type: "uint256"
    }, {
      indexed: !1,
      internalType: "string",
      name: "_contentHash",
      type: "string"
    }, {
      indexed: !1,
      internalType: "string",
      name: "_metadata",
      type: "string"
    }],
    name: "RescueItem",
    type: "event"
  }, {
    anonymous: !1,
    inputs: [{
      indexed: !1,
      internalType: "bool",
      name: "_previousValue",
      type: "bool"
    }, {
      indexed: !1,
      internalType: "bool",
      name: "_newValue",
      type: "bool"
    }],
    name: "SetApproved",
    type: "event"
  }, {
    anonymous: !1,
    inputs: [{
      indexed: !1,
      internalType: "bool",
      name: "_previousValue",
      type: "bool"
    }, {
      indexed: !1,
      internalType: "bool",
      name: "_newValue",
      type: "bool"
    }],
    name: "SetEditable",
    type: "event"
  }, {
    anonymous: !1,
    inputs: [{
      indexed: !0,
      internalType: "address",
      name: "_manager",
      type: "address"
    }, {
      indexed: !1,
      internalType: "bool",
      name: "_value",
      type: "bool"
    }],
    name: "SetGlobalManager",
    type: "event"
  }, {
    anonymous: !1,
    inputs: [{
      indexed: !0,
      internalType: "address",
      name: "_minter",
      type: "address"
    }, {
      indexed: !1,
      internalType: "bool",
      name: "_value",
      type: "bool"
    }],
    name: "SetGlobalMinter",
    type: "event"
  }, {
    anonymous: !1,
    inputs: [{
      indexed: !0,
      internalType: "uint256",
      name: "_itemId",
      type: "uint256"
    }, {
      indexed: !0,
      internalType: "address",
      name: "_manager",
      type: "address"
    }, {
      indexed: !1,
      internalType: "bool",
      name: "_value",
      type: "bool"
    }],
    name: "SetItemManager",
    type: "event"
  }, {
    anonymous: !1,
    inputs: [{
      indexed: !0,
      internalType: "uint256",
      name: "_itemId",
      type: "uint256"
    }, {
      indexed: !0,
      internalType: "address",
      name: "_minter",
      type: "address"
    }, {
      indexed: !1,
      internalType: "uint256",
      name: "_value",
      type: "uint256"
    }],
    name: "SetItemMinter",
    type: "event"
  }, {
    anonymous: !1,
    inputs: [{
      indexed: !0,
      internalType: "address",
      name: "from",
      type: "address"
    }, {
      indexed: !0,
      internalType: "address",
      name: "to",
      type: "address"
    }, {
      indexed: !0,
      internalType: "uint256",
      name: "tokenId",
      type: "uint256"
    }],
    name: "Transfer",
    type: "event"
  }, {
    anonymous: !1,
    inputs: [{
      indexed: !0,
      internalType: "uint256",
      name: "_itemId",
      type: "uint256"
    }, {
      indexed: !1,
      internalType: "uint256",
      name: "_price",
      type: "uint256"
    }, {
      indexed: !1,
      internalType: "address",
      name: "_beneficiary",
      type: "address"
    }, {
      indexed: !1,
      internalType: "string",
      name: "_metadata",
      type: "string"
    }],
    name: "UpdateItemData",
    type: "event"
  }, {
    inputs: [],
    name: "COLLECTION_HASH",
    outputs: [{
      internalType: "bytes32",
      name: "",
      type: "bytes32"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [],
    name: "ISSUED_ID_BITS",
    outputs: [{
      internalType: "uint8",
      name: "",
      type: "uint8"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [],
    name: "ITEM_ID_BITS",
    outputs: [{
      internalType: "uint8",
      name: "",
      type: "uint8"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [],
    name: "MAX_ISSUED_ID",
    outputs: [{
      internalType: "uint216",
      name: "",
      type: "uint216"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [],
    name: "MAX_ITEM_ID",
    outputs: [{
      internalType: "uint40",
      name: "",
      type: "uint40"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [{
      components: [{
        internalType: "string",
        name: "rarity",
        type: "string"
      }, {
        internalType: "uint256",
        name: "price",
        type: "uint256"
      }, {
        internalType: "address",
        name: "beneficiary",
        type: "address"
      }, {
        internalType: "string",
        name: "metadata",
        type: "string"
      }],
      internalType: "struct ERC721BaseCollectionV2.ItemParam[]",
      name: "_items",
      type: "tuple[]"
    }],
    name: "addItems",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }, {
    inputs: [{
      internalType: "address",
      name: "to",
      type: "address"
    }, {
      internalType: "uint256",
      name: "tokenId",
      type: "uint256"
    }],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }, {
    inputs: [{
      internalType: "address",
      name: "owner",
      type: "address"
    }],
    name: "balanceOf",
    outputs: [{
      internalType: "uint256",
      name: "",
      type: "uint256"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [],
    name: "baseURI",
    outputs: [{
      internalType: "string",
      name: "",
      type: "string"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [{
      internalType: "address",
      name: "_from",
      type: "address"
    }, {
      internalType: "address",
      name: "_to",
      type: "address"
    }, {
      internalType: "uint256[]",
      name: "_tokenIds",
      type: "uint256[]"
    }],
    name: "batchTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }, {
    inputs: [],
    name: "completeCollection",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }, {
    inputs: [],
    name: "createdAt",
    outputs: [{
      internalType: "uint256",
      name: "",
      type: "uint256"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [],
    name: "creator",
    outputs: [{
      internalType: "address",
      name: "",
      type: "address"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [{
      internalType: "uint256",
      name: "_id",
      type: "uint256"
    }],
    name: "decodeTokenId",
    outputs: [{
      internalType: "uint256",
      name: "itemId",
      type: "uint256"
    }, {
      internalType: "uint256",
      name: "issuedId",
      type: "uint256"
    }],
    stateMutability: "pure",
    type: "function"
  }, {
    inputs: [],
    name: "domainSeparator",
    outputs: [{
      internalType: "bytes32",
      name: "",
      type: "bytes32"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [{
      internalType: "uint256[]",
      name: "_itemIds",
      type: "uint256[]"
    }, {
      internalType: "uint256[]",
      name: "_prices",
      type: "uint256[]"
    }, {
      internalType: "address[]",
      name: "_beneficiaries",
      type: "address[]"
    }, {
      internalType: "string[]",
      name: "_metadatas",
      type: "string[]"
    }],
    name: "editItemsData",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }, {
    inputs: [{
      internalType: "uint256",
      name: "_itemId",
      type: "uint256"
    }, {
      internalType: "uint256",
      name: "_issuedId",
      type: "uint256"
    }],
    name: "encodeTokenId",
    outputs: [{
      internalType: "uint256",
      name: "id",
      type: "uint256"
    }],
    stateMutability: "pure",
    type: "function"
  }, {
    inputs: [{
      internalType: "address",
      name: "userAddress",
      type: "address"
    }, {
      internalType: "bytes",
      name: "functionSignature",
      type: "bytes"
    }, {
      internalType: "bytes32",
      name: "sigR",
      type: "bytes32"
    }, {
      internalType: "bytes32",
      name: "sigS",
      type: "bytes32"
    }, {
      internalType: "uint8",
      name: "sigV",
      type: "uint8"
    }],
    name: "executeMetaTransaction",
    outputs: [{
      internalType: "bytes",
      name: "",
      type: "bytes"
    }],
    stateMutability: "payable",
    type: "function"
  }, {
    inputs: [{
      internalType: "uint256",
      name: "tokenId",
      type: "uint256"
    }],
    name: "getApproved",
    outputs: [{
      internalType: "address",
      name: "",
      type: "address"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [],
    name: "getChainId",
    outputs: [{
      internalType: "uint256",
      name: "",
      type: "uint256"
    }],
    stateMutability: "pure",
    type: "function"
  }, {
    inputs: [{
      internalType: "address",
      name: "user",
      type: "address"
    }],
    name: "getNonce",
    outputs: [{
      internalType: "uint256",
      name: "nonce",
      type: "uint256"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [{
      internalType: "address",
      name: "",
      type: "address"
    }],
    name: "globalManagers",
    outputs: [{
      internalType: "bool",
      name: "",
      type: "bool"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [{
      internalType: "address",
      name: "",
      type: "address"
    }],
    name: "globalMinters",
    outputs: [{
      internalType: "bool",
      name: "",
      type: "bool"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [],
    name: "initImplementation",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }, {
    inputs: [{
      internalType: "string",
      name: "_name",
      type: "string"
    }, {
      internalType: "string",
      name: "_symbol",
      type: "string"
    }, {
      internalType: "string",
      name: "_baseURI",
      type: "string"
    }, {
      internalType: "address",
      name: "_creator",
      type: "address"
    }, {
      internalType: "bool",
      name: "_shouldComplete",
      type: "bool"
    }, {
      internalType: "bool",
      name: "_isApproved",
      type: "bool"
    }, {
      internalType: "contract IRarities",
      name: "_rarities",
      type: "address"
    }, {
      components: [{
        internalType: "string",
        name: "rarity",
        type: "string"
      }, {
        internalType: "uint256",
        name: "price",
        type: "uint256"
      }, {
        internalType: "address",
        name: "beneficiary",
        type: "address"
      }, {
        internalType: "string",
        name: "metadata",
        type: "string"
      }],
      internalType: "struct ERC721BaseCollectionV2.ItemParam[]",
      name: "_items",
      type: "tuple[]"
    }],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }, {
    inputs: [],
    name: "isApproved",
    outputs: [{
      internalType: "bool",
      name: "",
      type: "bool"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [{
      internalType: "address",
      name: "owner",
      type: "address"
    }, {
      internalType: "address",
      name: "operator",
      type: "address"
    }],
    name: "isApprovedForAll",
    outputs: [{
      internalType: "bool",
      name: "",
      type: "bool"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [],
    name: "isCompleted",
    outputs: [{
      internalType: "bool",
      name: "",
      type: "bool"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [],
    name: "isEditable",
    outputs: [{
      internalType: "bool",
      name: "",
      type: "bool"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [],
    name: "isInitialized",
    outputs: [{
      internalType: "bool",
      name: "",
      type: "bool"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [],
    name: "isMintingAllowed",
    outputs: [{
      internalType: "bool",
      name: "",
      type: "bool"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [{
      internalType: "address[]",
      name: "_beneficiaries",
      type: "address[]"
    }, {
      internalType: "uint256[]",
      name: "_itemIds",
      type: "uint256[]"
    }],
    name: "issueTokens",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }, {
    inputs: [{
      internalType: "uint256",
      name: "",
      type: "uint256"
    }, {
      internalType: "address",
      name: "",
      type: "address"
    }],
    name: "itemManagers",
    outputs: [{
      internalType: "bool",
      name: "",
      type: "bool"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [{
      internalType: "uint256",
      name: "",
      type: "uint256"
    }, {
      internalType: "address",
      name: "",
      type: "address"
    }],
    name: "itemMinters",
    outputs: [{
      internalType: "uint256",
      name: "",
      type: "uint256"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [{
      internalType: "uint256",
      name: "",
      type: "uint256"
    }],
    name: "items",
    outputs: [{
      internalType: "string",
      name: "rarity",
      type: "string"
    }, {
      internalType: "uint256",
      name: "maxSupply",
      type: "uint256"
    }, {
      internalType: "uint256",
      name: "totalSupply",
      type: "uint256"
    }, {
      internalType: "uint256",
      name: "price",
      type: "uint256"
    }, {
      internalType: "address",
      name: "beneficiary",
      type: "address"
    }, {
      internalType: "string",
      name: "metadata",
      type: "string"
    }, {
      internalType: "string",
      name: "contentHash",
      type: "string"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [],
    name: "itemsCount",
    outputs: [{
      internalType: "uint256",
      name: "",
      type: "uint256"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [],
    name: "name",
    outputs: [{
      internalType: "string",
      name: "",
      type: "string"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [],
    name: "owner",
    outputs: [{
      internalType: "address",
      name: "",
      type: "address"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [{
      internalType: "uint256",
      name: "tokenId",
      type: "uint256"
    }],
    name: "ownerOf",
    outputs: [{
      internalType: "address",
      name: "",
      type: "address"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [],
    name: "rarities",
    outputs: [{
      internalType: "contract IRarities",
      name: "",
      type: "address"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }, {
    inputs: [{
      internalType: "uint256[]",
      name: "_itemIds",
      type: "uint256[]"
    }, {
      internalType: "string[]",
      name: "_contentHashes",
      type: "string[]"
    }, {
      internalType: "string[]",
      name: "_metadatas",
      type: "string[]"
    }],
    name: "rescueItems",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }, {
    inputs: [{
      internalType: "address",
      name: "_from",
      type: "address"
    }, {
      internalType: "address",
      name: "_to",
      type: "address"
    }, {
      internalType: "uint256[]",
      name: "_tokenIds",
      type: "uint256[]"
    }, {
      internalType: "bytes",
      name: "_data",
      type: "bytes"
    }],
    name: "safeBatchTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }, {
    inputs: [{
      internalType: "address",
      name: "from",
      type: "address"
    }, {
      internalType: "address",
      name: "to",
      type: "address"
    }, {
      internalType: "uint256",
      name: "tokenId",
      type: "uint256"
    }],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }, {
    inputs: [{
      internalType: "address",
      name: "from",
      type: "address"
    }, {
      internalType: "address",
      name: "to",
      type: "address"
    }, {
      internalType: "uint256",
      name: "tokenId",
      type: "uint256"
    }, {
      internalType: "bytes",
      name: "_data",
      type: "bytes"
    }],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }, {
    inputs: [{
      internalType: "address",
      name: "operator",
      type: "address"
    }, {
      internalType: "bool",
      name: "approved",
      type: "bool"
    }],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }, {
    inputs: [{
      internalType: "bool",
      name: "_value",
      type: "bool"
    }],
    name: "setApproved",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }, {
    inputs: [{
      internalType: "string",
      name: "_baseURI",
      type: "string"
    }],
    name: "setBaseURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }, {
    inputs: [{
      internalType: "bool",
      name: "_value",
      type: "bool"
    }],
    name: "setEditable",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }, {
    inputs: [{
      internalType: "uint256[]",
      name: "_itemIds",
      type: "uint256[]"
    }, {
      internalType: "address[]",
      name: "_managers",
      type: "address[]"
    }, {
      internalType: "bool[]",
      name: "_values",
      type: "bool[]"
    }],
    name: "setItemsManagers",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }, {
    inputs: [{
      internalType: "uint256[]",
      name: "_itemIds",
      type: "uint256[]"
    }, {
      internalType: "address[]",
      name: "_minters",
      type: "address[]"
    }, {
      internalType: "uint256[]",
      name: "_values",
      type: "uint256[]"
    }],
    name: "setItemsMinters",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }, {
    inputs: [{
      internalType: "address[]",
      name: "_managers",
      type: "address[]"
    }, {
      internalType: "bool[]",
      name: "_values",
      type: "bool[]"
    }],
    name: "setManagers",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }, {
    inputs: [{
      internalType: "address[]",
      name: "_minters",
      type: "address[]"
    }, {
      internalType: "bool[]",
      name: "_values",
      type: "bool[]"
    }],
    name: "setMinters",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }, {
    inputs: [{
      internalType: "bytes4",
      name: "interfaceId",
      type: "bytes4"
    }],
    name: "supportsInterface",
    outputs: [{
      internalType: "bool",
      name: "",
      type: "bool"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [],
    name: "symbol",
    outputs: [{
      internalType: "string",
      name: "",
      type: "string"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [{
      internalType: "uint256",
      name: "index",
      type: "uint256"
    }],
    name: "tokenByIndex",
    outputs: [{
      internalType: "uint256",
      name: "",
      type: "uint256"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [{
      internalType: "address",
      name: "owner",
      type: "address"
    }, {
      internalType: "uint256",
      name: "index",
      type: "uint256"
    }],
    name: "tokenOfOwnerByIndex",
    outputs: [{
      internalType: "uint256",
      name: "",
      type: "uint256"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [{
      internalType: "uint256",
      name: "_tokenId",
      type: "uint256"
    }],
    name: "tokenURI",
    outputs: [{
      internalType: "string",
      name: "",
      type: "string"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [],
    name: "totalSupply",
    outputs: [{
      internalType: "uint256",
      name: "",
      type: "uint256"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [{
      internalType: "address",
      name: "_newCreator",
      type: "address"
    }],
    name: "transferCreatorship",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }, {
    inputs: [{
      internalType: "address",
      name: "from",
      type: "address"
    }, {
      internalType: "address",
      name: "to",
      type: "address"
    }, {
      internalType: "uint256",
      name: "tokenId",
      type: "uint256"
    }],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }, {
    inputs: [{
      internalType: "address",
      name: "newOwner",
      type: "address"
    }],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }]), _defineProperty(_Oe, e.ContractName.Forwarder, [{
    inputs: [{
      internalType: "address",
      name: "_owner",
      type: "address"
    }, {
      internalType: "address",
      name: "_caller",
      type: "address"
    }],
    stateMutability: "nonpayable",
    type: "constructor"
  }, {
    anonymous: !1,
    inputs: [{
      indexed: !0,
      internalType: "address",
      name: "_oldCaller",
      type: "address"
    }, {
      indexed: !0,
      internalType: "address",
      name: "_newCaller",
      type: "address"
    }],
    name: "CallerSet",
    type: "event"
  }, {
    anonymous: !1,
    inputs: [{
      indexed: !0,
      internalType: "address",
      name: "previousOwner",
      type: "address"
    }, {
      indexed: !0,
      internalType: "address",
      name: "newOwner",
      type: "address"
    }],
    name: "OwnershipTransferred",
    type: "event"
  }, {
    inputs: [],
    name: "caller",
    outputs: [{
      internalType: "address",
      name: "",
      type: "address"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [{
      internalType: "address",
      name: "_target",
      type: "address"
    }, {
      internalType: "bytes",
      name: "_data",
      type: "bytes"
    }],
    name: "forwardCall",
    outputs: [{
      internalType: "bool",
      name: "",
      type: "bool"
    }, {
      internalType: "bytes",
      name: "",
      type: "bytes"
    }],
    stateMutability: "payable",
    type: "function"
  }, {
    inputs: [],
    name: "owner",
    outputs: [{
      internalType: "address",
      name: "",
      type: "address"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }, {
    inputs: [{
      internalType: "address",
      name: "_newCaller",
      type: "address"
    }],
    name: "setCaller",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }, {
    inputs: [{
      internalType: "address",
      name: "newOwner",
      type: "address"
    }],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }]), _defineProperty(_Oe, e.ContractName.MANAToken, [{
    type: "constructor",
    stateMutability: "nonpayable",
    inputs: []
  }, {
    type: "event",
    name: "Approval",
    inputs: [{
      type: "address",
      name: "owner",
      internalType: "address",
      indexed: !0
    }, {
      type: "address",
      name: "spender",
      internalType: "address",
      indexed: !0
    }, {
      type: "uint256",
      name: "value",
      internalType: "uint256",
      indexed: !1
    }],
    anonymous: !1
  }, {
    type: "event",
    name: "MetaTransactionExecuted",
    inputs: [{
      type: "address",
      name: "userAddress",
      internalType: "address",
      indexed: !1
    }, {
      type: "address",
      name: "relayerAddress",
      internalType: "address payable",
      indexed: !1
    }, {
      type: "bytes",
      name: "functionSignature",
      internalType: "bytes",
      indexed: !1
    }],
    anonymous: !1
  }, {
    type: "event",
    name: "RoleAdminChanged",
    inputs: [{
      type: "bytes32",
      name: "role",
      internalType: "bytes32",
      indexed: !0
    }, {
      type: "bytes32",
      name: "previousAdminRole",
      internalType: "bytes32",
      indexed: !0
    }, {
      type: "bytes32",
      name: "newAdminRole",
      internalType: "bytes32",
      indexed: !0
    }],
    anonymous: !1
  }, {
    type: "event",
    name: "RoleGranted",
    inputs: [{
      type: "bytes32",
      name: "role",
      internalType: "bytes32",
      indexed: !0
    }, {
      type: "address",
      name: "account",
      internalType: "address",
      indexed: !0
    }, {
      type: "address",
      name: "sender",
      internalType: "address",
      indexed: !0
    }],
    anonymous: !1
  }, {
    type: "event",
    name: "RoleRevoked",
    inputs: [{
      type: "bytes32",
      name: "role",
      internalType: "bytes32",
      indexed: !0
    }, {
      type: "address",
      name: "account",
      internalType: "address",
      indexed: !0
    }, {
      type: "address",
      name: "sender",
      internalType: "address",
      indexed: !0
    }],
    anonymous: !1
  }, {
    type: "event",
    name: "Transfer",
    inputs: [{
      type: "address",
      name: "from",
      internalType: "address",
      indexed: !0
    }, {
      type: "address",
      name: "to",
      internalType: "address",
      indexed: !0
    }, {
      type: "uint256",
      name: "value",
      internalType: "uint256",
      indexed: !1
    }],
    anonymous: !1
  }, {
    type: "function",
    stateMutability: "view",
    outputs: [{
      type: "uint256",
      name: "",
      internalType: "uint256"
    }],
    name: "CHILD_CHAIN_ID",
    inputs: []
  }, {
    type: "function",
    stateMutability: "view",
    outputs: [{
      type: "bytes",
      name: "",
      internalType: "bytes"
    }],
    name: "CHILD_CHAIN_ID_BYTES",
    inputs: []
  }, {
    type: "function",
    stateMutability: "view",
    outputs: [{
      type: "bytes32",
      name: "",
      internalType: "bytes32"
    }],
    name: "DEFAULT_ADMIN_ROLE",
    inputs: []
  }, {
    type: "function",
    stateMutability: "view",
    outputs: [{
      type: "bytes32",
      name: "",
      internalType: "bytes32"
    }],
    name: "DEPOSITOR_ROLE",
    inputs: []
  }, {
    type: "function",
    stateMutability: "view",
    outputs: [{
      type: "string",
      name: "",
      internalType: "string"
    }],
    name: "ERC712_VERSION",
    inputs: []
  }, {
    type: "function",
    stateMutability: "view",
    outputs: [{
      type: "uint256",
      name: "",
      internalType: "uint256"
    }],
    name: "ROOT_CHAIN_ID",
    inputs: []
  }, {
    type: "function",
    stateMutability: "view",
    outputs: [{
      type: "bytes",
      name: "",
      internalType: "bytes"
    }],
    name: "ROOT_CHAIN_ID_BYTES",
    inputs: []
  }, {
    type: "function",
    stateMutability: "view",
    outputs: [{
      type: "uint256",
      name: "",
      internalType: "uint256"
    }],
    name: "allowance",
    inputs: [{
      type: "address",
      name: "owner",
      internalType: "address"
    }, {
      type: "address",
      name: "spender",
      internalType: "address"
    }]
  }, {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [{
      type: "bool",
      name: "",
      internalType: "bool"
    }],
    name: "approve",
    inputs: [{
      type: "address",
      name: "spender",
      internalType: "address"
    }, {
      type: "uint256",
      name: "amount",
      internalType: "uint256"
    }]
  }, {
    type: "function",
    stateMutability: "view",
    outputs: [{
      type: "uint256",
      name: "",
      internalType: "uint256"
    }],
    name: "balanceOf",
    inputs: [{
      type: "address",
      name: "account",
      internalType: "address"
    }]
  }, {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [],
    name: "changeName",
    inputs: [{
      type: "string",
      name: "name_",
      internalType: "string"
    }]
  }, {
    type: "function",
    stateMutability: "view",
    outputs: [{
      type: "uint8",
      name: "",
      internalType: "uint8"
    }],
    name: "decimals",
    inputs: []
  }, {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [{
      type: "bool",
      name: "",
      internalType: "bool"
    }],
    name: "decreaseAllowance",
    inputs: [{
      type: "address",
      name: "spender",
      internalType: "address"
    }, {
      type: "uint256",
      name: "subtractedValue",
      internalType: "uint256"
    }]
  }, {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [],
    name: "deposit",
    inputs: [{
      type: "address",
      name: "user",
      internalType: "address"
    }, {
      type: "bytes",
      name: "depositData",
      internalType: "bytes"
    }]
  }, {
    type: "function",
    stateMutability: "payable",
    outputs: [{
      type: "bytes",
      name: "",
      internalType: "bytes"
    }],
    name: "executeMetaTransaction",
    inputs: [{
      type: "address",
      name: "userAddress",
      internalType: "address"
    }, {
      type: "bytes",
      name: "functionSignature",
      internalType: "bytes"
    }, {
      type: "bytes32",
      name: "sigR",
      internalType: "bytes32"
    }, {
      type: "bytes32",
      name: "sigS",
      internalType: "bytes32"
    }, {
      type: "uint8",
      name: "sigV",
      internalType: "uint8"
    }]
  }, {
    type: "function",
    stateMutability: "pure",
    outputs: [{
      type: "uint256",
      name: "",
      internalType: "uint256"
    }],
    name: "getChainId",
    inputs: []
  }, {
    type: "function",
    stateMutability: "view",
    outputs: [{
      type: "bytes32",
      name: "",
      internalType: "bytes32"
    }],
    name: "getDomainSeperator",
    inputs: []
  }, {
    type: "function",
    stateMutability: "view",
    outputs: [{
      type: "uint256",
      name: "nonce",
      internalType: "uint256"
    }],
    name: "getNonce",
    inputs: [{
      type: "address",
      name: "user",
      internalType: "address"
    }]
  }, {
    type: "function",
    stateMutability: "view",
    outputs: [{
      type: "bytes32",
      name: "",
      internalType: "bytes32"
    }],
    name: "getRoleAdmin",
    inputs: [{
      type: "bytes32",
      name: "role",
      internalType: "bytes32"
    }]
  }, {
    type: "function",
    stateMutability: "view",
    outputs: [{
      type: "address",
      name: "",
      internalType: "address"
    }],
    name: "getRoleMember",
    inputs: [{
      type: "bytes32",
      name: "role",
      internalType: "bytes32"
    }, {
      type: "uint256",
      name: "index",
      internalType: "uint256"
    }]
  }, {
    type: "function",
    stateMutability: "view",
    outputs: [{
      type: "uint256",
      name: "",
      internalType: "uint256"
    }],
    name: "getRoleMemberCount",
    inputs: [{
      type: "bytes32",
      name: "role",
      internalType: "bytes32"
    }]
  }, {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [],
    name: "grantRole",
    inputs: [{
      type: "bytes32",
      name: "role",
      internalType: "bytes32"
    }, {
      type: "address",
      name: "account",
      internalType: "address"
    }]
  }, {
    type: "function",
    stateMutability: "view",
    outputs: [{
      type: "bool",
      name: "",
      internalType: "bool"
    }],
    name: "hasRole",
    inputs: [{
      type: "bytes32",
      name: "role",
      internalType: "bytes32"
    }, {
      type: "address",
      name: "account",
      internalType: "address"
    }]
  }, {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [{
      type: "bool",
      name: "",
      internalType: "bool"
    }],
    name: "increaseAllowance",
    inputs: [{
      type: "address",
      name: "spender",
      internalType: "address"
    }, {
      type: "uint256",
      name: "addedValue",
      internalType: "uint256"
    }]
  }, {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [],
    name: "initialize",
    inputs: [{
      type: "string",
      name: "name_",
      internalType: "string"
    }, {
      type: "string",
      name: "symbol_",
      internalType: "string"
    }, {
      type: "uint8",
      name: "decimals_",
      internalType: "uint8"
    }, {
      type: "address",
      name: "childChainManager",
      internalType: "address"
    }]
  }, {
    type: "function",
    stateMutability: "view",
    outputs: [{
      type: "string",
      name: "",
      internalType: "string"
    }],
    name: "name",
    inputs: []
  }, {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [],
    name: "renounceRole",
    inputs: [{
      type: "bytes32",
      name: "role",
      internalType: "bytes32"
    }, {
      type: "address",
      name: "account",
      internalType: "address"
    }]
  }, {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [],
    name: "revokeRole",
    inputs: [{
      type: "bytes32",
      name: "role",
      internalType: "bytes32"
    }, {
      type: "address",
      name: "account",
      internalType: "address"
    }]
  }, {
    type: "function",
    stateMutability: "view",
    outputs: [{
      type: "string",
      name: "",
      internalType: "string"
    }],
    name: "symbol",
    inputs: []
  }, {
    type: "function",
    stateMutability: "view",
    outputs: [{
      type: "uint256",
      name: "",
      internalType: "uint256"
    }],
    name: "totalSupply",
    inputs: []
  }, {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [{
      type: "bool",
      name: "",
      internalType: "bool"
    }],
    name: "transfer",
    inputs: [{
      type: "address",
      name: "recipient",
      internalType: "address"
    }, {
      type: "uint256",
      name: "amount",
      internalType: "uint256"
    }]
  }, {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [{
      type: "bool",
      name: "",
      internalType: "bool"
    }],
    name: "transferFrom",
    inputs: [{
      type: "address",
      name: "sender",
      internalType: "address"
    }, {
      type: "address",
      name: "recipient",
      internalType: "address"
    }, {
      type: "uint256",
      name: "amount",
      internalType: "uint256"
    }]
  }, {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [],
    name: "withdraw",
    inputs: [{
      type: "uint256",
      name: "amount",
      internalType: "uint256"
    }]
  }]), _defineProperty(_Oe, e.ContractName.Marketplace, [{
    inputs: [{
      internalType: "address",
      name: "_acceptedToken",
      type: "address"
    }, {
      internalType: "uint256",
      name: "_ownerCutPerMillion",
      type: "uint256"
    }, {
      internalType: "address",
      name: "_owner",
      type: "address"
    }],
    stateMutability: "nonpayable",
    type: "constructor"
  }, {
    anonymous: !1,
    inputs: [{
      indexed: !1,
      internalType: "uint256",
      name: "ownerCutPerMillion",
      type: "uint256"
    }],
    name: "ChangedOwnerCutPerMillion",
    type: "event"
  }, {
    anonymous: !1,
    inputs: [{
      indexed: !1,
      internalType: "uint256",
      name: "publicationFee",
      type: "uint256"
    }],
    name: "ChangedPublicationFee",
    type: "event"
  }, {
    anonymous: !1,
    inputs: [{
      indexed: !1,
      internalType: "address",
      name: "userAddress",
      type: "address"
    }, {
      indexed: !1,
      internalType: "address",
      name: "relayerAddress",
      type: "address"
    }, {
      indexed: !1,
      internalType: "bytes",
      name: "functionSignature",
      type: "bytes"
    }],
    name: "MetaTransactionExecuted",
    type: "event"
  }, {
    anonymous: !1,
    inputs: [{
      indexed: !1,
      internalType: "bytes32",
      name: "id",
      type: "bytes32"
    }, {
      indexed: !0,
      internalType: "uint256",
      name: "assetId",
      type: "uint256"
    }, {
      indexed: !0,
      internalType: "address",
      name: "seller",
      type: "address"
    }, {
      indexed: !1,
      internalType: "address",
      name: "nftAddress",
      type: "address"
    }],
    name: "OrderCancelled",
    type: "event"
  }, {
    anonymous: !1,
    inputs: [{
      indexed: !1,
      internalType: "bytes32",
      name: "id",
      type: "bytes32"
    }, {
      indexed: !0,
      internalType: "uint256",
      name: "assetId",
      type: "uint256"
    }, {
      indexed: !0,
      internalType: "address",
      name: "seller",
      type: "address"
    }, {
      indexed: !1,
      internalType: "address",
      name: "nftAddress",
      type: "address"
    }, {
      indexed: !1,
      internalType: "uint256",
      name: "priceInWei",
      type: "uint256"
    }, {
      indexed: !1,
      internalType: "uint256",
      name: "expiresAt",
      type: "uint256"
    }],
    name: "OrderCreated",
    type: "event"
  }, {
    anonymous: !1,
    inputs: [{
      indexed: !1,
      internalType: "bytes32",
      name: "id",
      type: "bytes32"
    }, {
      indexed: !0,
      internalType: "uint256",
      name: "assetId",
      type: "uint256"
    }, {
      indexed: !0,
      internalType: "address",
      name: "seller",
      type: "address"
    }, {
      indexed: !1,
      internalType: "address",
      name: "nftAddress",
      type: "address"
    }, {
      indexed: !1,
      internalType: "uint256",
      name: "totalPrice",
      type: "uint256"
    }, {
      indexed: !0,
      internalType: "address",
      name: "buyer",
      type: "address"
    }],
    name: "OrderSuccessful",
    type: "event"
  }, {
    anonymous: !1,
    inputs: [{
      indexed: !0,
      internalType: "address",
      name: "previousOwner",
      type: "address"
    }, {
      indexed: !0,
      internalType: "address",
      name: "newOwner",
      type: "address"
    }],
    name: "OwnershipTransferred",
    type: "event"
  }, {
    anonymous: !1,
    inputs: [{
      indexed: !1,
      internalType: "address",
      name: "account",
      type: "address"
    }],
    name: "Paused",
    type: "event"
  }, {
    anonymous: !1,
    inputs: [{
      indexed: !1,
      internalType: "address",
      name: "account",
      type: "address"
    }],
    name: "Unpaused",
    type: "event"
  }, {
    inputs: [],
    name: "ERC721_Interface",
    outputs: [{
      internalType: "bytes4",
      name: "",
      type: "bytes4"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [],
    name: "InterfaceId_ValidateFingerprint",
    outputs: [{
      internalType: "bytes4",
      name: "",
      type: "bytes4"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [],
    name: "acceptedToken",
    outputs: [{
      internalType: "contract ERC20Interface",
      name: "",
      type: "address"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [{
      internalType: "address",
      name: "nftAddress",
      type: "address"
    }, {
      internalType: "uint256",
      name: "assetId",
      type: "uint256"
    }],
    name: "cancelOrder",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }, {
    inputs: [{
      internalType: "address",
      name: "nftAddress",
      type: "address"
    }, {
      internalType: "uint256",
      name: "assetId",
      type: "uint256"
    }, {
      internalType: "uint256",
      name: "priceInWei",
      type: "uint256"
    }, {
      internalType: "uint256",
      name: "expiresAt",
      type: "uint256"
    }],
    name: "createOrder",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }, {
    inputs: [],
    name: "domainSeparator",
    outputs: [{
      internalType: "bytes32",
      name: "",
      type: "bytes32"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [{
      internalType: "address",
      name: "userAddress",
      type: "address"
    }, {
      internalType: "bytes",
      name: "functionSignature",
      type: "bytes"
    }, {
      internalType: "bytes32",
      name: "sigR",
      type: "bytes32"
    }, {
      internalType: "bytes32",
      name: "sigS",
      type: "bytes32"
    }, {
      internalType: "uint8",
      name: "sigV",
      type: "uint8"
    }],
    name: "executeMetaTransaction",
    outputs: [{
      internalType: "bytes",
      name: "",
      type: "bytes"
    }],
    stateMutability: "payable",
    type: "function"
  }, {
    inputs: [{
      internalType: "address",
      name: "nftAddress",
      type: "address"
    }, {
      internalType: "uint256",
      name: "assetId",
      type: "uint256"
    }, {
      internalType: "uint256",
      name: "price",
      type: "uint256"
    }],
    name: "executeOrder",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }, {
    inputs: [],
    name: "getChainId",
    outputs: [{
      internalType: "uint256",
      name: "",
      type: "uint256"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [{
      internalType: "address",
      name: "user",
      type: "address"
    }],
    name: "getNonce",
    outputs: [{
      internalType: "uint256",
      name: "nonce",
      type: "uint256"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [{
      internalType: "address",
      name: "",
      type: "address"
    }, {
      internalType: "uint256",
      name: "",
      type: "uint256"
    }],
    name: "orderByAssetId",
    outputs: [{
      internalType: "bytes32",
      name: "id",
      type: "bytes32"
    }, {
      internalType: "address",
      name: "seller",
      type: "address"
    }, {
      internalType: "address",
      name: "nftAddress",
      type: "address"
    }, {
      internalType: "uint256",
      name: "price",
      type: "uint256"
    }, {
      internalType: "uint256",
      name: "expiresAt",
      type: "uint256"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [],
    name: "owner",
    outputs: [{
      internalType: "address",
      name: "",
      type: "address"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [],
    name: "ownerCutPerMillion",
    outputs: [{
      internalType: "uint256",
      name: "",
      type: "uint256"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [],
    name: "paused",
    outputs: [{
      internalType: "bool",
      name: "",
      type: "bool"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [],
    name: "publicationFeeInWei",
    outputs: [{
      internalType: "uint256",
      name: "",
      type: "uint256"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }, {
    inputs: [{
      internalType: "address",
      name: "nftAddress",
      type: "address"
    }, {
      internalType: "uint256",
      name: "assetId",
      type: "uint256"
    }, {
      internalType: "uint256",
      name: "price",
      type: "uint256"
    }, {
      internalType: "bytes",
      name: "fingerprint",
      type: "bytes"
    }],
    name: "safeExecuteOrder",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }, {
    inputs: [{
      internalType: "uint256",
      name: "_ownerCutPerMillion",
      type: "uint256"
    }],
    name: "setOwnerCutPerMillion",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }, {
    inputs: [{
      internalType: "uint256",
      name: "_publicationFee",
      type: "uint256"
    }],
    name: "setPublicationFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }, {
    inputs: [{
      internalType: "address",
      name: "newOwner",
      type: "address"
    }],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }]), _defineProperty(_Oe, e.ContractName.Rarities, [{
    inputs: [{
      internalType: "address",
      name: "_owner",
      type: "address"
    }, {
      components: [{
        internalType: "string",
        name: "name",
        type: "string"
      }, {
        internalType: "uint256",
        name: "maxSupply",
        type: "uint256"
      }, {
        internalType: "uint256",
        name: "price",
        type: "uint256"
      }],
      internalType: "struct Rarities.Rarity[]",
      name: "_rarities",
      type: "tuple[]"
    }],
    stateMutability: "nonpayable",
    type: "constructor"
  }, {
    anonymous: !1,
    inputs: [{
      components: [{
        internalType: "string",
        name: "name",
        type: "string"
      }, {
        internalType: "uint256",
        name: "maxSupply",
        type: "uint256"
      }, {
        internalType: "uint256",
        name: "price",
        type: "uint256"
      }],
      indexed: !1,
      internalType: "struct Rarities.Rarity",
      name: "_rarity",
      type: "tuple"
    }],
    name: "AddRarity",
    type: "event"
  }, {
    anonymous: !1,
    inputs: [{
      indexed: !1,
      internalType: "address",
      name: "userAddress",
      type: "address"
    }, {
      indexed: !1,
      internalType: "address",
      name: "relayerAddress",
      type: "address"
    }, {
      indexed: !1,
      internalType: "bytes",
      name: "functionSignature",
      type: "bytes"
    }],
    name: "MetaTransactionExecuted",
    type: "event"
  }, {
    anonymous: !1,
    inputs: [{
      indexed: !0,
      internalType: "address",
      name: "previousOwner",
      type: "address"
    }, {
      indexed: !0,
      internalType: "address",
      name: "newOwner",
      type: "address"
    }],
    name: "OwnershipTransferred",
    type: "event"
  }, {
    anonymous: !1,
    inputs: [{
      indexed: !1,
      internalType: "string",
      name: "_name",
      type: "string"
    }, {
      indexed: !1,
      internalType: "uint256",
      name: "_price",
      type: "uint256"
    }],
    name: "UpdatePrice",
    type: "event"
  }, {
    inputs: [{
      components: [{
        internalType: "string",
        name: "name",
        type: "string"
      }, {
        internalType: "uint256",
        name: "maxSupply",
        type: "uint256"
      }, {
        internalType: "uint256",
        name: "price",
        type: "uint256"
      }],
      internalType: "struct Rarities.Rarity[]",
      name: "_rarities",
      type: "tuple[]"
    }],
    name: "addRarities",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }, {
    inputs: [],
    name: "domainSeparator",
    outputs: [{
      internalType: "bytes32",
      name: "",
      type: "bytes32"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [{
      internalType: "address",
      name: "userAddress",
      type: "address"
    }, {
      internalType: "bytes",
      name: "functionSignature",
      type: "bytes"
    }, {
      internalType: "bytes32",
      name: "sigR",
      type: "bytes32"
    }, {
      internalType: "bytes32",
      name: "sigS",
      type: "bytes32"
    }, {
      internalType: "uint8",
      name: "sigV",
      type: "uint8"
    }],
    name: "executeMetaTransaction",
    outputs: [{
      internalType: "bytes",
      name: "",
      type: "bytes"
    }],
    stateMutability: "payable",
    type: "function"
  }, {
    inputs: [],
    name: "getChainId",
    outputs: [{
      internalType: "uint256",
      name: "",
      type: "uint256"
    }],
    stateMutability: "pure",
    type: "function"
  }, {
    inputs: [{
      internalType: "address",
      name: "user",
      type: "address"
    }],
    name: "getNonce",
    outputs: [{
      internalType: "uint256",
      name: "nonce",
      type: "uint256"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [{
      internalType: "string",
      name: "_rarity",
      type: "string"
    }],
    name: "getRarityByName",
    outputs: [{
      components: [{
        internalType: "string",
        name: "name",
        type: "string"
      }, {
        internalType: "uint256",
        name: "maxSupply",
        type: "uint256"
      }, {
        internalType: "uint256",
        name: "price",
        type: "uint256"
      }],
      internalType: "struct Rarities.Rarity",
      name: "",
      type: "tuple"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [],
    name: "owner",
    outputs: [{
      internalType: "address",
      name: "",
      type: "address"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [{
      internalType: "uint256",
      name: "",
      type: "uint256"
    }],
    name: "rarities",
    outputs: [{
      internalType: "string",
      name: "name",
      type: "string"
    }, {
      internalType: "uint256",
      name: "maxSupply",
      type: "uint256"
    }, {
      internalType: "uint256",
      name: "price",
      type: "uint256"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [],
    name: "raritiesCount",
    outputs: [{
      internalType: "uint256",
      name: "",
      type: "uint256"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }, {
    inputs: [{
      internalType: "address",
      name: "newOwner",
      type: "address"
    }],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }, {
    inputs: [{
      internalType: "string[]",
      name: "_names",
      type: "string[]"
    }, {
      internalType: "uint256[]",
      name: "_prices",
      type: "uint256[]"
    }],
    name: "updatePrices",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }]), _Oe),
      ke = (_ke = {}, _defineProperty(_ke, Re.ETHEREUM_ROPSTEN, {
    version: "1",
    abi: Oe.Bid,
    address: "0x250fa138c0a994799c7a49df3097dc71e37b3d6f",
    name: "Decentraland Bid",
    chainId: Re.ETHEREUM_ROPSTEN
  }), _defineProperty(_ke, Re.ETHEREUM_MAINNET, {
    version: "1",
    abi: Oe.Bid,
    address: "0xe479dfd9664c693b2e2992300930b00bfde08233",
    name: "Decentraland Bid",
    chainId: Re.ETHEREUM_MAINNET
  }), _ke),
      je = (_je = {}, _defineProperty(_je, Re.ETHEREUM_ROPSTEN, {
    version: "2",
    abi: Oe.CollectionFactory,
    address: "0x16d8bac5b67a6b782a9081377bec413bc5bb56a6",
    name: "CollectionFactory",
    chainId: Re.ETHEREUM_ROPSTEN
  }), _defineProperty(_je, Re.MATIC_MUMBAI, {
    version: "2",
    abi: Oe.CollectionFactory,
    address: "0x2A72Ec4241Ac4fBc915ae98aC5a5b01AdE721f4B",
    name: "CollectionFactory",
    chainId: Re.MATIC_MUMBAI
  }), _defineProperty(_je, Re.MATIC_MAINNET, {
    version: "2",
    abi: Oe.CollectionFactory,
    address: "0xB549B2442b2BD0a53795BC5cDcBFE0cAF7ACA9f8",
    name: "CollectionFactory",
    chainId: Re.MATIC_MAINNET
  }), _je),
      De = (_De = {}, _defineProperty(_De, Re.MATIC_MUMBAI, {
    version: "1",
    abi: Oe.CollectionManager,
    address: "0xe539E0AED3C1971560517D58277f8dd9aC296281",
    name: "Decentraland Collection Manager",
    chainId: Re.MATIC_MUMBAI
  }), _defineProperty(_De, Re.MATIC_MAINNET, {
    version: "1",
    abi: Oe.CollectionManager,
    address: "0x9D32AaC179153A991e832550d9F96441Ea27763A",
    name: "Decentraland Collection Manager",
    chainId: Re.MATIC_MAINNET
  }), _De),
      Ue = (_Ue = {}, _defineProperty(_Ue, Re.MATIC_MUMBAI, {
    version: "1",
    abi: Oe.CollectionStore,
    address: "0x6ddF1b1924DAD850AdBc1C02026535464Be06B0c",
    name: "Decentraland Collection Store",
    chainId: Re.MATIC_MUMBAI
  }), _defineProperty(_Ue, Re.MATIC_MAINNET, {
    version: "1",
    abi: Oe.CollectionStore,
    address: "0x214ffC0f0103735728dc66b61A22e4F163e275ae",
    name: "Decentraland Collection Store",
    chainId: Re.MATIC_MAINNET
  }), _Ue),
      Ve = (_Ve = {}, _defineProperty(_Ve, Re.MATIC_MUMBAI, {
    version: "1",
    abi: Oe.Committee,
    address: "0xe18B1361d41afC44658216F3Dc27e48c2336e3c2",
    name: "Decentraland Collection Committee",
    chainId: Re.MATIC_MUMBAI
  }), _defineProperty(_Ve, Re.MATIC_MAINNET, {
    version: "1",
    abi: Oe.Committee,
    address: "0xaeec95a8aa671a6d3fec56594827d7804964fa70",
    name: "Decentraland Collection Committee",
    chainId: Re.MATIC_MAINNET
  }), _Ve),
      Fe = (_Fe = {}, _defineProperty(_Fe, Re.MATIC_MUMBAI, {
    version: "2",
    abi: Oe.ERC20,
    address: "",
    name: "ERC20",
    chainId: Re.MATIC_MUMBAI
  }), _defineProperty(_Fe, Re.MATIC_MAINNET, {
    version: "2",
    abi: Oe.ERC20,
    address: "",
    name: "ERC20",
    chainId: Re.MATIC_MAINNET
  }), _defineProperty(_Fe, Re.ETHEREUM_MAINNET, {
    version: "2",
    abi: Oe.ERC20,
    address: "",
    name: "ERC20",
    chainId: Re.ETHEREUM_MAINNET
  }), _defineProperty(_Fe, Re.ETHEREUM_ROPSTEN, {
    version: "2",
    abi: Oe.ERC20,
    address: "",
    name: "ERC20",
    chainId: Re.ETHEREUM_ROPSTEN
  }), _defineProperty(_Fe, Re.ETHEREUM_RINKEBY, {
    version: "2",
    abi: Oe.ERC20,
    address: "",
    name: "ERC20",
    chainId: Re.ETHEREUM_RINKEBY
  }), _defineProperty(_Fe, Re.ETHEREUM_KOVAN, {
    version: "2",
    abi: Oe.ERC20,
    address: "",
    name: "ERC20",
    chainId: Re.ETHEREUM_KOVAN
  }), _defineProperty(_Fe, Re.ETHEREUM_GOERLI, {
    version: "2",
    abi: Oe.ERC20,
    address: "",
    name: "ERC20",
    chainId: Re.ETHEREUM_GOERLI
  }), _Fe),
      Be = (_Be = {}, _defineProperty(_Be, Re.MATIC_MUMBAI, {
    version: "2",
    abi: Oe.ERC721,
    address: "",
    name: "ERC271",
    chainId: Re.MATIC_MUMBAI
  }), _defineProperty(_Be, Re.MATIC_MAINNET, {
    version: "2",
    abi: Oe.ERC721,
    address: "",
    name: "ERC271",
    chainId: Re.MATIC_MAINNET
  }), _defineProperty(_Be, Re.ETHEREUM_MAINNET, {
    version: "2",
    abi: Oe.ERC721,
    address: "",
    name: "ERC271",
    chainId: Re.ETHEREUM_MAINNET
  }), _defineProperty(_Be, Re.ETHEREUM_ROPSTEN, {
    version: "2",
    abi: Oe.ERC721,
    address: "",
    name: "ERC271",
    chainId: Re.ETHEREUM_ROPSTEN
  }), _defineProperty(_Be, Re.ETHEREUM_RINKEBY, {
    version: "2",
    abi: Oe.ERC721,
    address: "",
    name: "ERC271",
    chainId: Re.ETHEREUM_RINKEBY
  }), _defineProperty(_Be, Re.ETHEREUM_KOVAN, {
    version: "2",
    abi: Oe.ERC721,
    address: "",
    name: "ERC271",
    chainId: Re.ETHEREUM_KOVAN
  }), _defineProperty(_Be, Re.ETHEREUM_GOERLI, {
    version: "2",
    abi: Oe.ERC721,
    address: "",
    name: "ERC271",
    chainId: Re.ETHEREUM_GOERLI
  }), _Be),
      He = (_He = {}, _defineProperty(_He, Re.MATIC_MUMBAI, {
    version: "2",
    abi: Oe.ERC721CollectionV2,
    address: "",
    name: "Decentraland Collection",
    chainId: Re.MATIC_MUMBAI
  }), _defineProperty(_He, Re.MATIC_MAINNET, {
    version: "2",
    abi: Oe.ERC721CollectionV2,
    address: "",
    name: "Decentraland Collection",
    chainId: Re.MATIC_MAINNET
  }), _He),
      Le = (_Le = {}, _defineProperty(_Le, Re.MATIC_MUMBAI, {
    version: "2",
    abi: Oe.Forwarder,
    address: "0x71e56Ad57eca3fAAe5077b7F9ea731a25785fF92",
    name: "Forwarder",
    chainId: Re.MATIC_MUMBAI
  }), _defineProperty(_Le, Re.MATIC_MAINNET, {
    version: "2",
    abi: Oe.Forwarder,
    address: "0xBF6755A83C0dCDBB2933A96EA778E00b717d7004",
    name: "Forwarder",
    chainId: Re.MATIC_MAINNET
  }), _Le),
      Ke = (_Ke = {}, _defineProperty(_Ke, Re.ETHEREUM_MAINNET, {
    version: "1",
    abi: Oe.MANAToken,
    address: "0x0f5d2fb29fb7d3cfee444a200298f468908cc942",
    name: "MANAToken",
    chainId: Re.ETHEREUM_MAINNET
  }), _defineProperty(_Ke, Re.ETHEREUM_ROPSTEN, {
    version: "1",
    abi: Oe.MANAToken,
    address: "0x2a8fd99c19271f4f04b1b7b9c4f7cf264b626edb",
    name: "MANAToken",
    chainId: Re.ETHEREUM_ROPSTEN
  }), _defineProperty(_Ke, Re.ETHEREUM_GOERLI, {
    version: "1",
    abi: Oe.MANAToken,
    address: "0xe7fDae84ACaba2A5Ba817B6E6D8A2d415DBFEdbe",
    name: "MANAToken",
    chainId: Re.ETHEREUM_GOERLI
  }), _defineProperty(_Ke, Re.MATIC_MUMBAI, {
    version: "1",
    abi: Oe.MANAToken,
    address: "0x882Da5967c435eA5cC6b09150d55E8304B838f45",
    name: "Decentraland MANA (PoS)",
    chainId: Re.MATIC_MUMBAI
  }), _defineProperty(_Ke, Re.MATIC_MAINNET, {
    version: "1",
    abi: Oe.MANAToken,
    address: "0xA1c57f48F0Deb89f569dFbE6E2B7f46D33606fD4",
    name: "(PoS) Decentraland MANA",
    chainId: Re.MATIC_MAINNET
  }), _Ke),
      ze = (_ze = {}, _defineProperty(_ze, Re.MATIC_MUMBAI, {
    version: "1",
    abi: Oe.Marketplace,
    address: "0x2a09a000224f5dbe0E17214cA95CDe506DA7CB74",
    name: "Decentraland Marketplace",
    chainId: Re.MATIC_MUMBAI
  }), _defineProperty(_ze, Re.ETHEREUM_ROPSTEN, {
    version: "1",
    abi: Oe.Marketplace,
    address: "0x5424912699dabaa5f2998750c1c66e73d67ad219",
    name: "Decentraland Marketplace",
    chainId: Re.ETHEREUM_ROPSTEN
  }), _defineProperty(_ze, Re.ETHEREUM_MAINNET, {
    version: "1",
    abi: Oe.Marketplace,
    address: "0x8e5660b4ab70168b5a6feea0e0315cb49c8cd539",
    name: "Decentraland Marketplace",
    chainId: Re.ETHEREUM_MAINNET
  }), _defineProperty(_ze, Re.MATIC_MAINNET, {
    version: "1",
    abi: Oe.Marketplace,
    address: "0x02080031b45A3c67d338Dd4A2CC309D28756A160",
    name: "Decentraland Marketplace",
    chainId: Re.MATIC_MAINNET
  }), _ze),
      qe = (_qe = {}, _defineProperty(_qe, Re.MATIC_MUMBAI, {
    version: "1",
    abi: Oe.Rarities,
    address: "0x8eabF06f6cf667915bfF30138be70543bCE2901A",
    name: "Decentraland Rarities",
    chainId: Re.MATIC_MUMBAI
  }), _defineProperty(_qe, Re.MATIC_MAINNET, {
    version: "1",
    abi: Oe.Rarities,
    address: "0x17113b44fdd661A156cc01b5031E3aCF72c32EB3",
    name: "Decentraland Rarities",
    chainId: Re.MATIC_MAINNET
  }), _qe),
      Ge = (_Ge = {}, _defineProperty(_Ge, e.ContractName.Bid, ke), _defineProperty(_Ge, e.ContractName.CollectionFactory, je), _defineProperty(_Ge, e.ContractName.CollectionManager, De), _defineProperty(_Ge, e.ContractName.CollectionStore, Ue), _defineProperty(_Ge, e.ContractName.Committee, Ve), _defineProperty(_Ge, e.ContractName.ERC20, Fe), _defineProperty(_Ge, e.ContractName.ERC721, Be), _defineProperty(_Ge, e.ContractName.ERC721CollectionV2, He), _defineProperty(_Ge, e.ContractName.Forwarder, Le), _defineProperty(_Ge, e.ContractName.MANAToken, Ke), _defineProperty(_Ge, e.ContractName.Marketplace, ze), _defineProperty(_Ge, e.ContractName.Rarities, qe), _Ge);
  /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.
  
    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.
  
    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */

  function Je(e, t, n, a) {
    return new (n || (n = Promise))(function (r, s) {
      function i(e) {
        try {
          p(a.next(e));
        } catch (e) {
          s(e);
        }
      }

      function o(e) {
        try {
          p(a.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function p(e) {
        var t;
        e.done ? r(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
          e(t);
        })).then(i, o);
      }

      p((a = a.apply(e, t || [])).next());
    });
  }

  var Ye = "0c53c51c",
      We = et("0x");
  var Qe = 0;

  function Ze(e, t, n) {
    var a = t.replace("0x", ""),
        r = a.substring(0, 64),
        s = a.substring(64, 128),
        i = function (e) {
      var t = parseInt(e, 16);
      t < 27 && (t += 27);
      if (27 !== t && 28 !== t) throw Error("Invalid signature version \"".concat(e, "\" (parsed: ").concat(t, ")"));
      return t.toString(16);
    }(a.substring(128, 130)),
        o = n.replace("0x", ""),
        p = (o.length / 2).toString(16),
        u = Math.ceil(o.length / 64);

    return ["0x", Ye, tt(e), tt("a0"), r, s, tt(i), tt(p), o.padEnd(64 * u, "0")].join("");
  }

  function Xe(e, t) {
    return Je(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
      var n;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return function (e, t) {
                return nt(e, "eth_getCode", [t.toLowerCase(), "latest"]);
              }(e, t);

            case 2:
              n = _context6.sent;
              return _context6.abrupt("return", !(et(n.toLowerCase()) === We));

            case 4:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));
  }

  function et(e) {
    if (!/^0x[0-9a-f]*$/gi.test(e)) throw new Error("Not a valid hex string \"".concat(e, "\""));
    var t = e.slice(2);

    for (; t.length < 40;) {
      t = "0" + t;
    }

    return "0x" + t;
  }

  function tt(e) {
    return e.toString().replace("0x", "").padStart(64, "0");
  }

  function nt(e, t, n) {
    return Je(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
      var a, r;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              r = {
                jsonrpc: "2.0",
                id: ++Qe,
                method: t,
                params: n
              };

              if (!(void 0 !== e.request)) {
                _context7.next = 7;
                break;
              }

              _context7.next = 4;
              return e.request(r);

            case 4:
              a = _context7.sent;
              _context7.next = 18;
              break;

            case 7:
              if (!(void 0 !== e.sendAsync)) {
                _context7.next = 13;
                break;
              }

              _context7.next = 10;
              return e.sendAsync(r);

            case 10:
              a = _context7.sent;
              _context7.next = 18;
              break;

            case 13:
              _context7.t0 = void 0 !== e.send;

              if (!_context7.t0) {
                _context7.next = 18;
                break;
              }

              _context7.next = 17;
              return e.send(t, n);

            case 17:
              a = _context7.sent;

            case 18:
              if (!a) {
                _context7.next = 20;
                break;
              }

              return _context7.abrupt("return", a.result || a);

            case 20:
              throw new Error("Could not send the transaction correcty. Either the provider does not support the method \"".concat(t, "\" or is missing a proper send/request."));

            case 21:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));
  }

  var at;
  e.ErrorCode = void 0, (at = e.ErrorCode || (e.ErrorCode = {})).INVALID_ADDRESS = "invalid_address", at.CONTRACT_ACCOUNT = "contract_account", at.USER_DENIED = "user_denied", at.UNKNOWN = "unknown";

  var rt = /*#__PURE__*/function (_Error4) {
    _inherits(rt, _Error4);

    function rt(e, t) {
      var _this30;

      _classCallCheck(this, rt);

      _this30 = _possibleConstructorReturn(this, _getPrototypeOf(rt).call(this, e)), _this30.code = t, Object.setPrototypeOf(_assertThisInitialized(_assertThisInitialized(_this30)), rt.prototype);
      return _this30;
    }

    return rt;
  }(_wrapNativeSuper(Error));

  e.DOMAIN_TYPE = n, e.META_TRANSACTION_TYPE = a, e.MetaTransactionError = rt, e.getContract = function (e, t) {
    var n = Ge[e];
    if (!n) throw new Error("Could not get a valid contract for name: ".concat(e));
    if (!n[t]) throw new Error("Could not get a valid contract for ".concat(e, " using chain ").concat(t));
    return n[t];
  }, e.getContractName = function (e) {
    for (var _t27 in Ge) {
      for (var _n36 in Ge[_t27]) {
        if (Ge[_t27][_n36].address.toLowerCase() === e.toLowerCase()) return _t27;
      }
    }

    throw new Error("Could not get a valid contract name for address ".concat(e));
  }, e.isContract = Xe, e.sendMetaTransaction = function (t, r, s, i) {
    var o = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
    return Je(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
      var p, _o4, _u2, _d, _l, _c, _y, _yield$_y$json, _m4;

      return _regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              p = Object.assign(Object.assign({}, {
                serverURL: "https://transactions-api.decentraland.io/v1"
              }), o);

              if (i.address.trim()) {
                _context11.next = 3;
                break;
              }

              throw new rt("The contract address for ".concat(i.name, " is empty. You're probably trying to get a proxy contract. Try adding an address to the result of getContract"), e.ErrorCode.INVALID_ADDRESS);

            case 3:
              _context11.prev = 3;
              _context11.next = 6;
              return function (e) {
                return Je(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
                  var t;
                  return _regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                      switch (_context8.prev = _context8.next) {
                        case 0:
                          t = [];
                          _context8.prev = 1;
                          _context8.next = 4;
                          return nt(e, "eth_requestAccounts", []);

                        case 4:
                          t = _context8.sent;
                          _context8.next = 12;
                          break;

                        case 7:
                          _context8.prev = 7;
                          _context8.t0 = _context8["catch"](1);
                          _context8.next = 11;
                          return nt(e, "eth_accounts", []);

                        case 11:
                          t = _context8.sent;

                        case 12:
                          if (!(0 === t.length)) {
                            _context8.next = 14;
                            break;
                          }

                          throw new Error("Could not find a valid connected account");

                        case 14:
                          return _context8.abrupt("return", t[0]);

                        case 15:
                        case "end":
                          return _context8.stop();
                      }
                    }
                  }, _callee8, null, [[1, 7]]);
                }));
              }(t);

            case 6:
              _o4 = _context11.sent;
              _context11.next = 9;
              return Xe(t, _o4);

            case 9:
              if (!_context11.sent) {
                _context11.next = 11;
                break;
              }

              throw new rt("Contract accounts are not supported", e.ErrorCode.CONTRACT_ACCOUNT);

            case 11:
              _context11.next = 13;
              return function (e, t, n) {
                return Je(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
                  var a;
                  return _regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                      switch (_context9.prev = _context9.next) {
                        case 0:
                          a = tt(t);
                          _context9.t0 = tt;
                          _context9.next = 4;
                          return nt(e, "eth_call", [{
                            data: "0x2d0335ab".concat(a),
                            to: n
                          }, "latest"]);

                        case 4:
                          _context9.t1 = _context9.sent;
                          return _context9.abrupt("return", (0, _context9.t0)(_context9.t1));

                        case 6:
                        case "end":
                          return _context9.stop();
                      }
                    }
                  }, _callee9);
                }));
              }(r, _o4, i.address);

            case 13:
              _u2 = _context11.sent;

              _d = function (e, t) {
                return {
                  name: t.name,
                  version: t.version,
                  verifyingContract: t.address,
                  salt: e
                };
              }(function (e) {
                return "number" == typeof e ? "0x".concat(tt(e.toString(16))) : "0x".concat(tt(e));
              }(i.chainId), i);

              _l = function (e, t, r, s) {
                return {
                  types: {
                    EIP712Domain: n,
                    MetaTransaction: a
                  },
                  domain: s,
                  primaryType: "MetaTransaction",
                  message: {
                    nonce: parseInt(t, 16),
                    from: e,
                    functionSignature: r
                  }
                };
              }(_o4, _u2, s, _d);

              _context11.t0 = Ze;
              _context11.t1 = _o4;
              _context11.next = 20;
              return function (e, t, n) {
                return Je(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
                  return _regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                      switch (_context10.prev = _context10.next) {
                        case 0:
                          return _context10.abrupt("return", nt(e, "eth_signTypedData_v4", [t, n]));

                        case 1:
                        case "end":
                          return _context10.stop();
                      }
                    }
                  }, _callee10);
                }));
              }(t, _o4, JSON.stringify(_l));

            case 20:
              _context11.t2 = _context11.sent;
              _context11.t3 = s;
              _c = (0, _context11.t0)(_context11.t1, _context11.t2, _context11.t3);
              _context11.next = 25;
              return fetch("".concat(p.serverURL, "/transactions"), {
                headers: {
                  "Content-Type": "application/json"
                },
                body: JSON.stringify({
                  transactionData: {
                    from: _o4,
                    params: [i.address, _c]
                  }
                }),
                method: "POST"
              });

            case 25:
              _y = _context11.sent;

              if (_y.ok) {
                _context11.next = 28;
                break;
              }

              throw new Error(_y.statusText);

            case 28:
              _context11.next = 30;
              return _y.json();

            case 30:
              _yield$_y$json = _context11.sent;
              _m4 = _yield$_y$json.txHash;
              return _context11.abrupt("return", _m4);

            case 35:
              _context11.prev = 35;
              _context11.t4 = _context11["catch"](3);

              if (!(-1 !== _context11.t4.message.indexOf("User denied message signature"))) {
                _context11.next = 39;
                break;
              }

              throw new rt(_context11.t4.message, e.ErrorCode.USER_DENIED);

            case 39:
              throw _context11.t4 instanceof rt ? _context11.t4 : (console.warn("An error occurred trying to send the meta transaction. Error:", _context11.t4.message), new rt(_context11.t4.message, e.ErrorCode.UNKNOWN));

            case 40:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, null, [[3, 35]]);
    }));
  }, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});